(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["spices-pepper"] = factory(require("vue"));
	else
		root["spices-pepper"] = factory(root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__8bbf__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "1c25");
/******/ })
/************************************************************************/
/******/ ({

/***/ "08d2":
/***/ (function(module) {

module.exports = JSON.parse("{\"author\":\"Alexandre <alexandre@infinity-mobile.io>\",\"browserslist\":[\"> 1%\",\"last 2 versions\",\"not dead\"],\"category\":\"Data\",\"description\":\"Table component with pagination and sorting functionality.\",\"dependencies\":{\"@pepper/actions-button\":\"^1.4.5\",\"@pepper/data-pagination\":\"^1.3.12\",\"@pepper/forms-checkbox\":\"^1.6.5\",\"@pepper/forms-input\":\"^1.7.7\",\"@pepper/forms-select\":\"^1.5.9\",\"@pepper/popins-dropdown\":\"^1.3.5\",\"@pepper/utils\":\"^1.1.2\"},\"directories\":{\"src\":\"src\"},\"displayName\":\"Table\",\"files\":[\"src\"],\"homepage\":\"http://pepper.infinity-commerce.io/components/data/table\",\"license\":\"UNLICENSED\",\"main\":\"src/index.js\",\"name\":\"@pepper/data-table\",\"publishConfig\":{\"access\":\"public\",\"registry\":\"https://npm.infinity-commerce.io/\"},\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@bitbucket.org:infinity-mobile/pepper.git\"},\"samples\":{\"default\":{\"name\":\"Default\",\"props\":{},\"slots\":{\"default\":\"Label\"}}},\"scripts\":{\"bundle\":\"\",\"bundle:wc\":\"vue-cli-service build --target wc --name data-table ./src/table.vue\",\"bundle:lib\":\"vue-cli-service build --target lib --name pepper-data-table ./src/index.js\"},\"slots\":{\"default\":{}},\"version\":\"1.0.14\",\"gitHead\":\"837ba81c27d2379bdf07d4ba95dcf0dd35db1333\"}");

/***/ }),

/***/ "0993":
/***/ (function(module) {

module.exports = JSON.parse("{\"author\":\"Alexandre <alexandre@infinity-mobile.io>\",\"browserslist\":[\"> 1%\",\"last 2 versions\",\"not dead\"],\"category\":\"Popins\",\"description\":\"Covers the underlying UI for a layered component.\",\"dependencies\":{\"@pepper/popins-popin\":\"^1.3.2\"},\"devDependencies\":{\"@vue/cli-service\":\"^4.1.1\",\"vue\":\"^2.6.10\"},\"directories\":{\"src\":\"src\"},\"displayName\":\"Blanket\",\"events\":{},\"files\":[\"src\"],\"homepage\":\"http://pepper.infinity-commerce.io/components/popins/blanket\",\"license\":\"UNLICENSED\",\"main\":\"src/index.js\",\"name\":\"@pepper/popins-blanket\",\"publishConfig\":{\"access\":\"public\",\"registry\":\"https://npm.infinity-commerce.io/\"},\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@bitbucket.org:infinity-mobile/pepper.git\"},\"samples\":{\"default\":{\"key\":\"default\",\"name\":\"Default\",\"slots\":{\"default\":\"Label\"}}},\"scripts\":{\"bundle\":\"\",\"bundle:wc\":\"vue-cli-service build --target wc --name popins-blanket ./src/blanket.vue\",\"bundle:lib\":\"vue-cli-service build --target lib --name pepper-popins-blanket ./src/index.js\"},\"slots\":{},\"status\":\"draft\",\"version\":\"1.3.2\",\"gitHead\":\"14531a2a18d9b6dc6dc42232a03f11c3f7d5e9d2\"}");

/***/ }),

/***/ "124c":
/***/ (function(module) {

module.exports = JSON.parse("{\"author\":\"Alexandre <alexandre@infinity-mobile.io>\",\"browserslist\":[\"> 1%\",\"last 2 versions\",\"not dead\"],\"category\":\"Popins\",\"dependencies\":{\"@pepper/actions-button\":\"^1.4.5\",\"@pepper/popins-blanket\":\"^1.3.2\",\"@pepper/popins-popin\":\"^1.3.2\",\"@pepper/utils\":\"^1.1.2\"},\"description\":\"Informs the users while preserving the current page state. Displays content in a layer that sits above the rest of the page content. Users won't be able to interact with the page until the dialog is closed.\",\"directories\":{\"src\":\"src\"},\"displayName\":\"Modal\",\"events\":{},\"files\":[\"src\"],\"homepage\":\"http://pepper.infinity-commerce.io/components/popins/modal\",\"license\":\"UNLICENSED\",\"main\":\"src/index.js\",\"name\":\"@pepper/popins-modal\",\"publishConfig\":{\"access\":\"public\",\"registry\":\"https://npm.infinity-commerce.io/\"},\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@bitbucket.org:infinity-mobile/pepper.git\"},\"samples\":{\"default\":{\"key\":\"default\",\"name\":\"Default\",\"slots\":{\"default\":\"Label\"}}},\"scripts\":{\"bundle\":\"\",\"bundle:wc\":\"vue-cli-service build --target wc --name popins-modal ./src/modal.vue\",\"bundle:lib\":\"vue-cli-service build --target lib --name pepper-popins-modal ./src/index.js\"},\"slots\":{},\"status\":\"draft\",\"version\":\"1.2.5\"}");

/***/ }),

/***/ "1c25":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "version", function() { return /* reexport */ pepper_pepper_package["a" /* version */]; });
__webpack_require__.d(__webpack_exports__, "Action", function() { return /* reexport */ Action; });
__webpack_require__.d(__webpack_exports__, "Appearance", function() { return /* reexport */ Appearance; });
__webpack_require__.d(__webpack_exports__, "Direction", function() { return /* reexport */ Direction; });
__webpack_require__.d(__webpack_exports__, "Hue", function() { return /* reexport */ Hue; });
__webpack_require__.d(__webpack_exports__, "Intent", function() { return /* reexport */ Intent; });
__webpack_require__.d(__webpack_exports__, "KeyCode", function() { return /* reexport */ KeyCode; });
__webpack_require__.d(__webpack_exports__, "Layout", function() { return /* reexport */ Layout; });
__webpack_require__.d(__webpack_exports__, "MimeTypeCategory", function() { return /* reexport */ MimeTypeCategory; });
__webpack_require__.d(__webpack_exports__, "MimeType", function() { return /* reexport */ MimeType; });
__webpack_require__.d(__webpack_exports__, "Operator", function() { return /* reexport */ Operator; });
__webpack_require__.d(__webpack_exports__, "Position", function() { return /* reexport */ Position; });
__webpack_require__.d(__webpack_exports__, "Priority", function() { return /* reexport */ Priority; });
__webpack_require__.d(__webpack_exports__, "Selection", function() { return /* reexport */ Selection; });
__webpack_require__.d(__webpack_exports__, "Size", function() { return /* reexport */ Size; });
__webpack_require__.d(__webpack_exports__, "Sort", function() { return /* reexport */ Sort; });
__webpack_require__.d(__webpack_exports__, "PepperFile", function() { return /* reexport */ file_PepperFile; });
__webpack_require__.d(__webpack_exports__, "PepperSlot", function() { return /* reexport */ slot; });
__webpack_require__.d(__webpack_exports__, "isString", function() { return /* reexport */ isString; });
__webpack_require__.d(__webpack_exports__, "Constants", function() { return /* reexport */ src_namespaceObject; });
__webpack_require__.d(__webpack_exports__, "Autofocus", function() { return /* reexport */ autofocus; });
__webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return /* reexport */ clickoutside; });
__webpack_require__.d(__webpack_exports__, "ActionsButton", function() { return /* reexport */ src_button; });
__webpack_require__.d(__webpack_exports__, "ChartsStack", function() { return /* reexport */ stack; });
__webpack_require__.d(__webpack_exports__, "DataBadge", function() { return /* reexport */ badge; });
__webpack_require__.d(__webpack_exports__, "DataEmpty", function() { return /* reexport */ empty; });
__webpack_require__.d(__webpack_exports__, "DataFilter", function() { return /* reexport */ filter; });
__webpack_require__.d(__webpack_exports__, "DataPagination", function() { return /* reexport */ pagination; });
__webpack_require__.d(__webpack_exports__, "DataTable", function() { return /* reexport */ table; });
__webpack_require__.d(__webpack_exports__, "DataTag", function() { return /* reexport */ tag; });
__webpack_require__.d(__webpack_exports__, "FormsAutocomplete", function() { return /* reexport */ autocomplete; });
__webpack_require__.d(__webpack_exports__, "FormsCheckbox", function() { return /* reexport */ src_checkbox; });
__webpack_require__.d(__webpack_exports__, "FormsChoice", function() { return /* reexport */ choice; });
__webpack_require__.d(__webpack_exports__, "FormsControl", function() { return /* reexport */ control; });
__webpack_require__.d(__webpack_exports__, "FormsInput", function() { return /* reexport */ input; });
__webpack_require__.d(__webpack_exports__, "FormsIterable", function() { return /* reexport */ iterable; });
__webpack_require__.d(__webpack_exports__, "FormsList", function() { return /* reexport */ src_list; });
__webpack_require__.d(__webpack_exports__, "FormsFile", function() { return /* reexport */ src_component; });
__webpack_require__.d(__webpack_exports__, "FormsLabel", function() { return /* reexport */ label; });
__webpack_require__.d(__webpack_exports__, "FormsRadio", function() { return /* reexport */ src_radio; });
__webpack_require__.d(__webpack_exports__, "FormsSelect", function() { return /* reexport */ src_select; });
__webpack_require__.d(__webpack_exports__, "FormsTextarea", function() { return /* reexport */ src_textarea; });
__webpack_require__.d(__webpack_exports__, "NavigationsTabs", function() { return /* reexport */ tabs; });
__webpack_require__.d(__webpack_exports__, "NavigationsTabsItem", function() { return /* reexport */ item; });
__webpack_require__.d(__webpack_exports__, "PopinsPopin", function() { return /* reexport */ popin; });
__webpack_require__.d(__webpack_exports__, "PopinsBus", function() { return /* reexport */ bus; });
__webpack_require__.d(__webpack_exports__, "PopinsBlanket", function() { return /* reexport */ blanket; });
__webpack_require__.d(__webpack_exports__, "PopinsDropdown", function() { return /* reexport */ dropdown; });
__webpack_require__.d(__webpack_exports__, "PopinsListDropdown", function() { return /* reexport */ list; });
__webpack_require__.d(__webpack_exports__, "PopinsModal", function() { return /* reexport */ modal; });
__webpack_require__.d(__webpack_exports__, "NotificationBus", function() { return /* reexport */ src_bus; });
__webpack_require__.d(__webpack_exports__, "TransitionsFade", function() { return /* reexport */ fade; });
__webpack_require__.d(__webpack_exports__, "UiIcon", function() { return /* reexport */ icon; });
__webpack_require__.d(__webpack_exports__, "UiLoader", function() { return /* reexport */ loader; });
__webpack_require__.d(__webpack_exports__, "components", function() { return /* reexport */ components; });

// NAMESPACE OBJECT: ../pepper-utils/src/index.js
var src_namespaceObject = {};
__webpack_require__.r(src_namespaceObject);
__webpack_require__.d(src_namespaceObject, "Action", function() { return Action; });
__webpack_require__.d(src_namespaceObject, "Appearance", function() { return Appearance; });
__webpack_require__.d(src_namespaceObject, "Direction", function() { return Direction; });
__webpack_require__.d(src_namespaceObject, "Hue", function() { return Hue; });
__webpack_require__.d(src_namespaceObject, "Intent", function() { return Intent; });
__webpack_require__.d(src_namespaceObject, "KeyCode", function() { return KeyCode; });
__webpack_require__.d(src_namespaceObject, "Layout", function() { return Layout; });
__webpack_require__.d(src_namespaceObject, "MimeTypeCategory", function() { return MimeTypeCategory; });
__webpack_require__.d(src_namespaceObject, "MimeType", function() { return MimeType; });
__webpack_require__.d(src_namespaceObject, "Operator", function() { return Operator; });
__webpack_require__.d(src_namespaceObject, "Position", function() { return Position; });
__webpack_require__.d(src_namespaceObject, "Priority", function() { return Priority; });
__webpack_require__.d(src_namespaceObject, "Selection", function() { return Selection; });
__webpack_require__.d(src_namespaceObject, "Size", function() { return Size; });
__webpack_require__.d(src_namespaceObject, "Sort", function() { return Sort; });
__webpack_require__.d(src_namespaceObject, "PepperFile", function() { return file_PepperFile; });
__webpack_require__.d(src_namespaceObject, "PepperSlot", function() { return slot; });
__webpack_require__.d(src_namespaceObject, "isString", function() { return isString; });

// NAMESPACE OBJECT: ../pepper-pepper/src/components/index.js
var components_namespaceObject = {};
__webpack_require__.r(components_namespaceObject);
__webpack_require__.d(components_namespaceObject, "ActionsButton", function() { return src_button; });
__webpack_require__.d(components_namespaceObject, "ChartsStack", function() { return stack; });
__webpack_require__.d(components_namespaceObject, "DataBadge", function() { return badge; });
__webpack_require__.d(components_namespaceObject, "DataEmpty", function() { return empty; });
__webpack_require__.d(components_namespaceObject, "DataFilter", function() { return filter; });
__webpack_require__.d(components_namespaceObject, "DataPagination", function() { return pagination; });
__webpack_require__.d(components_namespaceObject, "DataTable", function() { return table; });
__webpack_require__.d(components_namespaceObject, "DataTag", function() { return tag; });
__webpack_require__.d(components_namespaceObject, "FormsAutocomplete", function() { return autocomplete; });
__webpack_require__.d(components_namespaceObject, "FormsCheckbox", function() { return src_checkbox; });
__webpack_require__.d(components_namespaceObject, "FormsChoice", function() { return choice; });
__webpack_require__.d(components_namespaceObject, "FormsControl", function() { return control; });
__webpack_require__.d(components_namespaceObject, "FormsInput", function() { return input; });
__webpack_require__.d(components_namespaceObject, "FormsIterable", function() { return iterable; });
__webpack_require__.d(components_namespaceObject, "FormsList", function() { return src_list; });
__webpack_require__.d(components_namespaceObject, "FormsFile", function() { return src_component; });
__webpack_require__.d(components_namespaceObject, "FormsLabel", function() { return label; });
__webpack_require__.d(components_namespaceObject, "FormsRadio", function() { return src_radio; });
__webpack_require__.d(components_namespaceObject, "FormsSelect", function() { return src_select; });
__webpack_require__.d(components_namespaceObject, "FormsTextarea", function() { return src_textarea; });
__webpack_require__.d(components_namespaceObject, "NavigationsTabs", function() { return tabs; });
__webpack_require__.d(components_namespaceObject, "NavigationsTabsItem", function() { return item; });
__webpack_require__.d(components_namespaceObject, "PopinsPopin", function() { return popin; });
__webpack_require__.d(components_namespaceObject, "PopinsBus", function() { return bus; });
__webpack_require__.d(components_namespaceObject, "PopinsBlanket", function() { return blanket; });
__webpack_require__.d(components_namespaceObject, "PopinsDropdown", function() { return dropdown; });
__webpack_require__.d(components_namespaceObject, "PopinsListDropdown", function() { return list; });
__webpack_require__.d(components_namespaceObject, "PopinsModal", function() { return modal; });
__webpack_require__.d(components_namespaceObject, "NotificationBus", function() { return src_bus; });
__webpack_require__.d(components_namespaceObject, "TransitionsFade", function() { return fade; });
__webpack_require__.d(components_namespaceObject, "UiIcon", function() { return icon; });
__webpack_require__.d(components_namespaceObject, "UiLoader", function() { return loader; });

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("405b")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var setPublicPath_src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (setPublicPath_src) {
    __webpack_require__.p = setPublicPath_src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ../pepper-pepper/package.json
var pepper_pepper_package = __webpack_require__("e687");

// CONCATENATED MODULE: ../pepper-utils/src/constants/action.js
const Action = {}
Action.SINGLE = 0b00001; // 1
Action.GLOBAL = 0b00010; // 2
Action.SOME   = 0b00100; // 4
Action.PAGE   = 0b01000; // 8
Action.PAGES  = 0b10000; // 16

Action.SUM = Action.SINGLE + Action.GLOBAL + Action.SOME + Action.PAGE + Action.PAGES;
Action.ALL = [ 
  Action.SINGLE, 
  Action.GLOBAL, 
  Action.SOME, 
  Action.PAGE, 
  Action.PAGES 
]

// CONCATENATED MODULE: ../pepper-utils/src/constants/appearance.js
const Appearance = {};

Appearance.DEFAULT = 'default';
Appearance.LINK = 'link';
Appearance.NONE = 'none';
Appearance.PRIMARY = 'primary';
Appearance.SUBTLE = 'subtle';
Appearance.TOGGLE = 'toggle';

Appearance.ALL = [
  Appearance.DEFAULT,
  Appearance.LINK,
  Appearance.NONE,
  Appearance.PRIMARY,
  Appearance.SUBTLE,
  Appearance.TOGGLE,
];

// CONCATENATED MODULE: ../pepper-utils/src/constants/direction.js
const Direction = {};

Direction.DOWN = 'down';
Direction.LEFT = 'left';
Direction.NONE = 'none';
Direction.RIGHT = 'right';
Direction.UP = 'up';

Direction.ALL = [
  Direction.DOWN,
  Direction.LEFT,
  Direction.NONE,
  Direction.RIGHT,
  Direction.UP,
];

// CONCATENATED MODULE: ../pepper-utils/src/constants/hue.js
const Hue = {};

Hue.LIGHT = 'light';
Hue.DARK = 'dark';
Hue.RED = 'red';
Hue.ORANGE = 'orange';
Hue.YELLOW = 'yellow';
Hue.GREEN = 'green';
Hue.TEAL = 'teal';
Hue.BLUE = 'blue';

Hue.ALL = [
  Hue.LIGHT,
  Hue.DARK,
  Hue.RED,
  Hue.ORANGE,
  Hue.YELLOW,
  Hue.GREEN,
  Hue.TEAL,
  Hue.BLUE
];

// CONCATENATED MODULE: ../pepper-utils/src/constants/intent.js
const Intent = {};

Intent.DANGER = 'danger';
Intent.DEFAULT = 'default';
Intent.SUCCESS = 'success';
Intent.WARNING = 'warning';

Intent.ALL = [
  Intent.DANGER,
  Intent.DEFAULT,
  Intent.SUCCESS,
  Intent.WARNING,
];

// CONCATENATED MODULE: ../pepper-utils/src/constants/keycode.js
const KeyCode = {}

KeyCode.BACKSPACE = 8
KeyCode.TAB = 9
KeyCode.ENTER = 13
KeyCode.SHIFT = 16
KeyCode.CTRL = 17
KeyCode.ALT = 18
KeyCode.PAUSE = 19
KeyCode.CAPSLOCK = 20
KeyCode.ESCAPE = 27
KeyCode.SPACE = 32
KeyCode.PAGEUP = 33
KeyCode.PAGEDOWN = 34
KeyCode.END = 35
KeyCode.HOME = 36
KeyCode.LEFT_ARROW = 37
KeyCode.UP_ARROW = 38
KeyCode.RIGHT_ARROW = 39
KeyCode.DOWN_ARROW = 40
KeyCode.INSERT = 45
KeyCode.DELETE = 46
KeyCode.DIGIT_0 = 48
KeyCode.DIGIT_1 = 49
KeyCode.DIGIT_2 = 50
KeyCode.DIGIT_3 = 51
KeyCode.DIGIT_4 = 52
KeyCode.DIGIT_5 = 53
KeyCode.DIGIT_6 = 54
KeyCode.DIGIT_7 = 55
KeyCode.DIGIT_8 = 56
KeyCode.DIGIT_9 = 57
KeyCode.KEY_A = 65
KeyCode.KEY_B = 66
KeyCode.KEY_C = 67
KeyCode.KEY_D = 68
KeyCode.KEY_E = 69
KeyCode.KEY_F = 70
KeyCode.KEY_G = 71
KeyCode.KEY_H = 72
KeyCode.KEY_I = 73
KeyCode.KEY_J = 74
KeyCode.KEY_K = 75
KeyCode.KEY_L = 76
KeyCode.KEY_M = 77
KeyCode.KEY_N = 78
KeyCode.KEY_O = 79
KeyCode.KEY_P = 80
KeyCode.KEY_Q = 81
KeyCode.KEY_R = 82
KeyCode.KEY_S = 83
KeyCode.KEY_T = 84
KeyCode.KEY_U = 85
KeyCode.KEY_V = 86
KeyCode.KEY_W = 87
KeyCode.KEY_X = 88
KeyCode.KEY_Y = 89
KeyCode.KEY_Z = 90
KeyCode.LEFT_WINDOW = 91
KeyCode.RIGHT_WINDOW = 92
KeyCode.SELECT = 93
KeyCode.NUMPAD_0 = 96
KeyCode.NUMPAD_1 = 97
KeyCode.NUMPAD_2 = 98
KeyCode.NUMPAD_3 = 99
KeyCode.NUMPAD_4 = 100
KeyCode.NUMPAD_5 = 101
KeyCode.NUMPAD_6 = 102
KeyCode.NUMPAD_7 = 103
KeyCode.NUMPAD_8 = 104
KeyCode.NUMPAD_9 = 105
KeyCode.MULTIPLY = 106
KeyCode.ADD = 107
KeyCode.SUBTRACT = 109
KeyCode.DECIMAL_POINT = 110
KeyCode.DIVIDE = 111
KeyCode.F1 = 112
KeyCode.F2 = 113
KeyCode.F3 = 114
KeyCode.F4 = 115
KeyCode.F5 = 116
KeyCode.F6 = 117
KeyCode.F7 = 118
KeyCode.F8 = 119
KeyCode.F9 = 120
KeyCode.F10 = 121
KeyCode.F11 = 122
KeyCode.F12 = 123
KeyCode.NUM_LOCK = 144
KeyCode.SCROLL_LOCK = 145



// CONCATENATED MODULE: ../pepper-utils/src/constants/layout.js
const Layout = {};

Layout.BLOCK = 'block';
Layout.INLINE = 'inline';
Layout.INLINE_REVERSE = 'inline-reverse';

Layout.LTR = 'ltr';
Layout.RTL = 'rtl';
Layout.TTB = 'ttb';
Layout.BTT = 'btt';

Layout.ALL = [
  Layout.BLOCK,
  Layout.INLINE,
  Layout.INLINE_REVERSE,

  Layout.LTR,
  Layout.RTL,
  Layout.TTB,
  Layout.BTT
];

// CONCATENATED MODULE: ../pepper-utils/src/constants/mimetype.js
class MimeTypeEntry{
  constructor(extension, category, value){
    this.extension = extension;
    this.category = category;
    this.value = value;
  }
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////
//
//  MimeType Category
//
///////////////////////////////////////////////////////////////////////////////////////////////////////////
const MimeTypeCategory = {};
MimeTypeCategory.ARCHIVE  = 'archive';
MimeTypeCategory.AUDIO    = 'audio';
MimeTypeCategory.CODE     = 'code';
MimeTypeCategory.DOCUMENT = 'document';
MimeTypeCategory.IMAGE    = 'image';
MimeTypeCategory.VIDEO    = 'video';
MimeTypeCategory.ALL = [
  MimeTypeCategory.ARCHIVE,
  MimeTypeCategory.AUDIO,
  MimeTypeCategory.CODE,
  MimeTypeCategory.DOCUMENT,
  MimeTypeCategory.IMAGE,
  MimeTypeCategory.VIDEO
];

///////////////////////////////////////////////////////////////////////////////////////////////////////////
//
//  MimeTypes
//
///////////////////////////////////////////////////////////////////////////////////////////////////////////
const MimeType = {};
MimeType.AAC =    new MimeTypeEntry('.aac',  MimeTypeCategory.AUDIO, 'audio/aac'),
MimeType.ABW =    new MimeTypeEntry('.abw',  MimeTypeCategory.DOCUMENT, 'application/x-abiword'),
MimeType.ARC =    new MimeTypeEntry('.arc',  MimeTypeCategory.ARCHIVE, 'application/octet-stream'),
MimeType.AVI =    new MimeTypeEntry('.avi',  MimeTypeCategory.VIDEO, 'video/x-msvideo'),
MimeType.AZW =    new MimeTypeEntry('.azw',  MimeTypeCategory.DOCUMENT, 'application/vnd.amazon.ebook'),
MimeType.BIN =    new MimeTypeEntry('.bin',  MimeTypeCategory.DOCUMENT, 'application/octet-stream'),
MimeType.BZ =     new MimeTypeEntry('.bz',   MimeTypeCategory.ARCHIVE, 'application/x-bzip'),
MimeType.BZ2 =    new MimeTypeEntry('.bz2',  MimeTypeCategory.ARCHIVE, 'application/x-bzip2'),
MimeType.CSH =    new MimeTypeEntry('.csh',  MimeTypeCategory.CODE, 'application/x-csh'),
MimeType.CSS =    new MimeTypeEntry('.css',  MimeTypeCategory.CODE, 'text/css'),
MimeType.CSV =    new MimeTypeEntry('.csv',  MimeTypeCategory.DOCUMENT, 'text/csv'),
MimeType.DOC =    new MimeTypeEntry('.doc',  MimeTypeCategory.DOCUMENT, 'application/msword'),
MimeType.DOCX =   new MimeTypeEntry('.docx', MimeTypeCategory.DOCUMENT, 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'),
MimeType.EOT =    new MimeTypeEntry('.eot',  MimeTypeCategory.DOCUMENT, 'application/vnd.ms-fontobject'),
MimeType.EPUB =   new MimeTypeEntry('.epub', MimeTypeCategory.DOCUMENT, 'application/epub+zip'),
MimeType.GIF =    new MimeTypeEntry('.gif',  MimeTypeCategory.IMAGE, 'image/gif'),
MimeType.HTM =    new MimeTypeEntry('.htm',  MimeTypeCategory.DOCUMENT, 'text/html'),
MimeType.HTML =   new MimeTypeEntry('.html', MimeTypeCategory.DOCUMENT, 'text/html'),
MimeType.ICO =    new MimeTypeEntry('.ico',  MimeTypeCategory.IMAGE, 'image/x-icon'),
MimeType.ICS =    new MimeTypeEntry('.ics',  MimeTypeCategory.DOCUMENT, 'text/calendar'),
MimeType.JAR =    new MimeTypeEntry('.jar',  MimeTypeCategory.CODE, 'application/java-archive'),
MimeType.JPEG =   new MimeTypeEntry('.jpeg', MimeTypeCategory.IMAGE, 'image/jpeg'),
MimeType.JPG =    new MimeTypeEntry('.jpg',  MimeTypeCategory.IMAGE, 'image/jpeg'),
MimeType.JS =     new MimeTypeEntry('.js',   MimeTypeCategory.CODE, 'application/javascript'),
MimeType.JSON =   new MimeTypeEntry('.json', MimeTypeCategory.CODE, 'application/json'),
MimeType.MID =    new MimeTypeEntry('.mid',  MimeTypeCategory.AUDIO, 'audio/midi'),
MimeType.MIDI =   new MimeTypeEntry('.midi', MimeTypeCategory.AUDIO, 'audio/midi'),
MimeType.MPEG =   new MimeTypeEntry('.mpeg', MimeTypeCategory.VIDEO, 'video/mpeg'),
MimeType.MPKG =   new MimeTypeEntry('.mpkg', MimeTypeCategory.DOCUMENT, 'application/vnd.apple.installer+xml'),
MimeType.ODP =    new MimeTypeEntry('.odp',  MimeTypeCategory.DOCUMENT, 'application/vnd.oasis.opendocument.presentation'),
MimeType.ODS =    new MimeTypeEntry('.ods',  MimeTypeCategory.DOCUMENT, 'application/vnd.oasis.opendocument.spreadsheet'),
MimeType.ODT =    new MimeTypeEntry('.odt',  MimeTypeCategory.DOCUMENT, 'application/vnd.oasis.opendocument.text'),
MimeType.OGA =    new MimeTypeEntry('.oga',  MimeTypeCategory.AUDIO, 'audio/ogg'),
MimeType.OGV =    new MimeTypeEntry('.ogv',  MimeTypeCategory.VIDEO, 'video/ogg'),
MimeType.OGX =    new MimeTypeEntry('.ogx',  MimeTypeCategory.DOCUMENT, 'application/ogg'),
MimeType.OTF =    new MimeTypeEntry('.otf',  MimeTypeCategory.DOCUMENT, 'font/otf'),
MimeType.PNG =    new MimeTypeEntry('.png',  MimeTypeCategory.IMAGE, 'image/png'),
MimeType.PDF =    new MimeTypeEntry('.pdf',  MimeTypeCategory.DOCUMENT, 'application/pdf'),
MimeType.PPT =    new MimeTypeEntry('.ppt',  MimeTypeCategory.DOCUMENT, 'application/vnd.ms-powerpoint'),
MimeType.PPTX =   new MimeTypeEntry('.pptx', MimeTypeCategory.DOCUMENT, 'application/vnd.openxmlformats-officedocument.presentationml.presentation'),
MimeType.RAR =    new MimeTypeEntry('.rar',  MimeTypeCategory.ARCHIVE, 'application/x-rar-compressed'),
MimeType.RTF =    new MimeTypeEntry('.rtf',  MimeTypeCategory.DOCUMENT, 'application/rtf'),
MimeType.SH =     new MimeTypeEntry('.sh',   MimeTypeCategory.CODE, 'application/x-sh'),
MimeType.SVG =    new MimeTypeEntry('.svg',  MimeTypeCategory.IMAGE, 'image/svg+xml'),
MimeType.SWF =    new MimeTypeEntry('.swf',  MimeTypeCategory.CODE, 'application/x-shockwave-flash'),
MimeType.TAR =    new MimeTypeEntry('.tar',  MimeTypeCategory.ARCHIVE, 'application/x-tar'),
MimeType.TIF =    new MimeTypeEntry('.tif',  MimeTypeCategory.IMAGE, 'image/tiff'),
MimeType.TIFF =   new MimeTypeEntry('.tiff', MimeTypeCategory.IMAGE, 'image/tiff'),
MimeType.TS =     new MimeTypeEntry('.ts',   MimeTypeCategory.CODE, 'application/typescript'),
MimeType.TTF =    new MimeTypeEntry('.ttf',  MimeTypeCategory.DOCUMENT, 'font/ttf'),
MimeType.VSD =    new MimeTypeEntry('.vsd',  MimeTypeCategory.DOCUMENT, 'application/vnd.visio'),
MimeType.WAV =    new MimeTypeEntry('.wav',  MimeTypeCategory.AUDIO, 'audio/x-wav'),
MimeType.WEBA =   new MimeTypeEntry('.weba', MimeTypeCategory.AUDIO, 'audio/webm'),
MimeType.WEBM =   new MimeTypeEntry('.webm', MimeTypeCategory.VIDEO, 'video/webm'),
MimeType.WEBP =   new MimeTypeEntry('.webp', MimeTypeCategory.IMAGE, 'image/webp'),
MimeType.WOFF =   new MimeTypeEntry('.woff', MimeTypeCategory.DOCUMENT, 'font/woff'),
MimeType.WOFF2 =  new MimeTypeEntry('.woff2',MimeTypeCategory.DOCUMENT, 'font/woff2'),
MimeType.XHTML =  new MimeTypeEntry('.xhtml',MimeTypeCategory.DOCUMENT, 'application/xhtml+xml'),
MimeType.XLS =    new MimeTypeEntry('.xls',  MimeTypeCategory.DOCUMENT, 'application/vnd.ms-excel'),
MimeType.XLSX =   new MimeTypeEntry('.xlsx', MimeTypeCategory.DOCUMENT, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'),
MimeType.XML =    new MimeTypeEntry('.xml',  MimeTypeCategory.CODE, 'application/xml'),
MimeType.XUL =    new MimeTypeEntry('.xul',  MimeTypeCategory.CODE, 'application/vnd.mozilla.xul+xml'),
MimeType.ZIP =    new MimeTypeEntry('.zip',  MimeTypeCategory.ARCHIVE, 'application/zip'),
MimeType._3GPA =  new MimeTypeEntry('.3gp',  MimeTypeCategory.AUDIO, 'audio/3gpp'),
MimeType._3GPV =  new MimeTypeEntry('.3gp',  MimeTypeCategory.VIDEO, 'video/3gpp'),
MimeType._3G2A =  new MimeTypeEntry('.3g2',  MimeTypeCategory.AUDIO, 'audio/3gpp2'),
MimeType._3G2V =  new MimeTypeEntry('.3g2',  MimeTypeCategory.VIDEO, 'video/3gpp2'),
MimeType._7Z =    new MimeTypeEntry('.7z',   MimeTypeCategory.ARCHIVE, 'application/x-7z-compressed'),

MimeType.ALL = [
  MimeType.AAC,
  MimeType.ABW,
  MimeType.ARC,
  MimeType.AVI,
  MimeType.AZW,
  MimeType.BIN,
  MimeType.BZ,
  MimeType.BZ2,
  MimeType.CSH,
  MimeType.CSS,
  MimeType.CSV,
  MimeType.DOC,
  MimeType.DOCX,
  MimeType.EOT,
  MimeType.EPUB,
  MimeType.GIF,
  MimeType.HTM,
  MimeType.HTML,
  MimeType.ICO,
  MimeType.ICS,
  MimeType.JAR,
  MimeType.JPEG,
  MimeType.JPG,
  MimeType.JS,
  MimeType.JSON,
  MimeType.MID,
  MimeType.MIDI,
  MimeType.MPEG,
  MimeType.MPKG,
  MimeType.ODP,
  MimeType.ODS,
  MimeType.ODT,
  MimeType.OGA,
  MimeType.OGV,
  MimeType.OGX,
  MimeType.OTF,
  MimeType.PNG,
  MimeType.PDF,
  MimeType.PPT,
  MimeType.PPTX,
  MimeType.RAR,
  MimeType.RTF,
  MimeType.SH,
  MimeType.SVG,
  MimeType.SWF,
  MimeType.TAR,
  MimeType.TIF,
  MimeType.TIFF,
  MimeType.TS,
  MimeType.TTF,
  MimeType.VSD,
  MimeType.WAV,
  MimeType.WEBA,
  MimeType.WEBM,
  MimeType.WEBP,
  MimeType.WOFF,
  MimeType.WOFF2,
  MimeType.XHTML,
  MimeType.XLS,
  MimeType.XLSX,
  MimeType.XML,
  MimeType.XUL,
  MimeType.ZIP,
  MimeType._3GPA,
  MimeType._3GPV,
  MimeType._3G2A,
  MimeType._3G2V,
  MimeType._7Z
];
MimeType.EXTENSIONS = MimeType.ALL.map( m => m.extension );

// CONCATENATED MODULE: ../pepper-utils/src/constants/operator.js
const Operator = {}

Operator.EQUAL = '='
Operator.GREATER = '>'
Operator.EQUALS_OR_GREATER = '≥'
Operator.LIKE = '≈'
Operator.LESS = '<'
Operator.EQUALS_OR_LESS = '≤'
Operator.NOT_EQUALS = '≠'

Operator.ALL = [Operator.EQUAL, Operator.GREATER, Operator.EQUALS_OR_GREATER, Operator.LIKE, Operator.LESS, Operator.EQUALS_OR_LESS, Operator.NOT_EQUALS]

// CONCATENATED MODULE: ../pepper-utils/src/constants/position.js
const Position = {}

Position.TOP_LEFT = 'top-left';
Position.TOP_CENTER = 'top-center';
Position.TOP_RIGHT = 'top-right';
Position.MIDDLE_LEFT = 'middle-left';
Position.MIDDLE_CENTER = 'middle-center';
Position.MIDDLE_RIGHT = 'middle-right';
Position.BOTTOM_LEFT = 'bottom-left';
Position.BOTTOM_CENTER = 'bottom-center';
Position.BOTTOM_RIGHT = 'bottom-right';

Position.ALL = [
  Position.TOP_LEFT,
  Position.TOP_CENTER,
  Position.TOP_RIGHT,
  Position.MIDDLE_LEFT,
  Position.MIDDLE_CENTER,
  Position.MIDDLE_RIGHT,
  Position.BOTTOM_LEFT,
  Position.BOTTOM_CENTER,
  Position.BOTTOM_RIGHT,
]

// CONCATENATED MODULE: ../pepper-utils/src/constants/priority.js
const Priority = {};

Priority.LOWEST = 'lowest';
Priority.LOW = 'low';
Priority.MEDIUM = 'medium';
Priority.HIGH = 'high';
Priority.HIGHEST = 'highest';

Priority.ALL = [
  Priority.LOWEST, 
  Priority.LOW, 
  Priority.MEDIUM, 
  Priority.HIGH, 
  Priority.HIGHEST
]

// CONCATENATED MODULE: ../pepper-utils/src/constants/selection.js
const Selection = {}

Selection.NONE = 0;
Selection.SOME = 0b00001; // 1
Selection.PAGE = 0b00010; // 2
Selection.PAGES = 0b0011; // 3

Selection.ALL = [ 
  Selection.NONE, 
  Selection.SOME, 
  Selection.PAGE, 
  Selection.PAGES 
];

// CONCATENATED MODULE: ../pepper-utils/src/constants/size.js
const Size = {};

Size.XS = 'xs'
Size.S = 's'
Size.M = 'm'
Size.L = 'l'
Size.XL = 'xl'
Size.FULLSCREEN = 'fullscreen'

Size.ALL = [
  Size.XS, 
  Size.S, 
  Size.M, 
  Size.L, 
  Size.XL
];

// CONCATENATED MODULE: ../pepper-utils/src/constants/sort.js
const Sort = {};

Sort.NONE = 0;
Sort.ASC = 0b00001; // 1
Sort.DESC = 0b00010; // 2

Sort.ALL = [
  Sort.NONE, 
  Sort.ASC, 
  Sort.DESC
];

// CONCATENATED MODULE: ../pepper-utils/src/helpers/file.js


class file_PepperFile{
  constructor({ errors, loaded, loading, name, size, src, transferred, type}){
    this.errors = errors || [];
    this.loaded = loaded || 0;
    this.loading= loading || false;
    this.name = name;
    this.size = size || 0;
    this.src = src;
    this.transferred = transferred || false;
    this.type = MimeType.ALL.find(m => m.value == type);

    if ( this.type == undefined ){
      let n = this.src instanceof File ? this.src.name : this.src;
      let ext = '.' + n.split('.').pop();
      this.type = MimeType.ALL.find(m => m.extension == ext);
    }
  }

  get filename(){
    let n = this.src instanceof File ? this.src.name : this.src;
    return n.split('/').pop();
  }

  get filesize(){
    if (this.size < 1024) {
      return this.size + 'o';
    } else if (this.size >= 1024 && this.size < 1048576) {
      return (this.size / 1024).toFixed(1) + 'ko';
    } else if (this.size >= 1048576) {
      return (this.size / 1048576).toFixed(1) + 'mo';
    }
  }

  get isArchive(){
    return this.type.category === MimeTypeCategory.ARCHIVE
  }
  
  get isAudio(){
    return this.type.category === MimeTypeCategory.AUDIO
  }
  
  get isCode(){
    return this.type.category === MimeTypeCategory.CODE
  }

  get isDocument(){
    return this.type.category === MimeTypeCategory.DOCUMENT
  }

  get isImage(){
    return this.type.category === MimeTypeCategory.IMAGE
  }
  
  get isVideo(){
    return this.type.category === MimeTypeCategory.VIDEO
  }
}

// CONCATENATED MODULE: ../pepper-utils/src/helpers/slot.js
/* harmony default export */ var slot = ({
  methods: {
    has(name){
      return !!this.$slots[name];
    }
  }
});

// CONCATENATED MODULE: ../pepper-utils/src/helpers/type.js
const isString = (value) => {
  return typeof value === 'string' || value instanceof String
}



// CONCATENATED MODULE: ../pepper-utils/src/index.js



















// CONCATENATED MODULE: ../directives-autofocus/src/autofocus.js
const directive = {
  inserted(el, binding) {
    if (binding.value !== undefined && !binding.value) {
      return;
    }

    el.focus();
  }
}

/* harmony default export */ var autofocus = (directive);

// EXTERNAL MODULE: ../directives-autofocus/package.json
var directives_autofocus_package = __webpack_require__("a074");

// CONCATENATED MODULE: ../directives-autofocus/src/index.js



autofocus.meta = directives_autofocus_package



// CONCATENATED MODULE: ../directives-clickoutside/src/clickoutside.js
const HANDLERS_PROPERTY = '__v-click-outside';
const HAS_WINDOWS = typeof window !== 'undefined';
const HAS_NAVIGATOR = typeof navigator !== 'undefined';
const IS_TOUCH = HAS_WINDOWS && ('ontouchstart' in window || (HAS_NAVIGATOR && navigator.msMaxTouchPoints > 0));
const EVENTS = IS_TOUCH ? ['touchstart'] : ['click'];

function processDirectiveArguments(bindingValue) {
  const isFunction = typeof bindingValue === 'function';
  if (!isFunction && typeof bindingValue !== 'object') {
    throw new Error('v-click-outside: Binding value must be a function or an object');
  }

  return {
    handler: isFunction ? bindingValue : bindingValue.handler,
    middleware: bindingValue.middleware || ((item) => item),
    events: bindingValue.events || EVENTS,
    isActive: !(bindingValue.isActive === false)
  }
}

function onEvent({ el, event, handler, middleware }) {
  // Note: composedPath is not supported on IE and Edge, more information here:
  //       https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath
  //       In the meanwhile, we are using el.contains for those browsers, not
  //       the ideal solution, but using IE or EDGE is not ideal either.
  const path = event.path || (event.composedPath && event.composedPath());
  const outsideCheck = path ? path.indexOf(el) < 0 : !el.contains(event.target);
  const isClickOutside = event.target !== el && outsideCheck;

  if (!isClickOutside) {
    return;
  }

  if (middleware(event)) {
    handler(event);
  }
}

function bind(el, { value }) {
  const { events, handler, middleware, isActive } = processDirectiveArguments(value);
  
  if (!isActive) {
    return;
  }

  el[HANDLERS_PROPERTY] = events.map((eventName) => ({
    event: eventName,
    handler: (event) => onEvent({ event, el, handler, middleware })
  }));

  el[HANDLERS_PROPERTY].forEach(({ event, handler }) =>
    setTimeout(() => {
      // Note: More info about this implementation can be found here:
      //       https://github.com/ndelvalle/v-click-outside/issues/137
      if (!el[HANDLERS_PROPERTY]) {
        return
      }
      document.documentElement.addEventListener(event, handler, false)
    }, 0)
  )
}

function unbind(el) {
  const handlers = el[HANDLERS_PROPERTY] || [];
  handlers.forEach(({ event, handler }) =>
    document.documentElement.removeEventListener(event, handler, false)
  )
  delete el[HANDLERS_PROPERTY];
}

function update(el, { value, oldValue }) {
  if (JSON.stringify(value) === JSON.stringify(oldValue)) {
    return;
  }
  unbind(el);
  bind(el, { value });
}

const clickoutside_directive = {
  bind,
  update,
  unbind
}

/* harmony default export */ var clickoutside = (HAS_WINDOWS ? clickoutside_directive : {});

// EXTERNAL MODULE: ../directives-clickoutside/package.json
var directives_clickoutside_package = __webpack_require__("8da5");

// CONCATENATED MODULE: ../directives-clickoutside/src/index.js



clickoutside.meta = directives_clickoutside_package



// CONCATENATED MODULE: ../pepper-pepper/src/directives/index.js



// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../actions-button/src/button.vue?vue&type=template&id=4439d174&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.is,_vm._g(_vm._b({tag:"component"},'component',_vm.attrs,false),_vm.listeners),[(_vm.loading)?_c('div',{staticClass:"actions-button__loader"},[_vm._t("loading",[_c('ui-loader',{attrs:{"size":_vm.size}})])],2):[(_vm.iconPre)?_c('ui-icon',{staticClass:"actions-button__icon",attrs:{"glyph":_vm.iconPre}}):_vm._e(),(_vm.hasLabel)?_c('span',{staticClass:"actions-button__label"},[_vm._t("default")],2):_vm._e(),(_vm.iconPost)?_c('ui-icon',{staticClass:"actions-button__icon",attrs:{"glyph":_vm.iconPost}}):_vm._e()]],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ../actions-button/src/button.vue?vue&type=template&id=4439d174&

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../ui-icon/src/icon.vue?vue&type=template&id=04b034e0&
var iconvue_type_template_id_04b034e0_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:_vm.classes,attrs:{"aria-label":_vm.label}})}
var iconvue_type_template_id_04b034e0_staticRenderFns = []


// CONCATENATED MODULE: ../ui-icon/src/icon.vue?vue&type=template&id=04b034e0&

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../ui-icon/src/icon.vue?vue&type=script&lang=js&
//
//
//

/* harmony default export */ var iconvue_type_script_lang_js_ = ({
  name: "UiIcon",

  props: {
    glyph: {
      type: String,
      default: 'none'
    },

    label: {
      type: String
    }
  },
  
  computed: {
    classes(){
      return 'icon-' + this.glyph;
    }
  }
});

// CONCATENATED MODULE: ../ui-icon/src/icon.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_iconvue_type_script_lang_js_ = (iconvue_type_script_lang_js_); 
// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ../ui-icon/src/icon.vue





/* normalize component */

var component = normalizeComponent(
  src_iconvue_type_script_lang_js_,
  iconvue_type_template_id_04b034e0_render,
  iconvue_type_template_id_04b034e0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var icon = (component.exports);
// EXTERNAL MODULE: ../ui-icon/package.json
var ui_icon_package = __webpack_require__("42ac");

// CONCATENATED MODULE: ../ui-icon/src/index.js



icon.meta = ui_icon_package


// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../ui-loader/src/loader.vue?vue&type=template&id=6b3f7912&
var loadervue_type_template_id_6b3f7912_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[(_vm.appearance === 'spinner')?[_c('div',{staticClass:"ui-loader__spinner"}),_c('div',{staticClass:"ui-loader__spinner"}),_c('div',{staticClass:"ui-loader__spinner"}),_c('div',{staticClass:"ui-loader__spinner"}),_c('div',{staticClass:"ui-loader__spinner"}),_c('div',{staticClass:"ui-loader__spinner"})]:_vm._e(),(_vm.appearance === 'double-bounce')?[_c('div',{staticClass:"ui-loader__bounce"}),_c('div',{staticClass:"ui-loader__bounce"})]:_vm._e(),(_vm.appearance === 'dots')?[_c('div',{staticClass:"ui-loader__dot"}),_c('div',{staticClass:"ui-loader__dot"}),_c('div',{staticClass:"ui-loader__dot"})]:_vm._e()],2)}
var loadervue_type_template_id_6b3f7912_staticRenderFns = []


// CONCATENATED MODULE: ../ui-loader/src/loader.vue?vue&type=template&id=6b3f7912&

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../ui-loader/src/loader.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loadervue_type_script_lang_js_ = ({
  name: "UiLoader",

  props: {
    appearance: {
      type: String,
      default: 'spinner',
      values: ['spinner', 'double-bounce', 'dots'],
      validator: value => ['spinner', 'double-bounce', 'dots'].includes(value)
    },

    size: {
      type: String,
      default: 'm',
      values: ['xs', 's', 'm', 'l'],
      validator: value => ['xs', 's', 'm', 'l'].includes(value)
    }
  },

  computed: {
    classes(){
      return {
        'ui-loader': true,
        '-is-spinner': this.appearance === 'spinner',
        '-is-double-bounce': this.appearance === 'double-bounce',
        '-is-dots': this.appearance == 'dots',

        '-xs': this.size === 'xs',
        '-s': this.size === 's',
        '-l': this.size === 'l'
      }
    }
  }
});

// CONCATENATED MODULE: ../ui-loader/src/loader.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_loadervue_type_script_lang_js_ = (loadervue_type_script_lang_js_); 
// CONCATENATED MODULE: ../ui-loader/src/loader.vue





/* normalize component */

var loader_component = normalizeComponent(
  src_loadervue_type_script_lang_js_,
  loadervue_type_template_id_6b3f7912_render,
  loadervue_type_template_id_6b3f7912_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var loader = (loader_component.exports);
// EXTERNAL MODULE: ../ui-loader/package.json
var ui_loader_package = __webpack_require__("f8c4");

// CONCATENATED MODULE: ../ui-loader/src/index.js



loader.meta = ui_loader_package


// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../actions-button/src/button.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var buttonvue_type_script_lang_js_ = ({
  name: 'ActionsButton',

  components: {
    UiIcon: icon,
    UiLoader: loader
  },

  props: {
    appearance: {
      type: String,
      default: Appearance.DEFAULT,
      values: [Appearance.DEFAULT, Appearance.PRIMARY, Appearance.LINK, Appearance.SUBTLE],
      validator: value => [Appearance.DEFAULT, Appearance.PRIMARY, Appearance.LINK, Appearance.SUBTLE].includes(value)
    },

    autofocus: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    download: {
      type: String
    },

    href: {},

    iconPre: {
      type: String
    },

    iconPost: {
      type: String
    },

    intent: {
      type: String,
      default: Intent.DEFAULT,
      values: Intent.ALL,
      validator: value => Intent.ALL.includes(value)
    },

    loading: {
      type: Boolean,
      default: false
    },

    submit: {
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: Size.M,
      values: [Size.XS, Size.S, Size.M, Size.L],
      validator: value => [Size.XS, Size.S, Size.M, Size.L].includes(value)
    },

    tabindex: {
      type: Number
    },

    target: {
      type: String,
      default: '_blank',
      values: ['_blank', '_self', '_parent', '_top'],
      validator: value => ['_blank', '_self', '_parent', '_top'].includes(value)
    }
  },

  computed: {
    attrs(){
      let ret = {
        class: this.classes,
        disabled: this.disabled === true,
        download: this.download && this.download.length > 0 ? this.download : null,
        to: this.href
      };

      if (this.tabindex){
        ret.tabindex = this.tabindex;
      }

      if (this.type === 'a'){
        ret.href = this.href;

        if (this.target){
          ret.target = this.target;

          if (this.target === '_blank'){
            ret.rel = 'noopener noferrer';
          }
        }
      }

      if (this.submit){
        this.type = 'submit';
      }

      return ret;
    },

    classes(){
      return {
        'actions-button': true,
        '-no-label': !this.hasLabel,

        '-is-link': this.appearance === Appearance.LINK,
        '-is-primary': this.appearance === Appearance.PRIMARY,
        '-is-subtle': this.appearance === Appearance.SUBTLE,

        '-is-download': this.download && this.download.length > 0 ? this.download : null,

        '-is-disabled': this.disabled,
        '-is-loading': this.loading,
        '-is-issubmit': this.submit,

        '-icon-pre': this.iconPre,
        '-icon-post': this.iconPost,

        '-is-danger': this.intent === Intent.DANGER,
        '-is-warning': this.intent === Intent.WARNING,
        '-is-success': this.intent === Intent.SUCCESS,

        '-xs': this.size === Size.XS,
        '-s': this.size === Size.S,
        '-m': this.size === Size.M,
        '-l': this.size === Size.L,
      }
    },

    hasLabel(){
      return !!this.$slots.default;
    },

    listeners(){
      return this.$listeners;
    },

    is(){
      let ret = 'button';

      if (this.href){
        // object -> router-link
        if (typeof this.href === 'object'){
          ret = 'router-link';
        }

        // valid url -> a
        else if (this.isURL(this.href) || this.href.includes('mailto')) {
          ret = 'a';
        }

        // is relative -> router-link
        else{
          ret = 'router-link';
        }
      }

      return ret;
    },
  },

  methods: {
    isURL(str) {
      const pattern = new RegExp(
        '^(https?:\\/\\/)?' // protocol
       + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' // domain name
       + '((\\d{1,3}\\.){3}\\d{1,3}))' // OR ip (v4) address
       + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' // port and path
       + '(\\?[;&a-z\\d%_.~+=-]*)?' // query string
       + '(\\#[-a-z\\d_]*)?$', 'i'
      ); // fragment locator
      return pattern.test(str);
    }
  }
});

// CONCATENATED MODULE: ../actions-button/src/button.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_buttonvue_type_script_lang_js_ = (buttonvue_type_script_lang_js_); 
// CONCATENATED MODULE: ../actions-button/src/button.vue





/* normalize component */

var button_component = normalizeComponent(
  src_buttonvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_button = (button_component.exports);
// EXTERNAL MODULE: ../actions-button/package.json
var actions_button_package = __webpack_require__("974a");

// CONCATENATED MODULE: ../actions-button/src/index.js



src_button.meta = actions_button_package


// CONCATENATED MODULE: ../pepper-pepper/src/components/actions.js

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../charts-stack/src/stack.vue?vue&type=template&id=5420d5da&
var stackvue_type_template_id_5420d5da_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g(_vm._b({},'div',_vm.attrs,false),_vm.listeners),[(_vm.hasLabel)?_c('div',{staticClass:"charts-stack__label"},[_vm._t("default")],2):_vm._e(),_c('div',{staticClass:"charts-stack__chart"},_vm._l((_vm.entries),function(entry,index){return _c('div',_vm._b({key:entry.label},'div',_vm.getAttrsForEntry(entry, index),false))}),0)])}
var stackvue_type_template_id_5420d5da_staticRenderFns = []


// CONCATENATED MODULE: ../charts-stack/src/stack.vue?vue&type=template&id=5420d5da&

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../charts-stack/src/stack.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var stackvue_type_script_lang_js_ = ({
  name: "ChartsStack",

  props: {
    appearance: {
      type: String,
      default: 'default',
      values: [Appearance.DEFAULT],
      validator: (value) => [Appearance.DEFAULT].includes(value)
    },

    hues: {
      type: Array,
      default: () => [Hue.BLUE, Hue.RED, Hue.ORANGE, Hue.TEAL]
    },

    layout: {
      type: String,
      default: Layout.LTR,
      values: [ Layout.LTR, Layout.RTL, Layout.TTB, Layout.BTT ],
      validator: (value) => [ Layout.LTR, Layout.RTL, Layout.TTB, Layout.BTT ].includes(value)
    },

    total:{
      type: Number,
      default: 0
    },

    value: {
      type: Array,
      default: () => [],
      required: true
    }
  },

  computed: {
    attrs(){
      let ret = {
        class: this.classes,
      }

      return ret;
    },

    classes(){
      return {
        'charts-stack': true,

        '-is-horizontal': this.isHorizontal,
        '-is-vertical': this.isVertical,

        '-is-ltr': this.layout === Layout.LTR,
        '-is-rtl': this.layout === Layout.RTL,
        '-is-ttb': this.layout === Layout.TTB,
        '-is-btt': this.layout === Layout.BTT
      }
    },

    entries(){
      let formatter = new Intl.NumberFormat('en-us', {style: "percent", maximumFractionDigits: 2})
      return this.value.map(entry => {
        let value = entry.value / this.total;
        let length = formatter.format(value);
        return Object.assign(
          entry,
          {
            length: length,
            ratio: value
          }
        )
      })
    },

    hasLabel(){
      return !!this.$slots.default
    },

    isHorizontal(){
      return [Layout.LTR, Layout.RTL].includes(this.layout)
    },

    isVertical(){
      return [Layout.TTB, Layout.BTT].includes(this.layout)
    },

    listeners(){
      return this.$listeners
    }
  },

  methods: {
    getAttrsForEntry(item, index){
      let ret =  {
        class: this.getClassForEntry(item, index),
        style: this.getStyleForEntry(item, index),
        title: item.label
      }
      return ret;
    },

    getClassForEntry(item, index){
      let n = this.hues.length;
      let i = index - ((index / n) | 0) * n;
      let h = this.hues[i];

      let ret = {
        'charts-stack__entry': true,
        ['-'+h]: true
      }

      if (item.class){
        ret[item.class] = true
      }

      return ret;
    },

    getStyleForEntry(item, index){
      return {
        [this.isHorizontal ? 'width' : 'height']: item.length
      };
    }
  }
});

// CONCATENATED MODULE: ../charts-stack/src/stack.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_stackvue_type_script_lang_js_ = (stackvue_type_script_lang_js_); 
// CONCATENATED MODULE: ../charts-stack/src/stack.vue





/* normalize component */

var stack_component = normalizeComponent(
  src_stackvue_type_script_lang_js_,
  stackvue_type_template_id_5420d5da_render,
  stackvue_type_template_id_5420d5da_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var stack = (stack_component.exports);
// EXTERNAL MODULE: ../charts-stack/package.json
var charts_stack_package = __webpack_require__("8f54");

// CONCATENATED MODULE: ../charts-stack/src/index.js



stack.meta = charts_stack_package



// CONCATENATED MODULE: ../pepper-pepper/src/components/charts.js

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../data-badge/src/badge.vue?vue&type=template&id=50b640db&
var badgevue_type_template_id_50b640db_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g(_vm._b({},'div',_vm.attrs,false),_vm.$listeners),[(!_vm.dot)?_c('div',{staticClass:"data-badge__value"},[_vm._v(_vm._s(_vm.label))]):_vm._e()])}
var badgevue_type_template_id_50b640db_staticRenderFns = []


// CONCATENATED MODULE: ../data-badge/src/badge.vue?vue&type=template&id=50b640db&

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../data-badge/src/badge.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var badgevue_type_script_lang_js_ = ({
  name: "DataBadge",

  props: {
    appearance: {
      type: String,
      default: Appearance.DEFAULT,
      values: [Appearance.DEFAULT, Appearance.PRIMARY],
      validator: (value) => [Appearance.DEFAULT, Appearance.PRIMARY].includes(value)
    },

    dot: {
      type: Boolean,
      default: false
    },

    max: {
      type: Number,
    },

    value: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    attrs(){
      let ret = {
        class: this.classes,
        title: this.value
      }

      return ret;
    },

    classes(){
      return {
        'data-badge': true,

        '-is-primary': this.appearance === 'primary',
        '-is-dot': this.dot === true
      }
    },

    label(){
      let ret = this.value;
      
      if (this.max){
        ret = ret >= this.max ? `${this.max}+` : ret;
      }

      return ret;
    }
  }
});

// CONCATENATED MODULE: ../data-badge/src/badge.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_badgevue_type_script_lang_js_ = (badgevue_type_script_lang_js_); 
// CONCATENATED MODULE: ../data-badge/src/badge.vue





/* normalize component */

var badge_component = normalizeComponent(
  src_badgevue_type_script_lang_js_,
  badgevue_type_template_id_50b640db_render,
  badgevue_type_template_id_50b640db_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var badge = (badge_component.exports);
// EXTERNAL MODULE: ../data-badge/package.json
var data_badge_package = __webpack_require__("5d60");

// CONCATENATED MODULE: ../data-badge/src/index.js



badge.meta = data_badge_package



// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../data-empty/src/empty.vue?vue&type=template&id=ec2dbbca&
var emptyvue_type_template_id_ec2dbbca_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-empty"},[_c('div',{staticClass:"data-empty__body"},[_vm._t("default",[(_vm.illustration)?_c('div',{staticClass:"data-empty__illustration",style:('background-image:url('+ _vm.illustration + ')')}):_vm._e(),(_vm.title)?_c('h2',{staticClass:"data-empty__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.description)?_c('div',{staticClass:"data-empty__description"},[_vm._v(_vm._s(_vm.description))]):_vm._e()],{"description":_vm.description,"illustraton":_vm.illustration,"title":_vm.title}),(_vm.primaryAction || _vm.secondaryAction || _vm.tertiaryAction)?_c('div',{staticClass:"data-empty__actions"},[(_vm.primaryAction || _vm.secondaryAction)?_c('div',{staticClass:"data-empty__action"},[(_vm.primaryAction)?_c('actions-button',_vm._g({ref:"primary",attrs:{"appearance":"primary"}},_vm.listeners),[_vm._v(_vm._s(_vm.primaryAction))]):_vm._e(),(_vm.secondaryAction)?_c('actions-button',_vm._g({ref:"secondary"},_vm.listeners),[_vm._v(_vm._s(_vm.secondaryAction))]):_vm._e()],1):_vm._e(),(_vm.tertiaryAction)?_c('div',{staticClass:"data-empty__action"},[_c('actions-button',_vm._g({ref:"tertiary",attrs:{"appearance":"link"}},_vm.listeners),[_vm._v(_vm._s(_vm.tertiaryAction))])],1):_vm._e()]):_vm._e()],2)])}
var emptyvue_type_template_id_ec2dbbca_staticRenderFns = []


// CONCATENATED MODULE: ../data-empty/src/empty.vue?vue&type=template&id=ec2dbbca&

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../data-empty/src/empty.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var emptyvue_type_script_lang_js_ = ({

  name: 'DataEmpty',

  components: {
    ActionsButton: src_button
  },

  props: {
    description: {
      type: String,
    },

    illustration: {
      type: String,
    },

    primaryAction: {
      type: String,
    },

    secondaryAction: {
      type: String,
    },

    tertiaryAction: {
      type: String,
    },

    title: {
      type: String,
    }
  },

  computed: {
    listeners(){
      let k = Object.keys(this.$listeners);
      let compListeners = {};
      k.forEach((e) => {
        let l = 'on' + e.charAt(0).toUpperCase() + e.slice(1);
        if (this.hasOwnProperty(l)){
          compListeners[e] = (event, ...args) => this[l](event, args);
        }
      });

      return compListeners;
    },
  },

  methods: {
    onClick(event, args) {
      event.preventDefault();

      let target = event.currentTarget;
      let action = [ this.$refs.primary, this.$refs.secondary, this.$refs.tertiary]
        .filter((e) => e && e.$el == target);

      if (action.length > 0){
        action = action[0];
        this.$emit('click', event, action.$vnode.data.ref)
      }
    }
  }
});

// CONCATENATED MODULE: ../data-empty/src/empty.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_emptyvue_type_script_lang_js_ = (emptyvue_type_script_lang_js_); 
// CONCATENATED MODULE: ../data-empty/src/empty.vue





/* normalize component */

var empty_component = normalizeComponent(
  src_emptyvue_type_script_lang_js_,
  emptyvue_type_template_id_ec2dbbca_render,
  emptyvue_type_template_id_ec2dbbca_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var empty = (empty_component.exports);
// EXTERNAL MODULE: ../data-empty/package.json
var data_empty_package = __webpack_require__("f4eb");

// CONCATENATED MODULE: ../data-empty/src/index.js



empty.meta = data_empty_package



// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../data-filter/src/filter.vue?vue&type=template&id=61f2826e&
var filtervue_type_template_id_61f2826e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({},'div',_vm.attrs,false),[_vm._l((_vm.layout),function(item){return [(item === 'add')?_c('actions-button',{key:item,staticClass:"data-filter__add",attrs:{"disabled":_vm.disabled || _vm.disabledAdd || !_vm.isValid,"icon-pre":"plus","size":_vm.size},on:{"click":_vm.onAddClick}}):_vm._e(),(item === 'field')?_c('forms-select',{key:item,staticClass:"data-filter__field",attrs:{"disabled":_vm.disabled,"options":_vm.fields,"placeholder":_vm.fieldsPlaceholder,"size":_vm.size},on:{"change":_vm.onValueChange},model:{value:(_vm.value.field),callback:function ($$v) {_vm.$set(_vm.value, "field", $$v)},expression:"value.field"}}):_vm._e(),(item === 'label')?_c('forms-label',{key:item,staticClass:"data-filter__label"},[_vm._t("default")],2):_vm._e(),(item === 'remove')?_c('actions-button',{key:item,staticClass:"data-filter__remove",attrs:{"disabled":_vm.disabled || _vm.disabledRemove,"icon-pre":"minus","size":_vm.size},on:{"click":_vm.onRemoveClick}}):_vm._e(),(item === 'operator')?_c('forms-select',{key:item,staticClass:"data-filter__operator",attrs:{"disabled":_vm.disabled || !_vm.value.field,"options":_vm.operators,"placeholder":_vm.operatorsPlaceholder,"size":_vm.size},on:{"change":_vm.onValueChange},model:{value:(_vm.value.operator),callback:function ($$v) {_vm.$set(_vm.value, "operator", $$v)},expression:"value.operator"}}):_vm._e(),(item === 'value' && _vm.type === 'date')?_c('forms-input',{key:item,staticClass:"data-filter__value",attrs:{"disabled":_vm.disabled || !_vm.value.field,"placeholder":_vm.valuePlaceholder,"type":"date","size":_vm.size},on:{"input":_vm.onValueChange},model:{value:(_vm.value.value),callback:function ($$v) {_vm.$set(_vm.value, "value", $$v)},expression:"value.value"}}):_vm._e(),(item === 'value' && _vm.type === 'enum')?_c('forms-select',{key:item,staticClass:"data-filter__value",attrs:{"disabled":_vm.disabled || !_vm.value.field,"multiple":_vm.multiple,"options":_vm.options,"placeholder":_vm.valuePlaceholder,"size":_vm.size},on:{"change":_vm.onValueChange},model:{value:(_vm.value.value),callback:function ($$v) {_vm.$set(_vm.value, "value", $$v)},expression:"value.value"}}):_vm._e(),(item === 'value' && _vm.type === 'number')?_c('forms-input',{key:item,staticClass:"data-filter__value",attrs:{"disabled":_vm.disabled || !_vm.value.field,"placeholder":_vm.valuePlaceholder,"type":"number","size":_vm.size},on:{"input":_vm.onValueChange},model:{value:(_vm.value.value),callback:function ($$v) {_vm.$set(_vm.value, "value", $$v)},expression:"value.value"}}):_vm._e(),(item === 'value' && _vm.type === 'string')?_c('forms-input',{key:item,staticClass:"data-filter__value",attrs:{"disabled":_vm.disabled || !_vm.value.field,"placeholder":_vm.valuePlaceholder,"size":_vm.size},on:{"input":_vm.onValueChange},model:{value:(_vm.value.value),callback:function ($$v) {_vm.$set(_vm.value, "value", $$v)},expression:"value.value"}}):_vm._e()]})],2)}
var filtervue_type_template_id_61f2826e_staticRenderFns = []


// CONCATENATED MODULE: ../data-filter/src/filter.vue?vue&type=template&id=61f2826e&

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../data-filter/src/filter.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var filtervue_type_script_lang_js_ = ({

  name: 'DataFilter',

  components: {
    ActionsButton: src_button
  },

  model: {
    event: 'change',
    prop: 'value'
  },

  props: {
    appearance: {
      type: String,
      default: 'default'
    },

    disabled: {
      type: Boolean,
      default: false
    },

    disabledAdd: {
      type: Boolean,
      default: false
    },

    disabledRemove: {
      type: Boolean,
      default: false
    },

    fields: {
      type: Array,
      default: () => []
    },

    fieldsPlaceholder: {
      type: String,
      default: "Select a field"
    },

    layout: {
      type: Array,
      default: () => ['label', 'field', 'operator', 'value', 'add', 'remove'],
      validator: (value) => {
        let ret = true;
        value.forEach((item) => {
          if (!['label', 'field', 'operator', 'value', 'add', 'remove'].includes(item)){
            ret = false;
          }
        });

        return ret;
      }
    },

    multiple: {
      type: Boolean,
      default: false
    },

    operators: {
      type: Array,
      default: () => [
        {label: Operator.EQUAL, value: Operator.EQUAL}, 
        {label: Operator.NOT_EQUALS, value: Operator.NOT_EQUALS},
        {label: Operator.LESS, value: Operator.LESS},
        {label: Operator.EQUALS_OR_LESS, value: Operator.EQUALS_OR_LESS},
        {label: Operator.GREATER, value: Operator.GREATER},
        {label: Operator.EQUALS_OR_GREATER, value: Operator.EQUALS_OR_GREATER},
        {label: Operator.LIKE, value: Operator.LIKE}
      ],
      validator: (value) => {
        const values = [Operator.EQUAL, Operator.NOT_EQUALS, Operator.LESS, Operator.EQUALS_OR_LESS, Operator.GREATER, Operator.EQUALS_OR_GREATER, Operator.LIKE];
        let ret = true;
        value.forEach( v => {
          if (!values.includes(v.value)){
            ret = false;
          }
        })

        return ret;
      }
    },

    operatorsPlaceholder: {
      type: String,
      default: 'Select an operator'
    },

    options: {
      type: Array,
      default: () => []
    },

    size: {
      type: String,
      default: 'm',
      values: ['s', 'm'],
      validator: value => ['s', 'm'].includes(value)
    },

    type: {
      type: String,
      default: 'string',
      values: ['date', 'enum', 'number', 'string'],
      validator: (value) => ['date', 'enum', 'number', 'string'].includes(value)
    },

    value: {
      type: Object,
      default: () => { return {
        field: null,
        operator: null,
        value: null
      }}
    },

    valuePlaceholder: {
      type: String,
      default: 'Set the value'
    }
  },

  data(){
    return {
      operator: null
    }
  },

  computed: {
    attrs(){
      return {
        class: this.classes
      }
    },

    classes(){
      return {
        'data-filter': true,

        '-s': this.size === 's',

        '-is-disabled': this.disabled === true,
        '-is-add-disabled': this.disabledAdd === true,
        '-is-remove-disabled': this.disabledRemove === true
      }
    },

    isValid(){
      return this.value.field && this.value.operator && this.value.value;
    }
  },

  methods: {
    onAddClick(){
      this.$emit('add', this.value);
    },

    onValueChange(){
      this.$emit('change', this.value);
    },

    onRemoveClick(){
      this.$emit('remove', this.value);
    }
  }
});

// CONCATENATED MODULE: ../data-filter/src/filter.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_filtervue_type_script_lang_js_ = (filtervue_type_script_lang_js_); 
// CONCATENATED MODULE: ../data-filter/src/filter.vue





/* normalize component */

var filter_component = normalizeComponent(
  src_filtervue_type_script_lang_js_,
  filtervue_type_template_id_61f2826e_render,
  filtervue_type_template_id_61f2826e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var filter = (filter_component.exports);
// EXTERNAL MODULE: ../data-filter/package.json
var data_filter_package = __webpack_require__("cfcf");

// CONCATENATED MODULE: ../data-filter/src/index.js



filter.meta = data_filter_package



// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../data-pagination/src/pagination.vue?vue&type=template&id=76e6708b&
var paginationvue_type_template_id_76e6708b_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_vm._l((_vm.layout),function(item){return [(item == 'first' && !_vm.isSinglePage)?_c('div',{key:item,staticClass:"data-pagination__first"},[_vm._t("first",[_c('actions-button',{attrs:{"icon-pre":"caret-left","size":_vm.size,"disabled":_vm.disabled || _vm.isFirstPage,"click":"first"}})],{"disabled":_vm.disabled,"goToFirst":_vm.first,"isFirstPage":_vm.isFirstPage,"size":_vm.size})],2):_vm._e(),(item == 'jumper' && _vm.hasJumper && !_vm.isSinglePage)?_c('div',{key:item,staticClass:"data-pagination__jumper"},[_vm._t("jumper",[_c('forms-select',{attrs:{"disabled":_vm.disabled,"size":_vm.size},on:{"change":_vm.onPageChange}},_vm._l((_vm.nPages),function(page){return _c('option',{key:page},[_vm._v(_vm._s(page))])}),0)],{"disabled":_vm.disabled,"size":_vm.size})],2):_vm._e(),(item == 'last' && !_vm.isSinglePage)?_c('div',{key:item,staticClass:"data-pagination__last"},[_vm._t("last",[_c('actions-button',{attrs:{"icon-pre":"caret-right","size":_vm.size,"disabled":_vm.disabled || _vm.isLastPage},on:{"click":_vm.last}})],{"disabled":_vm.disabled,"isLastPage":_vm.isLastPage,"goToLastPage":_vm.last,"size":_vm.size})],2):_vm._e(),(item == 'next' && !_vm.isSinglePage)?_c('div',{key:item,staticClass:"data-pagination__next"},[_vm._t("next",[_c('actions-button',{attrs:{"icon-pre":"angle-right","size":_vm.size,"disabled":_vm.disabled || _vm.isLastPage},on:{"click":_vm.next}})],{"disabled":_vm.disabled,"isLastPage":_vm.isLastPage,"goToNext":_vm.next,"size":_vm.size})],2):_vm._e(),(item == 'pager' && !_vm.isSinglePage)?_c('div',{key:item,staticClass:"data-pagination__pager"},_vm._l((_vm.pages),function(i,index){return _c('button',{key:index,staticClass:"data-pagination__page",class:{
          '-is-selected': _vm.currentPage === i,
          '-is-separator': i == -1
          },attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.onPageChange($event, i)}}},[_vm._v(_vm._s(i > 0 ? i : ''))])}),0):_vm._e(),(item == 'prev' && !_vm.isSinglePage)?_c('div',{key:item,staticClass:"data-pagination__prev"},[_vm._t("prev",[_c('actions-button',{attrs:{"icon-pre":"angle-left","size":_vm.size,"disabled":_vm.disabled || _vm.isFirstPage},on:{"click":_vm.prev}})],{"disabled":_vm.disabled,"isFirstPage":_vm.isFirstPage,"goToPrev":_vm.prev,"size":_vm.size})],2):_vm._e(),(_vm.pageSizes && item == 'page-size')?_c('div',{key:item,staticClass:"data-pagination__quantity"},[_vm._t("page-size",[_c('forms-select',{attrs:{"disabled":_vm.disabled,"options":_vm.pageSizesOptions,"size":_vm.size},on:{"change":_vm.onPageSize},model:{value:(_vm.$data._pageSize),callback:function ($$v) {_vm.$set(_vm.$data, "_pageSize", $$v)},expression:"$data._pageSize"}})],{"disabled":_vm.disabled,"options":_vm.pageSizesOptions,"size":_vm.size,"value":_vm.$data._pageSize,"onChange":_vm.onPageSize})],2):_vm._e(),(item == 'total')?_c('div',{key:item,staticClass:"data-pagination__count"},[_vm._t("count",[_vm._v(_vm._s(_vm.total)+" Results")],{"total":_vm.total})],2):_vm._e()]})],2)}
var paginationvue_type_template_id_76e6708b_staticRenderFns = []


// CONCATENATED MODULE: ../data-pagination/src/pagination.vue?vue&type=template&id=76e6708b&

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../forms-select/src/select.vue?vue&type=template&id=f2288b48&
var selectvue_type_template_id_f2288b48_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('forms-control',_vm._b({ref:"control",class:_vm.classes,scopedSlots:_vm._u([{key:"before",fn:function(){return [_vm._t("before")]},proxy:true},{key:"default",fn:function(){return [_vm._t("default")]},proxy:true},{key:"after",fn:function(){return [_vm._t("after")]},proxy:true},{key:"prefix",fn:function(){return [_vm._t("prefix")]},proxy:true},{key:"content",fn:function(){return [(_vm.multiple)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.outside),expression:"outside"}],ref:"select",staticClass:"forms-select__content",on:{"click":function($event){return _vm.toggleOptionsDropdown($event)}}},[(_vm.value.length == 0 && _vm.placeholder)?_c('forms-label',{staticClass:"forms-select__placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._l((_vm.displayedValues),function(option,i){return _c('data-tag',{key:i,attrs:{"closable":"","value":option,"size":_vm.size},on:{"close":function($event){return _vm.onTagClose(option)}}},[_vm._v(_vm._s(option.label))])}),(_vm.collapsed && _vm.remaining > 0)?_c('data-tag',{attrs:{"size":_vm.size}},[_vm._v("+"+_vm._s(_vm.remaining))]):_vm._e()],2):_vm._e(),(!_vm.multiple)?_c('div',{staticClass:"forms-select__content"},[_c('select',_vm._g(_vm._b({directives:[{name:"autofocus",rawName:"v-autofocus",value:(_vm.autofocus),expression:"autofocus"}]},'select',_vm.selectAttrs,false),_vm.listeners),[(_vm.placeholder)?_c('option',{attrs:{"disabled":"","value":""}},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._l((_vm.options),function(option){return [(option.group)?_c('optgroup',{key:option.label,attrs:{"disabled":option.disabled,"label":option.label}},_vm._l((option.options),function(o){return _c('option',{key:o.value,attrs:{"disabled":o.disabled},domProps:{"value":o.value}},[_vm._v(_vm._s(o.label))])}),0):_c('option',{key:option.label,attrs:{"disabled":option.disabled},domProps:{"value":option.value}},[_vm._v(_vm._s(option.label))])]})],2)]):_vm._e(),(_vm.multiple)?_c('popins-list-dropdown',{ref:"dropdown",staticClass:"forms-select__dropdown",attrs:{"multiple":"","options":_vm.dropdown,"overflow":"visible","position":_vm.position,"target":_vm.$refs.control,"size":_vm.size,"visible":_vm.showOptions,"width":"100%"},on:{"change":_vm.onDropdownChange}}):_vm._e()]},proxy:true}],null,true)},'forms-control',_vm.$props,false))}
var selectvue_type_template_id_f2288b48_staticRenderFns = []


// CONCATENATED MODULE: ../forms-select/src/select.vue?vue&type=template&id=f2288b48&

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../data-tag/src/tag.vue?vue&type=template&id=2372a1bf&
var tagvue_type_template_id_2372a1bf_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.is,_vm._g(_vm._b({tag:"component"},'component',_vm.attrs,false),_vm.listeners),[_c('div',{staticClass:"data-tag__label"},[_vm._t("before"),_vm._t("default"),_vm._t("after")],2),(_vm.closable)?_c('button',{staticClass:"data-tag__close",on:{"click":function($event){return _vm.$emit('close', _vm.value)}}}):_vm._e()])}
var tagvue_type_template_id_2372a1bf_staticRenderFns = []


// CONCATENATED MODULE: ../data-tag/src/tag.vue?vue&type=template&id=2372a1bf&

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../data-tag/src/tag.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tagvue_type_script_lang_js_ = ({
  name: "DataTag",

  props: {
    appearance: {
      type: String,
      default: Appearance.DEFAULT,
      values: [Appearance.DEFAULT, Appearance.PRIMARY],
      validator: (value) => [Appearance.DEFAULT, Appearance.PRIMARY].includes(value)
    },

    closable: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    intent: {
      type: String,
      default: Intent.DEFAULT,
      values: Intent.ALL,
      validator: value => Intent.ALL.includes(value)
    },

    interactive: {
      type: Boolean,
      default: false
    },

    href: {},

    size: {
      type: String,
      default: Size.M,
      values: Size.ALL,
      validator: value => Size.ALL.includes(value)
    },

    value: {}
  },

  computed: {
    attrs(){
      let ret = {
        class: this.classes,
        disabled: this.disabled,
        to: this.href
      }

      if (this.is === 'a'){
        ret.href = this.href;
      }

      return ret;
    },

    classes(){
      return {
        'data-tag': true,

        '-no-label': !this.hasLabel,
        '-is-primary': this.appearance === 'primary',

        '-is-danger': this.intent === 'danger',
        '-is-warning': this.intent === 'warning',
        '-is-success': this.intent === 'success',

        '-is-closable': this.closable === true,
        '-is-interactive': this.isAnchor === true || this.interactive === true,

        '-xs': this.size === 'xs',
        '-s': this.size === 's',
        '-m': this.size === 'm',
        '-l': this.size === 'l'
      }
    },

    is(){
      let ret = 'div';

      if (this.href){
        // object -> router-link
        if (typeof this.href === 'object'){
          ret = 'router-link';
        }

        // url -> a
        ret = 'a';
      }

      return ret;
    },

    isAnchor(){
      return ['router-link', 'a'].includes(this.is);
    },

    hasLabel(){
      return !!this.$slots.default;
    },

    listeners(){
      let k = Object.keys(this.$listeners);
      let compListeners = {};
      k.forEach((e) => {
        let l = 'on' + e.charAt(0).toUpperCase() + e.slice(1);
        compListeners[e] = (event, ...args) => this[l](event, args);
      });

      let l = Object.assign({}, this.$listeners);
      return Object.assign(l, compListeners);
      // return {...this.$listeners, ...compListeners};
    }
  }
});

// CONCATENATED MODULE: ../data-tag/src/tag.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_tagvue_type_script_lang_js_ = (tagvue_type_script_lang_js_); 
// CONCATENATED MODULE: ../data-tag/src/tag.vue





/* normalize component */

var tag_component = normalizeComponent(
  src_tagvue_type_script_lang_js_,
  tagvue_type_template_id_2372a1bf_render,
  tagvue_type_template_id_2372a1bf_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var tag = (tag_component.exports);
// EXTERNAL MODULE: ../data-tag/package.json
var data_tag_package = __webpack_require__("477f");

// CONCATENATED MODULE: ../data-tag/src/index.js



tag.meta = data_tag_package



// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../forms-control/src/control.vue?vue&type=template&id=1f5e0702&
var controlvue_type_template_id_1f5e0702_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[(_vm.has('default') || _vm.has('before') || _vm.has('after'))?_c('div',{staticClass:"forms-control__header"},[_c('forms-label',{staticClass:"forms-control__label",attrs:{"rel":_vm.id},scopedSlots:_vm._u([{key:"before",fn:function(){return [_vm._t("before")]},proxy:true},{key:"after",fn:function(){return [_vm._t("after")]},proxy:true}],null,true)},[_vm._t("default")],2)],1):_vm._e(),_c('div',{staticClass:"forms-control__body"},[(_vm.has('prefix'))?_c('div',{staticClass:"forms-control__prefix"},[_vm._t("prefix")],2):_vm._e(),_c('div',{staticClass:"forms-control__content"},[_vm._t("content")],2),(_vm.loading)?_c('div',{staticClass:"forms-control__loader"},[_vm._t("loader",[_c('ui-loader',{staticClass:"forms-control__loader",attrs:{"size":"s"}})])],2):_vm._e(),(_vm.has('suffix'))?_c('div',{staticClass:"forms-control__suffix"},[_vm._t("suffix")],2):_vm._e()]),(_vm.hint || (_vm.errors && _vm.errors.length))?_c('div',{staticClass:"forms-control__footer"},[(_vm.hint)?_c('div',{staticClass:"forms-control__hint"},[_vm._v(_vm._s(_vm.hint))]):_vm._e(),_c('div',{staticClass:"forms-control__errors"},_vm._l((_vm.errors),function(e){return _c('forms-label',{key:e,staticClass:"forms-control__label",attrs:{"rel":_vm.id,"intent":"danger"}},[_vm._v(_vm._s(e))])}),1)]):_vm._e()])}
var controlvue_type_template_id_1f5e0702_staticRenderFns = []


// CONCATENATED MODULE: ../forms-control/src/control.vue?vue&type=template&id=1f5e0702&

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../forms-label/src/label.vue?vue&type=template&id=511be578&
var labelvue_type_template_id_511be578_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',_vm._b({},'label',_vm.attrs,false),[(_vm.hasBefore)?_c('span',{staticClass:"forms-label__before"},[_vm._t("before")],2):_vm._e(),(_vm.hasDefault)?_c('span',{staticClass:"forms-label__content"},[_vm._t("default",[_vm._v("Label")])],2):_vm._e(),(_vm.hasAfter)?_c('span',{staticClass:"forms-label__after"},[_vm._t("after")],2):_vm._e()])}
var labelvue_type_template_id_511be578_staticRenderFns = []


// CONCATENATED MODULE: ../forms-label/src/label.vue?vue&type=template&id=511be578&

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../forms-label/src/label.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var labelvue_type_script_lang_js_ = ({
  name: "FormsLabel",

  props: {
    intent: {
      type: String,
      default: Intent.DEFAULT,
      values: Intent.ALL,
      validator: value => Intent.ALL.includes(value)
    },

    rel: {
      type: String
    },

    size: {
      type: String,
      default: Size.M,
      values: [Size.S, Size.M],
      validator: value => [Size.S, Size.M].includes(value)
    }
  },

  computed: {
    attrs() {
      return {
        class: this.classes,
        for: this.rel
      }
    },

    classes(){
      return {
        'forms-label': true,
        '-is-danger': this.intent === Intent.DANGER,
        '-is-warn': this.intent === Intent.WARNING,

        '-s': this.size === Size.S,
        '-m': this.size === Size.M
      }
    },

    hasBefore(){
      return !!this.$slots.before;
    },

    hasDefault(){
      return !!this.$slots.default;
    },

    hasAfter(){
      return !!this.$slots.after;
    },
  }
});

// CONCATENATED MODULE: ../forms-label/src/label.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_labelvue_type_script_lang_js_ = (labelvue_type_script_lang_js_); 
// CONCATENATED MODULE: ../forms-label/src/label.vue





/* normalize component */

var label_component = normalizeComponent(
  src_labelvue_type_script_lang_js_,
  labelvue_type_template_id_511be578_render,
  labelvue_type_template_id_511be578_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var label = (label_component.exports);
// EXTERNAL MODULE: ../forms-label/package.json
var forms_label_package = __webpack_require__("32bb");

// CONCATENATED MODULE: ../forms-label/src/index.js



label.meta = forms_label_package



// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../forms-control/src/control.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var controlvue_type_script_lang_js_ = ({
  name: "FormsControl",

  components: {
    FormsLabel: label,
    UiLoader: loader
  },

  mixins: [
    slot
  ],

  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    errors: {
      type: Array,
      property: String,
      default: () => []
    },

    hint: {
      type: String
    },

    id: {
      type: String,
      default: () => 'forms-control-' + Math.round( Math.random() * 9999999 )
    },

    loading: {
      type: Boolean,
      default: false
    },

    name: {
      type: String,
      default: () => 'forms-control-' + Math.round( Math.random() * 9999999 )
    },

    required: {
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: Size.M,
      values: Size.ALL,
      validator: value => Size.ALL.includes(value)
    }
  },

  computed: {
    classes(){
      return {
        'forms-control': true,

        '-is-disabled': this.disabled,
        '-is-loading': this.loading,
        '-is-required': this.required,
        '-is-invalid': this.errors && this.errors.length,

        '-is-number': this.type === 'number',

        '-has-before': this.has('before'),
        '-has-after': this.has('after'),
        '-has-prefix': this.has('prefix'),
        '-has-suffix': this.has('suffix'),

        '-xs': this.size === Size.XS,
        '-s': this.size === Size.S,
        '-m': this.size === Size.M,
        '-l': this.size === Size.L,
        '-xl': this.size === Size.xL,

        '-no-label': !this.has('default')
      }
    },
  },
});

// CONCATENATED MODULE: ../forms-control/src/control.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_controlvue_type_script_lang_js_ = (controlvue_type_script_lang_js_); 
// CONCATENATED MODULE: ../forms-control/src/control.vue





/* normalize component */

var control_component = normalizeComponent(
  src_controlvue_type_script_lang_js_,
  controlvue_type_template_id_1f5e0702_render,
  controlvue_type_template_id_1f5e0702_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var control = (control_component.exports);
// EXTERNAL MODULE: ../forms-control/package.json
var forms_control_package = __webpack_require__("c3a3");

// CONCATENATED MODULE: ../forms-control/src/index.js



control.meta = forms_control_package



// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../popins-dropdown/src/dropdown.vue?vue&type=template&id=13e78a62&
var dropdownvue_type_template_id_13e78a62_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popins-popin',_vm._b({},'popins-popin',_vm.popinAttrs,false),[_c('div',_vm._b({},'div',_vm.attrs,false),[_vm._t("default")],2)])}
var dropdownvue_type_template_id_13e78a62_staticRenderFns = []


// CONCATENATED MODULE: ../popins-dropdown/src/dropdown.vue?vue&type=template&id=13e78a62&

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../popins-popin/src/popin.vue?vue&type=template&id=233c19bd&
var popinvue_type_template_id_233c19bd_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({},'div',_vm.attrs,false),[_c('transitions-fade',{attrs:{"direction":_vm.direction},on:{"after-leave":_vm.onPopinLeave}},[(_vm.visible)?_c('div',{staticClass:"popins-popin__inner"},[_vm._t("default")],2):_vm._e()])],1)}
var popinvue_type_template_id_233c19bd_staticRenderFns = []


// CONCATENATED MODULE: ../popins-popin/src/popin.vue?vue&type=template&id=233c19bd&

// CONCATENATED MODULE: ../transitions-fade/src/fade.js


/* harmony default export */ var fade = ({
  name: 'TransitionsFade',
  functional: true,

  props: {

    appear: {
      type: Boolean,
      default: false
    },

    direction: {
      type: String,
      default: Direction.NONE,
      values: Direction.ALL,
      validator: (value) => Direction.ALL.includes(value)
    },

    duration: {
      type: Number,
      default: 500
    },

    group: {
      type: Boolean,
      default: false
    },

    mode:{
      type: String,
      default: 'out-in',
      values: ['in-out', 'out-in'],
      validator: (value) => ['in-out', 'out-in'].includes(value)
    },

    tag: {
      type: String,
      default: 'div'
    }
  },

  render(createElement, { props, listeners, children }){
    let attrs = getAttrs(props);
    return createElement('transition', {
      attrs,
      on: listeners
    }, children);
  }
});


const getAttrs = (vm) => {
  let type = getIs(vm);
  let ret = {
    appear: vm.appear,
    is: getIs(vm),
    mode: vm.mode,
    name: getName(vm),
    css: true,
    duration: vm.duration
  }

  if (type === 'transition-group'){
    ret.tag = vm.tag
  }

  return ret;
};

const getListeners = (vm) => {
  let k = Object.keys(vm.$listeners);
  let compListeners = {};
  k.forEach((e) => {
    let l = 'on' + e.charAt(0).toUpperCase() + e.slice(1);
    compListeners[e] = (event, ...args) => vm[l](event, args);
  });

  let ret = Object.assign({}, vm.$listeners);
  ret = Object.assign(ret, compListeners);
  return ret;
}

const getName = (vm) => {
  return vm.direction == 'none' ? 'fade' : 'fade-' + vm.direction;
}

const getIs = (vm) => {
  return vm.group ? 'transition-group' : 'transition';
}

// EXTERNAL MODULE: ../transitions-fade/package.json
var transitions_fade_package = __webpack_require__("3b6d");

// CONCATENATED MODULE: ../transitions-fade/src/index.js



fade.meta = transitions_fade_package



// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../popins-popin/src/popin.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var popinvue_type_script_lang_js_ = ({
  name: "PopinsPopin",

  components: {
    TransitionsFade: fade
  },

  props :{
    margin:{
      type: Number,
      default: 0
    },

    overflow: {
      type: String,
      default: 'hidden',
      values: ['hidden', 'visible'],
      validator: (value) => ['hidden', 'visible'].includes(value),
    },

    position: {
      type: String,
      default: Position.TOP_CENTER,
      values: Position.ALL,
      validator: (value) => Position.ALL.includes(value),
    },

    target: {
      default: () => document.body
    },

    direction: {
      type: String,
      default: Direction.NONE,
      values: Direction.ALL,
      validator: (value) => Direction.ALL.includes(value),
    },

    visible: {
      type: Boolean,
      default: false
    },

    width: {
      type: String,
      default: null
    },    
  },

  data: () => ({
    top: 0,
    left: 0,
    w: null,
    id: 0,
    z: -1,
    visibility: false,
    interval: null
  }),

  computed:{
    attrs(){
      return {
        class: this.classes,
        id: `popin-${ this.id }`,
        ref: 'popin',
        style: this.styles
      }
    },

    classes(){
      let ret =  {
        'popin': true,
        '-is-active': this.visibility
      }

      if (this.$attrs.hasOwnProperty('class')){
        ret[this.$attrs.class] = true 
      }

      return ret;
    },

    styles(){
      return {
        'left': `${this.left}px`,
        'top': `${this.top}px`,
        'width': typeof this.w === 'number' ? `${this.w}px` : this.w,
        'z-index': this.z
      }
    }
  },

  watch: {
    visible(val){
      this.reset();
    },
    position(val){
      this.update();
    },
    overflow(val){
      this.update();
    },
    target(val){
      this.update();
    },
    width(val){
      this.update();
    },
    z(val){
      this.update();
    }
  },

  mounted() {
    this.id = this.$popin.register(this.$refs.popin);
    this.reset();
    this.update();
  },

  beforeDestroy() {
    this.stop();
    this.$popin.unregister(this.id);
  },

  methods: {
    reset(){
      if (this.visible){
        this.visibility = true;
        this.$popin.show(this);
        this.update();
        this.start();
      }
      else{
        this.$popin.hide(this);
        this.stop();
      }
    },

    start(){
      window.addEventListener('resize', this.update.bind(this));
      document.addEventListener('scroll', this.update.bind(this));
      this.interval = setInterval(this.update.bind(this), 100);
    },

    stop(){
      window.removeEventListener('resize', this.update.bind(this));
      document.removeEventListener('scroll', this.update.bind(this));
      clearInterval(this.interval);
      this.interval = null;
    },

    update() {
      this.$nextTick(() => {
        if (!this.$refs.popin || !this.target){
          return;
        }

        let t = this.target;
        if (this.target.hasOwnProperty('$vnode')) { t = this.target.$vnode.elm; }
        let tr = t.getBoundingClientRect();
        let cr = this.$refs.popin.getBoundingClientRect();
        let w = window.innerWidth;
        let h = window.innerHeight;

        let bounderies = {
          top: 0,
          right: w,
          bottom: h,
          left: 0,
          width: w,
          height: h
        };

        this.w = this.getWidth(tr, cr, bounderies);
        if (typeof this.w === 'number'){
          cr.width = this.w;
        }

        this.top = this.getTop(tr, cr, bounderies);
        this.left = this.getLeft(tr, cr, bounderies);
      });
    },

    /**
     * Get the top position
     * @param  {Rect} pr         parent bounding rect
     * @param  {Rect} cr         child bounding rect
     * @param  {Rect} bounderies window bounding rect
     * @return {Number}          The top position
     */
    getTop(pr, cr, bounderies){
      let ret = this.getTopForPosition(pr, cr, this.position);

      if (this.overflow === 'visible'){
        const vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        ret = Math.min(vh - cr.height, Math.max(ret, 0));
      }

      return ret;
    },

    /**
     * Get the left position
     * @param  {Rect} pr         parent bounding rect
     * @param  {Rect} cr         child bounding rect
     * @param  {Rect} bounderies window bounding rect
     * @return {Number}          The top position
     */
    getLeft(pr, cr, bounderies){
      let ret = this.getLeftForPosition(pr, cr, this.position);

      if (this.overflow === 'visible'){
        const vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        ret = Math.min(vw - cr.width, Math.max(ret, 0));
      }

      return ret;
    },

    /**
     * Get the width of the popin
     * @param  {Rect} pr         parent bounding rect
     * @param  {Rect} cr         child bounding rect
     * @param  {Rect} bounderies window bounding rect
     * @return {Number}          The top position
     */
    getWidth(pr, cr, bounderies){
      let v = this.parseCssUnit(this.width);
      let ret = null;

      switch (v.type) {
        case 'px':
          ret = v.value;
          break;

        case '%':
          let w = pr.width * (v.value / 100);
          ret = w;
          break;

        default:
          ret = v.value;
          break;
      }

      // bounderies
      if (typeof v.value === 'number'){

      }

      return ret;
    },


    /**
     * Get the top for a given position
     * @param  {rect} pr         Parent bounding Rect
     * @param  {Rect} cr         Child bounding Rect
     * @param  {String} position Position
     * @return {Number}          Top for a position
     */
    getTopForPosition(pr, cr, position){
      let [y, x] = position.split('-');
      const m = typeof this.margin === 'number' ? this.margin : this.margin.top || 0;

      let ret = 0;
      switch(y){
        case 'top':
          ret = pr.top + m;
          break;

        case 'middle':
          ret = pr.top + (pr.height >> 1) - (cr.height >> 1) + m;
          break;

        case 'bottom':
          ret = pr.top + pr.height + m;
          break;
      }

      return ret;
    },

    /**
     * Get the left for a given position
     * @param  {rect} pr         Parent bounding Rect
     * @param  {Rect} cr         Child bounding Rect
     * @param  {String} position Position
     * @return {Mumber}          Left for a position
     */
    getLeftForPosition(pr, cr, position){
      let [y, x] = position.split('-');
      const m = typeof this.margin === 'number' ? this.margin : this.margin.left || 0;

      let ret = 0;
      switch(x){
        case 'left':
          ret = pr.left + m;
          break;

        case 'center':
          ret = pr.left + (pr.width >> 1) - (cr.width >>1) + m;
          break;

        case 'right':
          ret = pr.left + pr.width + m;
          break;
      }

      return ret;
    },

    parseCssUnit(value){
      const isNumber = typeof value === 'number';
      const isString = typeof value === 'string';

      // null
      // String('auto')
      let ret = {
        value: value,
        type: null
      };

      // number -> px
      if (isNumber){
        ret.type = 'px';
      }

      if (isString && value.length > 0 && value !== 'auto'){
        let sub = 0;
        // px
        if (value.includes('px')){
          sub = 2;
          ret.type = 'px';
        }

        // %
        if (value.includes('%')){
          sub = 1;
          ret.type = '%';
        }

        ret.value = parseFloat(value.substring(0, value.length-sub).trim());
      }

      return ret;
    },

    onPopinLeave(){
      this.visibility =  false || this.visible;
    }
  }
});

// CONCATENATED MODULE: ../popins-popin/src/popin.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_popinvue_type_script_lang_js_ = (popinvue_type_script_lang_js_); 
// CONCATENATED MODULE: ../popins-popin/src/popin.vue





/* normalize component */

var popin_component = normalizeComponent(
  src_popinvue_type_script_lang_js_,
  popinvue_type_template_id_233c19bd_render,
  popinvue_type_template_id_233c19bd_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var popin = (popin_component.exports);
// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);

// CONCATENATED MODULE: ../popins-popin/src/bus.js


class PopinBus {
  constructor() {
    this.instances = [];
    this.shown = [];
    this.z = 5000;

    // check for the container
    let all = document.getElementsByClassName('popins-bus');
    if (!all.length){
      this.container = document.createElement('div');
      this.container.classList.add('popins-bus');
      document.body.appendChild(this.container);
    }
    else {
      this.container = all[0];
    }
  }

  show(item){
    if (!this.shown.includes(item)){
      this.shown.push(item);
    }
    
    item.z = this.z + this.shown.length;
  }
  
  hide(item){
    let i = this.shown.indexOf(item);
    if (i !== -1){
      this.shown.splice(i, 1);
    }

    this.shown.forEach( (item, i) => {
      item.z = this.z + i;
    });
  }

  register(item) {
    let id = this.__uuid();
    this.container.appendChild(item);
    this.instances.push({ [id]: item });
    return id;
  }

  unregister(id) {
    let el = document.getElementById('popin-' + id);
    el && this.container.removeChild(el);
  }

  __uuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
}

/* harmony default export */ var bus = (new PopinBus());

// EXTERNAL MODULE: ../popins-popin/package.json
var popins_popin_package = __webpack_require__("2046");

// CONCATENATED MODULE: ../popins-popin/src/index.js




popin.meta = popins_popin_package

bus.install = function (Vue, options) {
  Vue.prototype.$popin = bus;
}


// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../popins-dropdown/src/dropdown.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var dropdownvue_type_script_lang_js_ = ({
  name: "PopinsDropdown",

  props: {},
  
  computed:{
    attrs(){
      return {
        class: this.classes
      }
    },

    classes() {
      return {
        'popins-dropdown': true,

        '-is-active': this.$attrs.visible
      }
    },

    popinAttrs(){
      let ret = {
        position: Position.BOTTOM_CENTER,
        direction: Direction.DOWN
      };

      return Object.assign(ret, this.$attrs);
    }
  }
});

// CONCATENATED MODULE: ../popins-dropdown/src/dropdown.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_dropdownvue_type_script_lang_js_ = (dropdownvue_type_script_lang_js_); 
// CONCATENATED MODULE: ../popins-dropdown/src/dropdown.vue





/* normalize component */

var dropdown_component = normalizeComponent(
  src_dropdownvue_type_script_lang_js_,
  dropdownvue_type_template_id_13e78a62_render,
  dropdownvue_type_template_id_13e78a62_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var dropdown = (dropdown_component.exports);
// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../popins-dropdown/src/list.vue?vue&type=template&id=2b95cd4e&
var listvue_type_template_id_2b95cd4e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popins-dropdown',_vm._b({},'popins-dropdown',_vm.attrs,false),[(_vm.searchable)?_c('forms-input',_vm._g({staticClass:"popins-list-dropdown__search",attrs:{"placeholder":_vm.placeholder},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}},_vm.listeners)):_vm._e(),_c('ul',{staticClass:"popins-list-dropdown__items"},_vm._l((_vm.filtered),function(option,index){return _c('li',{key:index,staticClass:"popins-list-dropdown__item",attrs:{"title":option.label}},[_vm._l((_vm.layout),function(l){return [(l === 'field')?_c('div',{key:l,staticClass:"popins-list-dropdown__item-field"},[(_vm.multiple)?_c('forms-checkbox',{attrs:{"id":option.__id,"size":_vm.size},on:{"change":_vm.onCheckboxChange},model:{value:(option.active),callback:function ($$v) {_vm.$set(option, "active", $$v)},expression:"option.active"}}):_c('forms-radio',{attrs:{"name":_vm.name,"id":option.__id,"size":_vm.size,"value":true},on:{"change":_vm.onRadioChange},model:{value:(option.active),callback:function ($$v) {_vm.$set(option, "active", $$v)},expression:"option.active"}})],1):_vm._e(),(l == 'label')?_c(_vm.getTypeForOption(option),_vm._g(_vm._b({key:l,tag:"component"},'component',_vm.getAttributesForOption(option),false),_vm.getListenersForOption(option)),[_vm._v(_vm._s(option.label))]):_vm._e()]})],2)}),0)],1)}
var listvue_type_template_id_2b95cd4e_staticRenderFns = []


// CONCATENATED MODULE: ../popins-dropdown/src/list.vue?vue&type=template&id=2b95cd4e&

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../forms-checkbox/src/checkbox.vue?vue&type=template&id=2a86d30b&
var checkboxvue_type_template_id_2a86d30b_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[(_vm.layout == 'block')?_c('div',{staticClass:"forms-checkbox__header"},[(_vm.hasLabel)?_c('forms-label',{staticClass:"forms-checkbox__label",attrs:{"rel":_vm.id},scopedSlots:_vm._u([{key:"before",fn:function(){return [_vm._t("before")]},proxy:true},{key:"after",fn:function(){return [_vm._t("after")]},proxy:true}],null,true)},[_vm._t("default")],2):_vm._e()],1):_vm._e(),_c('div',{staticClass:"forms-checkbox__body"},[(_vm.layout == 'inline-reverse')?_c('div',{staticClass:"forms-checkbox__header"},[(_vm.hasLabel)?_c('forms-label',{staticClass:"forms-checkbox__label",attrs:{"rel":_vm.id},scopedSlots:_vm._u([{key:"before",fn:function(){return [_vm._t("before")]},proxy:true},{key:"after",fn:function(){return [_vm._t("after")]},proxy:true}],null,true)},[_vm._t("default")],2):_vm._e()],1):_vm._e(),_c('div',{staticClass:"forms-checkbox__content"},[_c('input',_vm._g(_vm._b({directives:[{name:"autofocus",rawName:"v-autofocus",value:(_vm.autofocus),expression:"autofocus"}]},'input',_vm.inputAttrs,false),_vm.listeners)),_c('label',{staticClass:"forms-checkbox__display",attrs:{"for":_vm.id}},[(_vm.isToggle)?_c('div',{staticClass:"forms-checkbox__bg"}):_vm._e(),(_vm.isToggle)?_c('div',{staticClass:"forms-checkbox__track"}):_vm._e()])]),(_vm.layout == 'inline')?_c('div',{staticClass:"forms-checkbox__header"},[(_vm.hasLabel)?_c('forms-label',{staticClass:"forms-checkbox__label",attrs:{"rel":_vm.id},scopedSlots:_vm._u([{key:"before",fn:function(){return [_vm._t("before")]},proxy:true},{key:"after",fn:function(){return [_vm._t("after")]},proxy:true}],null,true)},[_vm._t("default")],2):_vm._e()],1):_vm._e()]),(_vm.errors && _vm.errors.length)?_c('div',{staticClass:"forms-checkbox__footer"},_vm._l((_vm.errors),function(e){return _c('forms-label',{key:e,staticClass:"forms-checkbox__label",attrs:{"rel":_vm.id,"intent":"danger"}},[_vm._v(_vm._s(e))])}),1):_vm._e()])}
var checkboxvue_type_template_id_2a86d30b_staticRenderFns = []


// CONCATENATED MODULE: ../forms-checkbox/src/checkbox.vue?vue&type=template&id=2a86d30b&

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../forms-checkbox/src/checkbox.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var checkboxvue_type_script_lang_js_ = ({
  name: 'FormsCheckbox',

  components: {
    FormsLabel: label
  },

  directives: {
    Autofocus: autofocus
  },

  model: {
    prop: 'checked',
    event: 'change'
  },

  props: {
    appearance: {
      type: String,
      default: Appearance.DEFAULT,
      values: [Appearance.DEFAULT, Appearance.TOGGLE],
      validator: (value) => [Appearance.DEFAULT, Appearance.TOGGLE].includes(value)
    },

    autocomplete: {
      type: Boolean,
      default: true
    },

    autofocus: {
      type: Boolean,
      default: false
    },

    checked: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    errors: {
      type: Array,
      property: String,
      default: () => []
    },

    id: {
      type: String,
      default: () => 'checkbox-' + Math.round( Math.random() * 9999 )
    },

    indeterminate: {
      type: Boolean,
      default: false
    },

    layout: {
      type: String,
      default: Layout.INLINE,
      values: Layout.ALL,
      validator: (value) => Layout.ALL.includes(value)
    },

    name: {
      type: String,
      default: () => 'checkbox-' + Math.round( Math.random() * 9999 )
    },

    readOnly: {
      type: Boolean,
      default: false
    },

    required: {
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: Size.M,
      values: Size.ALL,
      validator: value => Size.ALL.includes(value)
    },

    value: {
      default: false
    }
  },

  computed: {
    classes(){
      return {
        'forms-checkbox': true,

        '-view-default': this.appearance === Appearance.DEFAULT,
        '-view-toggle': this.appearance === Appearance.TOGGLE,

        '-is-disabled': this.disabled,
        '-is-indeterminate': this.indeterminate,
        '-is-invalid': this.errors && this.errors.length,
        '-is-read-only': this.readOnly,
        '-is-required': this.required,

        '-is-inline': this.layout === Layout.INLINE,
        '-is-inline-reverse': this.layout === Layout.INLINE_REVERSE,
        '-is-block': this.layout === Layout.BLOCK,

        '-xs': this.size === Size.XS,
        '-s': this.size === Size.S,
        '-m': this.size === Size.M,
        '-l': this.size === Size.L,

        '-no-label': this.hasLabel
      }
    },

    hasBefore(){
      return !!this.$slots.before;
    },

    hasLabel(){
      return !!this.$slots.default;
    },

    hasAfter(){
      return !!this.$slots.after;
    },

    inputAttrs(){
      return {
        autocomplete: this.autocomplete === true ? 'on' : null,
        autofocus: this.autofocus,
        class: "forms-checkbox__field",
        checked: this.checked,
        disabled: this.disabled,
        id: this.id,
        name: this.name,
        readonly: this.readOnly,
        ref: 'field',
        required: this.required,
        type: 'checkbox',
        value: this.value
      }
    },

    isToggle(){
      return this.appearance === Appearance.TOGGLE
    },

    listeners(){
      let _this = this;
      let ret = Object.assign({}, this.$listeners);
      ret = Object.assign(ret, {
          blur(event)  { _this.onBlur(event) },
          change(event){ _this.onChange(event) },
          focus(event) { _this.onFocus(event) },
        }
      )

      return ret;
    }
  },

  methods: {
    onBlur(event){
      this.$emit('blur', event);
    },
    onChange(event){
      this.$emit('change', event.currentTarget.checked, {name: this.name, id: this.id, value: this.value});
    },
    onFocus(event){
      this.$emit('focus', event);
    }
  }
});

// CONCATENATED MODULE: ../forms-checkbox/src/checkbox.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_checkboxvue_type_script_lang_js_ = (checkboxvue_type_script_lang_js_); 
// CONCATENATED MODULE: ../forms-checkbox/src/checkbox.vue





/* normalize component */

var checkbox_component = normalizeComponent(
  src_checkboxvue_type_script_lang_js_,
  checkboxvue_type_template_id_2a86d30b_render,
  checkboxvue_type_template_id_2a86d30b_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_checkbox = (checkbox_component.exports);
// EXTERNAL MODULE: ../forms-checkbox/package.json
var forms_checkbox_package = __webpack_require__("68aa");

// CONCATENATED MODULE: ../forms-checkbox/src/index.js



src_checkbox.meta = forms_checkbox_package

 

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../forms-input/src/input.vue?vue&type=template&id=581c7cba&
var inputvue_type_template_id_581c7cba_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('forms-control',_vm._b({class:_vm.classes,scopedSlots:_vm._u([{key:"before",fn:function(){return [_vm._t("before")]},proxy:true},{key:"default",fn:function(){return [_vm._t("default")]},proxy:true},{key:"after",fn:function(){return [_vm._t("after")]},proxy:true},{key:"prefix",fn:function(){return [_vm._t("prefix",[(_vm.iconPre && !_vm.isNumber)?_c(_vm.iconPreInteractive ? 'button' : 'div',_vm._g({tag:"component",staticClass:"forms-control__pre",class:{'-is-interactive': _vm.iconPreInteractive},attrs:{"disabled":_vm.iconPreDisabled}},_vm.iconPreListeners),[_c('ui-icon',{staticClass:"forms-control__icon",attrs:{"glyph":_vm.iconPre}})],1):_vm._e(),(_vm.isNumber)?_c('button',{staticClass:"forms-control__pre -is-interactive",attrs:{"disabled":_vm.iconPreDisabled || _vm.mined},on:{"click":_vm.decrease}},[_c('ui-icon',{staticClass:"forms-control__icon",attrs:{"glyph":"minus"}})],1):_vm._e()])]},proxy:true},{key:"content",fn:function(){return [(((_vm.inputAttrs).type)==='checkbox')?_c('input',_vm._g(_vm._b({directives:[{name:"autofocus",rawName:"v-autofocus",value:(_vm.autofocus),expression:"autofocus"},{name:"model",rawName:"v-model",value:(_vm.ivalue),expression:"ivalue"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.ivalue)?_vm._i(_vm.ivalue,null)>-1:(_vm.ivalue)},on:{"change":function($event){var $$a=_vm.ivalue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.ivalue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.ivalue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.ivalue=$$c}}}},'input',_vm.inputAttrs,false),_vm.listeners)):(((_vm.inputAttrs).type)==='radio')?_c('input',_vm._g(_vm._b({directives:[{name:"autofocus",rawName:"v-autofocus",value:(_vm.autofocus),expression:"autofocus"},{name:"model",rawName:"v-model",value:(_vm.ivalue),expression:"ivalue"}],attrs:{"type":"radio"},domProps:{"checked":_vm._q(_vm.ivalue,null)},on:{"change":function($event){_vm.ivalue=null}}},'input',_vm.inputAttrs,false),_vm.listeners)):_c('input',_vm._g(_vm._b({directives:[{name:"autofocus",rawName:"v-autofocus",value:(_vm.autofocus),expression:"autofocus"},{name:"model",rawName:"v-model",value:(_vm.ivalue),expression:"ivalue"}],attrs:{"type":(_vm.inputAttrs).type},domProps:{"value":(_vm.ivalue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ivalue=$event.target.value}}},'input',_vm.inputAttrs,false),_vm.listeners))]},proxy:true},{key:"suffix",fn:function(){return [_vm._t("suffix",[(_vm.iconPost && !_vm.clearable && !_vm.isNumber)?_c(_vm.iconPostInteractive ? 'button' : 'div',_vm._g({tag:"component",staticClass:"forms-control__post",class:{'-is-interactive': _vm.iconPostInteractive},attrs:{"disabled":_vm.iconPostDisabled}},_vm.iconPostListerners),[_c('ui-icon',{staticClass:"forms-control__icon",attrs:{"glyph":_vm.iconPost}})],1):_vm._e(),(_vm.clearable && _vm.value && _vm.value.length > 0)?_c('button',{staticClass:"forms-control__post -is-interactive forms-control__clear",on:{"click":_vm.onClear}},[_c('ui-icon',{staticClass:"forms-control__icon",attrs:{"glyph":"cross"}})],1):_vm._e(),(_vm.isNumber)?_c('button',{staticClass:"forms-control__post -is-interactive",attrs:{"disabled":_vm.iconPostDisabled || _vm.maxed},on:{"click":_vm.increase}},[_c('ui-icon',{staticClass:"forms-control__icon",attrs:{"glyph":"plus"}})],1):_vm._e(),(_vm.isSearch)?_c('ui-icon',{staticClass:"forms-control__post forms-control__icon",attrs:{"glyph":"search"}}):_vm._e()])]},proxy:true}],null,true)},'forms-control',_vm.$props,false))}
var inputvue_type_template_id_581c7cba_staticRenderFns = []


// CONCATENATED MODULE: ../forms-input/src/input.vue?vue&type=template&id=581c7cba&

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../forms-input/src/input.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var inputvue_type_script_lang_js_ = ({
  name: "FormsInput",

  components: {
    FormsLabel: label,
    UiIcon: icon,
    UiLoader: loader
  },

  directives: {
    Autofocus: autofocus
  },

  extends: control,

  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    appearance: {
      type: String,
      default: Appearance.DEFAULT,
      values: [Appearance.DEFAULT, Appearance.NONE],
      validator: (value) => [Appearance.DEFAULT, Appearance.NONE].includes(value)
    },

    autocomplete: {
      type: Boolean,
      default: true
    },

    autofocus: {
      type: Boolean,
      default: false
    },

    clearable: {
      type: Boolean,
      default: false
    },

    iconPre: {
      type: String
    },

    iconPreDisabled: {
      type: Boolean,
      default: false
    },

    iconPreInteractive: {
      type: Boolean,
      default: false
    },

    iconPost: {
      type: String
    },

    iconPostDisabled: {
      type: Boolean,
      default: false
    },

    iconPostInteractive: {
      type: Boolean,
      default: false
    },

    inputMode: {
      type: String,
      values: ['text', 'tel', 'url', 'email', 'numeric', 'decimal', 'search'],
      validator: (value) => ['text', 'tel', 'url', 'email', 'numeric', 'decimal', 'search'].includes(value)
    },

    max: {},

    min: {},

    name: {
      type: String,
      default: () => 'forms-control-' + Math.round( Math.random() * 9999999 )
    },

    pattern: {
      type: String
    },

    placeholder: {
      type: String
    },

    readOnly: {
      type: Boolean,
      default: false
    },

    step: {},

    type: {
      type: String,
      default: 'text',
      values: ['date', 'email', 'file', 'number', 'password', 'search', 'tel', 'text', 'time', 'url'],
      validator: (value) => ['date', 'email', 'file', 'number', 'password', 'search', 'tel', 'text', 'time', 'url'].includes(value)
    },

    value: {}
  },

  data(){
    return {
      ivalue: null
    }
  },

  watch: {
    value(val){
      this.ivalue = val;
    }
  },

  computed: {
    classes(){
      return {
        'forms-input': true,

        '-view-none': this.appearance === 'none',

        '-icon-pre': this.iconPre,
        '-icon-pre-disabled': this.iconPreDisabled,
        '-icon-pre-interactive': this.iconPreInteractive,
        '-icon-post': this.iconPost,
        '-icon-post-disabled': this.iconPostDisabled,
        '-icon-post-interactive': this.iconPostInteractive,

        '-is-required': this.required,
        '-is-read-only': this.readOnly,

        '-is-number': this.type === 'number',
        '-is-search': this.isSearch,

        '-has-prefix': this.hasPrefix,
        '-has-suffix': this.hasSuffix,
      }
    },

    iconPreListeners(){
      return this.iconPreInteractive ? {'click': (event) => this.onIconClick(event, 'pre') } : {};
    },

    iconPostListerners(){
      return this.iconPostInteractive ? {'click': (event) => this.onIconClick(event, 'post') } : {};
    },

    inputAttrs(){
      let ret = Object.assign({}, this.$attrs);
      ret = Object.assign(ret, {
        autocomplete: this.autocomplete === false ? 'off' : null,
        autofocus: this.autofocus,
        class: "forms-control__field",
        id: this.id,
        inputmode: this.inputMode,
        disabled: this.disabled,
        max: ['number'].includes(this.type) ? this.max : null,
        maxlength: ['text'].includes(this.type) ? this.max : null,
        min: this.min,
        name: this.name,
        pattern: this.pattern,
        placeholder: this.placeholder,
        readonly: this.readOnly,
        ref: 'field',
        required: this.required,
        step: this.step,
        type: this.type,
        value: this.value
      })

      return ret;
    },

    isSearch(){
      return this.type === 'search'
    },

    hasLabel(){
      return this.hasSlot('default');
    },

    hasPrefix(){
      return this.hasSlot('prefix');
    },

    hasSuffix(){
      return this.hasSlot('suffix');
    },

    isNumber(){
      return this.type === 'number'
    },

    listeners(){
      let _this = this;
      let ret = Object.assign({}, this.$listeners);
      ret = Object.assign(ret, {
        input(event){ _this.onInput(event) }
      });
      
      // if (this.$listeners.hasOwnProperty('blur')){
      //   ret.blur = (event) => { _this.onBlur(event) }
      // }

      // if (this.$listeners.hasOwnProperty('focus')){
      //   ret.focus = (event) => { _this.onFocus(event) }
      // }

      // if (this.$listeners.hasOwnProperty('keyup')){
      //   ret.keyup = (event) => { _this.onKeyUp(event) }
      // }

      return ret;
    },

    maxed(){
      let max = this.max || Number.MAX_SAFE_INTEGER;
      let value = parseFloat(this.ivalue);
      return value >= max;
    },

    mined(){
      let min = this.min || Number.MIN_SAFE_INTEGER;
      let value = parseFloat(this.ivalue);
      return value <= min;
    }
  },

  methods: {
    click(){
      try{
        this.$refs.field.click();
      }
      catch(e){
        console.log(e);
      }
    },

    decrease(){
      let min = this.min || Number.MIN_SAFE_INTEGER;
      let step = parseFloat(this.step) || 1;
      let value = parseFloat(this.ivalue);
      value = (value - step) > min ? value - step : min;
      this.$emit('input', value);
    },

    increase(){
      let max = this.max || Number.MAX_SAFE_INTEGER;
      let step = parseFloat(this.step) || 1;
      let value = parseFloat(this.ivalue) || 0;
      // value = (value + step) < max ? value + step : max;
      // console.log(value, step, value + step);
      value = value + step;
      this.$emit('input', value );
    },

    focus(){
      this.$refs.field.focus();
    },

    hasSlot(name){
      return !!this.$slots[name];
    },

    onClear(event){
      this.ivalue = '';
      this.$refs.field.focus();
      this.$emit('clear', event);
      this.$emit('input', this.ivalue);
    },
    
    onIconClick(event, position){
      this.$emit('iconClick', event, position);
    },
    
    onInput(event){
      this.$emit('input', this.ivalue);
    }
  },

  mounted() {
    this.ivalue = this.value;
  }
});

// CONCATENATED MODULE: ../forms-input/src/input.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_inputvue_type_script_lang_js_ = (inputvue_type_script_lang_js_); 
// CONCATENATED MODULE: ../forms-input/src/input.vue





/* normalize component */

var input_component = normalizeComponent(
  src_inputvue_type_script_lang_js_,
  inputvue_type_template_id_581c7cba_render,
  inputvue_type_template_id_581c7cba_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var input = (input_component.exports);
// EXTERNAL MODULE: ../forms-input/package.json
var forms_input_package = __webpack_require__("fdcd");

// CONCATENATED MODULE: ../forms-input/src/index.js



input.meta = forms_input_package



// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../forms-radio/src/radio.vue?vue&type=template&id=4a6be5cc&
var radiovue_type_template_id_4a6be5cc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[(_vm.layout == 'block')?_c('div',{staticClass:"forms-radio__header"},[(_vm.hasLabel)?_c('forms-label',{staticClass:"forms-radio__label",attrs:{"rel":_vm.id},scopedSlots:_vm._u([{key:"before",fn:function(){return [_vm._t("before")]},proxy:true},{key:"after",fn:function(){return [_vm._t("after")]},proxy:true}],null,true)},[_vm._t("default")],2):_vm._e()],1):_vm._e(),_c('div',{staticClass:"forms-radio__body"},[(_vm.layout == 'inline-reverse')?_c('div',{staticClass:"forms-radio__header"},[(_vm.hasLabel)?_c('forms-label',{staticClass:"forms-radio__label",attrs:{"rel":_vm.id},scopedSlots:_vm._u([{key:"before",fn:function(){return [_vm._t("before")]},proxy:true},{key:"after",fn:function(){return [_vm._t("after")]},proxy:true}],null,true)},[_vm._t("default")],2):_vm._e()],1):_vm._e(),_c('div',{staticClass:"forms-radio__content"},[_c('input',_vm._g(_vm._b({directives:[{name:"autofocus",rawName:"v-autofocus",value:(_vm.autofocus),expression:"autofocus"}]},'input',_vm.inputAttrs,false),_vm.listeners)),_c('label',{staticClass:"forms-radio__display",attrs:{"for":_vm.id}})]),(_vm.layout == 'inline')?_c('div',{staticClass:"forms-radio__header"},[(_vm.hasLabel)?_c('forms-label',{staticClass:"forms-radio__label",attrs:{"rel":_vm.id},scopedSlots:_vm._u([{key:"before",fn:function(){return [_vm._t("before")]},proxy:true},{key:"after",fn:function(){return [_vm._t("after")]},proxy:true}],null,true)},[_vm._t("default")],2):_vm._e()],1):_vm._e()]),(_vm.errors && _vm.errors.length)?_c('div',{staticClass:"forms-radio__footer"},_vm._l((_vm.errors),function(e){return _c('forms-label',{key:e,staticClass:"forms-radio__label",attrs:{"rel":_vm.id,"intent":"danger"}},[_vm._v(_vm._s(e))])}),1):_vm._e()])}
var radiovue_type_template_id_4a6be5cc_staticRenderFns = []


// CONCATENATED MODULE: ../forms-radio/src/radio.vue?vue&type=template&id=4a6be5cc&

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../forms-radio/src/radio.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var radiovue_type_script_lang_js_ = ({
  name: 'FormsRadio',
  inheritAttrs: false,

  components: {
    FormsLabel: label
  },

  directives: {
    Autofocus: autofocus
  },

  model: {
    event: 'change',
    prop: 'modelValue'
  },

  props: {
    appearance: {
      type: String,
      default: 'default',
      values: [Appearance.DEFAULT],
      validator: (value) => [Appearance.DEFAULT].includes(value)
    },

    autocomplete: {
      type: Boolean,
      default: true
    },

    autofocus: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    errors: {
      type: Array,
      property: String,
      default: () => []
    },

    id: {
      type: String,
      default: () => 'radio-' + Math.round( Math.random() * 9999 )
    },

    indeterminate: {
      type: Boolean,
      default: false
    },

    readOnly: {
      type: Boolean,
      default: false
    },

    required: {
      type: Boolean,
      default: false
    },

    label: {
      type: String,
      doc: 'Label'
    },

    layout: {
      type: String,
      default: Layout.INLINE,
      values: [Layout.BLOCK, Layout.INLINE, Layout.INLINE_BLOCK],
      validator: (value) => [Layout.BLOCK, Layout.INLINE, Layout.INLINE_BLOCK].includes(value)
    },

    name: {
      type: String,
      default: () => 'radio-' + Math.round( Math.random() * 9999 )
    },

    size: {
      type: String,
      default: Size.M,
      values: Size.ALL,
      validator: value => Size.ALL.includes(value)
    },

    value: {
    }
  },

  data(){
    return {
      modelValue: null
    }
  },

  computed: {
    checked(){
      return this.value === this.modelValue;
    },

    classes(){
      return {
        'forms-radio': true,

        '-is-disabled': this.disabled,
        '-is-indeterminate': this.indeterminate,
        '-is-invalid': this.errors && this.errors.length,
        '-is-read-only': this.readOnly,
        '-is-required': this.required,

        '-is-inline': this.layout === Layout.INLINE,
        '-is-inline-reverse': this.layout === Layout.INLINE_REVERSE,
        '-is-block': this.layout === Layout.BLOCK,

        '-xs': this.size === Size.XS,
        '-s': this.size === Size.S,
        '-m': this.size === Size.M,
        '-l': this.size === Size.L,

        '-no-label': this.hasLabel
      }
    },

    hasBefore(){
      return !!this.$slots.before;
    },

    hasLabel(){
      return !!this.$slots.default;
    },

    hasAfter(){
      return !!this.$slots.after;
    },

    inputAttrs(){
      return {
        autocomplete: this.autocomplete === true ? 'on' : null,
        autofocus: this.autofocus,
        class: "forms-radio__field",
        checked: this.checked,
        disabled: this.disabled,
        id: this.id,
        name: this.name,
        readonly: this.readOnly,
        ref: 'field',
        required: this.required,
        type: 'radio',
        value: this.value
      }
    },

    listeners(){
      let _this = this;
      let ret = Object.assign({}, this.$listeners);
      ret = Object.assign(ret, {
        blur(event)  { _this.onBlur(event) },
        change(event){ _this.onChange(event) },
        focus(event) { _this.onFocus(event) },
      })

      return ret;
    }
  },

  methods: {
    onBlur(event){
      this.$emit('blur', event);
    },
    onChange(event){
      this.$emit('change', this.value, {name: this.name, id: this.id});
    },
    onFocus(event){
      this.$emit('focus');
    }
  },

  mounted(){
    this.modelValue = this.$attrs.modelValue;
  }
});

// CONCATENATED MODULE: ../forms-radio/src/radio.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_radiovue_type_script_lang_js_ = (radiovue_type_script_lang_js_); 
// CONCATENATED MODULE: ../forms-radio/src/radio.vue





/* normalize component */

var radio_component = normalizeComponent(
  src_radiovue_type_script_lang_js_,
  radiovue_type_template_id_4a6be5cc_render,
  radiovue_type_template_id_4a6be5cc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_radio = (radio_component.exports);
// EXTERNAL MODULE: ../forms-radio/package.json
var forms_radio_package = __webpack_require__("df54");

// CONCATENATED MODULE: ../forms-radio/src/index.js



src_radio.meta = forms_radio_package



// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../popins-dropdown/src/list.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var listvue_type_script_lang_js_ = ({
  name: "PopinsListDropdown",

  components: {
    FormsCheckbox: src_checkbox,
    FormsInput: input,
    FormsRadio: src_radio,
    PopinsDropdown: dropdown
  },

  props: {
    ignoreCase: {
      type: Boolean,
      default: true
    },

    filter: {
      type: Function,
      default: (item) => item
    },
    
    layout: {
      type: Array,
      default: () => ['field', 'label']
    },

    multiple: {
      type: Boolean,
      default: false
    },

    name: {
      type: String,
      default: () => 'popins-list-dropdown-' + Math.round( Math.random() * 9999 )
    },

    options: {
      type: Array,
      required: true
    },

    placeholder: {
      type: String,
    },

    property: {
      type: String,
      default: 'label'
    },

    searchable: {
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: Size.M,
      values: [Size.M, Size.S],
      validator: (value) => [Size.M, Size.S].includes(value)
    },

    target:{},

    threshold: {
      type: Number,
      default: 0
    },

    visible: {
      type: Boolean,
      default: false
    }
  },

  data(){
    return {
      entries: [],
      filtered: [],
      search: '',
      selectedIndex: 0
    }
  },

  computed: {
    attrs(){
      let ret = {
        class: this.classes,
        visible: this.visible,
        target: this.target
      }

      return Object.assign(ret, this.$attrs); 
    },

    classes(){
      return {
        'popins-list-dropdown': true,
        '-s': this.size === Size.S
      }
    },

    listeners(){
      const vm = this;
      let ret = Object.assign({}, this.$listeners);
      ret = Object.assign(ret, {
          keyup(event){ vm.onKeyUp.call(vm, event) },
      });
      return ret;
    }
  },

  watch: {
    options(value){
      if (!value){
        return;
      }
      
      this.options.forEach(option => {
        option.__id = 'popins-list-dropdown-' + Math.round( Math.random() * 999999 )
      });
      this.filtered = value;
      this.update();
    },

    search(value){
      this.update();
    }
  },

  methods: {
    update(){
      if (!this.search || (this.search.length <= this.threshold && this.search.length !== 0)) {
        this.filtered = this.options;
      }

      let ret = this.options.filter(entry => {
        let e = entry[this.property];
        return this.ignoreCase ===  true ?
          e && e.toLowerCase().includes(this.search.toLowerCase()) :
          e && e.includes(this.search);
      });

      if(this.filter) {
        ret = ret.filter(this.filter);
      }

      this.selectedIndex = 0;

      this.filtered = ret;
    },
          
    up(){
      this.selectedIndex = this.selectedIndex - 1 < 0 ? this.filtered.length - 1 : this.selectedIndex -= 1;
    },

    down(){
      this.selectedIndex = this.selectedIndex + 1 > this.filtered.length - 1 ? 0 : this.selectedIndex += 1;
      },

    getTypeForOption(option){
      let ret = 'label';

      // href
      if (option.href){
        // Object => router-link
        if(typeof option.href === 'object'){
          ret = 'router-link'
        }

        // 
        if (typeof option.href === 'string'){
          let protocol = ['http://', 'https://', 'mailto://', 'tel://'].filter(protocol => option.href.indexOf(protocol) != -1);
          if (protocol.length > 0){
            ret = 'a'
          }
        }
      }

      return ret;
    },

    getAttributesForOption(option){
      let type = this.getTypeForOption(option);
      let classes = ['popins-list-dropdown__item-label'];
      let ret = {}

      if (type === 'label'){
        classes.push('-is-label')
        ret.for = option.__id;
      }

      if (type === 'router-link'){
        classes.push('-is-router')
        ret.to = option.href;
      }

      if (type === 'a'){
        classes.push('-is-link')
        ret.href = option.href;
        ret.target = '_blank';
        ret.rel = 'noopener noreferrer';
      }

      ret.class = classes.join(' ');

      return ret;
    },

    getListenersForOption(option){
      return option.hasOwnProperty('event') ? option.event : {};
    },

    selected(option){},

    onKeyUp(event){
      let char = event.which ? event.which : event.keyCode;

      // down
      if (char == KeyCode.DOWN_ARROW){
        event.preventDefault();
        this.down()
      }

      // up
      if (char == KeyCode.UP_ARROW){
        event.preventDefault();
        this.up();
      }

      // enter
      if (char == KeyCode.ENTER){
        event.preventDefault();
        this.select(this.selectedIndex);
      }

      // tab
      if (char == KeyCode.TAB){
        this.mousefocus = false;
      }
    },

    onCheckboxChange(checked, {name, id, value}){
      this.$emit('change', this.options, name);
    },

    onRadioChange(value, {name, id}){
      this.options.forEach(option => {
        option.active = option.__id === id;
      });

      this.$emit('change', this.options, name);
    }
  },

  created(){
    if (this.options){
      this.options.forEach(option => {
        option.__id = 'popins-list-dropdown-' + Math.round( Math.random() * 999999 );
        option.active = option.active || false;
      });

      this.filtered = this.options;
    }
  }
});

// CONCATENATED MODULE: ../popins-dropdown/src/list.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_listvue_type_script_lang_js_ = (listvue_type_script_lang_js_); 
// CONCATENATED MODULE: ../popins-dropdown/src/list.vue





/* normalize component */

var list_component = normalizeComponent(
  src_listvue_type_script_lang_js_,
  listvue_type_template_id_2b95cd4e_render,
  listvue_type_template_id_2b95cd4e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var list = (list_component.exports);
// EXTERNAL MODULE: ../popins-dropdown/package.json
var popins_dropdown_package = __webpack_require__("5266");

// CONCATENATED MODULE: ../popins-dropdown/src/index.js




dropdown.meta = popins_dropdown_package;
let m = Object.assign(popins_dropdown_package, {
  displayName: "ListDropdown"
});
list.meta = m;



// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../forms-select/src/select.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var selectvue_type_script_lang_js_ = ({
  name: "FormsSelect",

  components: {
    DataTag: tag,
    FormsLabel: label,
    PopinsListDropdown: list,
  },

  directives: {
    Autofocus: autofocus,
    ClickOutside: clickoutside
  },

  extends: control,

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    appearance: {
      type: String,
      default: 'default',
      values: [Appearance.DEFAULT],
      validator: (value) => [Appearance.DEFAULT].includes(value)
    },

    autocomplete: {
      type: Boolean,
      default: false
    },

    autofocus: {
      type: Boolean,
      default: false
    },

    collapsed: {
      type: Boolean,
      default: false
    },

    id: {
      type: String,
      default: () => 'forms-select-' + Math.round( Math.random() * 9999 )
    },

    max: {
      type: Number
    },

    multiple: {
      type: Boolean,
      default: false
    },

    options: {
      type: Array,
      default: () => []
    },

    placeholder: {
      type: String,
    },

    position: {
      type: String,
      default: Position.BOTTOM_CENTER,
      values: Position.ALL,
      validator: (value) => Position.ALL.includes(value)
    },

    readonly: {
      type: Boolean,
      default: false
    },

    max: {},

    min: {},

    name: {
      type: String,
      default: () => 'forms-select-' + Math.round( Math.random() * 9999 )
    },

    placeholder: {
      type: String,
      doc: 'placeholder'
    },

    value: {
      default: () => []
    }
  },

  data(){
    return {
      outside: {
        handler: this.onClickOutside,
        middleware: this.clickOutsideMiddleware
      },
      showOptions: false,
      optionKey: 0,
      dropdown: []
    }
  },

  computed: {
    classes(){
      return {
        'forms-select': true,

        '-is-multiple': this.multiple,
        '-is-collapsed': this.collapsed,

        '-is-active': this.showOptions,
      }
    },

    hasAfter(){
      return this.hasSlot('after');
    },

    hasBefore(){
      return this.hasSlot('before');
    },

    hasLabel(){
      return this.hasSlot('default');
    },

    listeners(){
      let _this = this;
      let ret = Object.assign({}, this.$listeners);
      ret = Object.assign(ret, {
        change(event){ _this.onChange(event) },
      });

      return ret;
    },

    selectAttrs(){
      return {
        autocomplete: this.autocomplete === true ? 'on' : null,
        autofocus: this.autofocus,
        class: "forms-control__field",
        id: this.id,
        disabled: this.disabled,
        name: this.name,
        readonly: this.readonly,
        ref: 'field',
        required: this.required,
        value: this.value
      }
    },

    displayedValues(){
      let ret = this.value ? this.value : [];
      if (this.collapsed && ret.length > 0){
        ret = [ret[0]];
      }
      return ret;
    },

    remaining(){
      return this.value && this.value.length > 0 ? this.value.length - 1 : 0;
    }
  },

  watch: {
    value(){
      this.reset();
    },

    options(){
      this.reset();
    }
  },

  methods: {
    focus(){
      let el = this.multiple ? this.$refs.content : this.$refs.field;
      if (el){
        el.focus();
      }
    },

    hasSlot(name){
      return !!this.$slots[name];
    },

    reset(){
      if (this.value && Array.isArray(this.value)) {
        this.dropdown = [];
        this.options.forEach( o => {
          let oo = JSON.parse(JSON.stringify(o));

          this.value.forEach(v => {
            if ( o.value === v.value ){
              oo.active = true;
            }
          })

          this.dropdown.push(oo);
        })
        
        this.optionKey++;
      }
    },

    toggleOptionsDropdown(event){
      if (event.target.className == 'data-tag__close'){
        return;
      }

      this.showOptions = !this.showOptions;
    },

    onChange(event){
      this.$emit('change', event.target.value);
    },

    onDropdownChange(options){
      let ret = options.filter( o => o.active );
      this.$emit('change', ret);
    },

    onTagClose(o){
      let i = this.value.indexOf(o);
      let ret = [...this.value];
      ret.splice(i, 1);
      this.$emit('change', ret);
    },

    clickOutsideMiddleware(event){
      let isSelect = this.$refs.select.contains(event.target) === false;
      let isDropdown = this.$refs.dropdown.$el.contains(event.target) === false;
      return isSelect && isDropdown;
    },

    onClickOutside (event) {
      this.showOptions = false;
    },
  },

  mounted(){
    this.reset();
  }
});

// CONCATENATED MODULE: ../forms-select/src/select.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_selectvue_type_script_lang_js_ = (selectvue_type_script_lang_js_); 
// CONCATENATED MODULE: ../forms-select/src/select.vue





/* normalize component */

var select_component = normalizeComponent(
  src_selectvue_type_script_lang_js_,
  selectvue_type_template_id_f2288b48_render,
  selectvue_type_template_id_f2288b48_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_select = (select_component.exports);
// EXTERNAL MODULE: ../forms-select/package.json
var forms_select_package = __webpack_require__("b2a5");

// CONCATENATED MODULE: ../forms-select/src/index.js



src_select.meta = forms_select_package


// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../data-pagination/src/pagination.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var paginationvue_type_script_lang_js_ = ({
  name: 'DataPagination',

  components: {
    ActionsButton: src_button,
    FormsSelect: src_select
  },
  
  model: {
    prop: 'currentPage',
    event: 'change'
  },

  props: {
    appearance: {
      type: String,
      default: Appearance.DEFAULT,
      values: [Appearance.DEFAULT]
    },

    currentPage: {
      type: Number,
      default: 1
    },

    disabled: {
      type: Boolean,
      default: false
    },

    hideOnSinglePage: {
      type: Boolean,
      default: true
    },

    layout: {
      type: Array,
      default: () => ["total", "prev", "pager", "next"],
      validator: (value) => {
        let ret = true;
        value.forEach((item) => {
          if (!["first", "jumper", "last", "next", "page-size", "pager", "prev", "total"].includes(item)){
            ret = false;
          }
        });

        return ret;
      }
    },

    margin: {
      type: Number,
      default: 2
    },

    pageSize:{
      type: Number,
      default: 10
    },

    pageSizes: {
      type: Array
    },

    range:{
      type: Number,
      default: 3
    },

    size: {
      type: String,
      default: Size.M,
      values: [Size.S, Size.M],
      validator: value => [Size.S, Size.M].includes(value)
    },

    total: {
      type: Number
    }
  },

  data(){
    return {
      _pageSize: this.pageSize
    }
  },

  computed: {
    classes(){
      return {
        'data-pagination': true,
        '-s': this.size === Size.S
      }
    },

    pages() {
      let ret = [];

      const setPageItem = index => {
        // ret[index] = index;
        ret.push(index);
      }

      const setPageSeparator = index => {
        // ret[index] = -1;
        ret.push(-1);
      }

      // User has only <range> pages
      if (this.nPages <= this.range){
        let i = 0;
        while( i++ < this.nPages ){
          setPageItem(i);
        }
      }

      // User is on any other pages
      else{
        let halfRange = Math.floor(this.range / 2);

        let rangeLow = 0;
        if (this.currentPage - halfRange > 0) {
          rangeLow = this.currentPage - 1 - halfRange;
        }

        let rangeHigh = rangeLow + this.range - 1;
        if (rangeHigh >= this.nPages) {
          rangeHigh = this.nPages - 1;
          rangeLow = rangeHigh - this.range + 1;
        }

        // 1st - loop thru low end of margin pages
        let i = 0;
        while( i++ < this.margin && i <= rangeLow ){
          setPageItem(i);
        }

        // 2nd - loop thru current range
        // Check if there is breakView in the left of selected range
        if (rangeLow > this.margin) {
          setPageSeparator(rangeLow - 1)
        }

        i = rangeLow;
        while( i++ <= rangeHigh && i <= this.nPages ){
          setPageItem(i);
        }

        // Check if there is breakView in the right of selected range
        if (rangeHigh + 1 < this.nPages - this.margin) {
          setPageSeparator(rangeHigh + 2)
        }

        // 3rd - loop thru high end of margin pages
        i = Math.max(rangeHigh + 1, this.nPages - this.margin); 
        while( i++ < this.nPages ){
          setPageItem(i);
        }
      }

      return ret.filter( r => r != undefined);
    },

    isFirstPage() {
      return this.currentPage <= 1;
    },

    hasJumper() {
      return this.nPages > 4;
    },

    isSinglePage(){
      return this.hideOnSinglePage && this.nPages == 1;
    },

    isLastPage(){
      return this.currentPage >= this.nPages;
    },

    nPages() {
      let ret = (this.total / this.pageSize) | 0;
      return (this.total % this.pageSize) > 0 ? ret + 1 : ret;
    },

    pageSizesOptions(){
      return this.pageSizes.map( item => {
        return {
          label: item,
          value: item
        }
      })
    }
  },

  methods: {
    change({ page, origin }){
      this.$emit('change', page, { event, origin: origin });
    },

    first(){
      this.change({
        page: 0,
        origin: 'first'
      });
    },

    last(event) {
      this.change({
        page: this.nPages,
        origin: 'last'
      });
    },

    next(event){
      this.change({
        page: this.currentPage + 1 < this.nPages ? this.currentPage + 1 : this.nPages,
        origin: 'next'
      });
    },

    prev(event){
      this.change({
        page: this.currentPage - 1 > 0 ? this.currentPage - 1 : 0,
        origin: 'prev'
      });
    },

    onPageChange(event, value){
      this.change({
        page: value ? value | 0 : event.target.value | 0,
        origin: 'pager'
      });
    },

    onPageSize(value){
      this.$emit('page-size', value | 0, this.currentPage);
    },
  },

  created() {
    this._pageSize = this.pageSize;
  }
});

// CONCATENATED MODULE: ../data-pagination/src/pagination.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_paginationvue_type_script_lang_js_ = (paginationvue_type_script_lang_js_); 
// CONCATENATED MODULE: ../data-pagination/src/pagination.vue





/* normalize component */

var pagination_component = normalizeComponent(
  src_paginationvue_type_script_lang_js_,
  paginationvue_type_template_id_76e6708b_render,
  paginationvue_type_template_id_76e6708b_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var pagination = (pagination_component.exports);
// EXTERNAL MODULE: ../data-pagination/package.json
var data_pagination_package = __webpack_require__("7431");

// CONCATENATED MODULE: ../data-pagination/src/index.js



pagination.meta = data_pagination_package



// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../data-table/src/table.vue?vue&type=template&id=335e5d4f&
var tablevue_type_template_id_335e5d4f_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({},'div',_vm.attrs,false),[(!_vm.isEmpty)?_c('div',{staticClass:"data-table__header"},[_c('div',{staticClass:"data-table__actions"},[(!_vm.hasSelection)?_vm._l((_vm.globalActions),function(action){return _c('actions-button',{key:_vm.getKeyForAction(action),attrs:{"disabled":_vm.loading,"size":"s"},on:{"click":function($event){return _vm.getPageActionClick(action)}}},[_vm._v(_vm._s(action.label))])}):_vm._e(),(_vm.isPartialSelection)?_vm._l((_vm.partialActions),function(action){return _c('actions-button',{key:_vm.getKeyForAction(action),attrs:{"disabled":_vm.loading,"size":"s"},on:{"click":function($event){return _vm.getPageActionClick(action)}}},[_vm._v(_vm._s(action.label))])}):_vm._e(),(_vm.isAllPagesSelected)?_vm._l((_vm.pagesActions),function(action){return _c('actions-button',{key:_vm.getKeyForAction(action),attrs:{"disabled":_vm.loading,"size":"s"},on:{"click":function($event){return _vm.getPageActionClick(action)}}},[_vm._v(_vm._s(action.label))])}):(_vm.isPageSelected)?_vm._l((_vm.pageActions),function(action){return _c('actions-button',{key:_vm.getKeyForAction(action),attrs:{"disabled":_vm.loading,"size":"s"},on:{"click":function($event){return _vm.getPageActionClick(action)}}},[_vm._v(_vm._s(action.label))])}):_vm._e(),(!_vm.hasSelection && _vm.hasFilters)?_c('div',{staticClass:"data-table__filters"},[_c('actions-button',{attrs:{"icon-pre":"filter","disabled":_vm.loading,"size":"s"},on:{"click":function($event){_vm.showFilters = !_vm.showFilters}}},[(_vm.nCurrentFilters > 0)?[_vm._v(_vm._s(_vm.nCurrentFilters))]:_vm._e()],2)],1):_vm._e()],2),(!_vm.hasSelection && _vm.searchable)?_c('div',{staticClass:"data-table__search"},[_vm._t("search",[_c('forms-input',{attrs:{"type":"search","disabled":_vm.loading,"size":"s","placeholder":"Search"},on:{"input":function($event){return _vm.onSearch($event)}}})],{"onInput":_vm.onSearch})],2):_vm._e()]):_vm._e(),_c('div',{staticClass:"data-table__body"},[_c('div',{staticClass:"data-table__loading"},[(_vm.loading)?_c('ui-loader',{attrs:{"size":"l"}}):_vm._e()],1),_c('table',{staticClass:"data-table__table"},[_c('thead',{staticClass:"data-table__head"},[_c('tr',[(_vm.isSelectable)?_c('th',{staticClass:"data-table__column data-table__select",attrs:{"scope":"col"}},[_c('forms-checkbox',{attrs:{"checked":_vm.isPageSelected,"indeterminate":_vm.isPartialSelection},on:{"click":_vm.toggleSelectAllInPage}})],1):_vm._e(),_vm._l((_vm.columns),function(col){return _c('th',_vm._g({key:col.fqn,class:_vm.getColumnClasses(col),attrs:{"scope":"col"}},_vm.getColumnListeners(col)),[_vm._v(_vm._s(col.label))])}),(_vm.hasSingleActions)?_c('th',{staticClass:"data-table__column data-table__action"}):_vm._e()],2)]),(!_vm.isEmpty)?_c('tbody',{staticClass:"data-table__body"},[(_vm.pagesSelectionAllowed && _vm.hasSelection)?_c('tr',[_c('td',{staticClass:"data-table__selectallpages",attrs:{"colspan":_vm.nColumns}},[_vm._t("select-pages",[(_vm.isAllPagesSelected)?_c('div',{staticClass:"data-table__selectallpages-content"},[_vm._v(" The "+_vm._s(_vm.nSelected)+" items have been selected. "),_c('button',{staticClass:"data-table__selectallpages-link",on:{"click":_vm.deselectAllPages}},[_vm._v("Erase the selection")])]):_c('div',{staticClass:"data-table__selectallpages-content"},[_vm._v(" "+_vm._s(_vm.nSelected)+" item(s) selected. "),_c('button',{staticClass:"data-table__selectallpages-link",on:{"click":_vm.selectAllPages}},[_vm._v("Click here to select all.")])])],{"nSelected":_vm.nSelected,"isAllPagesSelected":_vm.isAllPagesSelected,"selectAllPages":_vm.selectAllPages,"deselectAllPages":_vm.deselectAllPages})],2)]):_vm._e(),_vm._l((_vm.rows),function(row,i){return _c('tr',_vm._g({key:row.fqn,class:_vm.getRowClasses(row)},_vm.getRowListeners(row, i)),[(_vm.isSelectable)?_c('td',{staticClass:"data-table__cell data-table__select data-table__checkbox"},[(_vm.select > 0)?_c('forms-checkbox',{attrs:{"checked":_vm.isRowChecked(row)},on:{"change":function($event){return _vm.onRowSelection($event, row)}}}):_vm._e()],1):_vm._e(),_vm._l((row.data),function(cell,x){return _c('td',{key:cell.fqn,staticClass:"data-table__cell",class:_vm.getCellClasses(cell, x)},[(cell.component)?[_c(cell.component,_vm._b({tag:"component"},'component',cell,false))]:[_vm._v(_vm._s(cell.content))]],2)}),(_vm.hasSingleActions)?_c('td',{staticClass:"data-table__cell data-table__action"},[_c('actions-button',{staticClass:"data-table__action-button",attrs:{"icon-pre":"dot-dot-dot","size":"s"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.toggleRowActions($event, row)}}})],1):_vm._e()],2)})],2):_c('tbody',[_c('tr',{staticClass:"data-table__empty"},[_c('td',{attrs:{"colspan":_vm.nColumns}},[_vm._t("empty",[_c('data-empty',{attrs:{"title":"Empty","description":"The current parameters yield to no results."}})])],2)])])])]),(!_vm.isEmpty)?_c('div',{staticClass:"data-table__footer"},[_vm._t("pagination",[_c('data-pagination',_vm._b({on:{"change":_vm.onPageChange,"page-size":_vm.onSizeChange}},'data-pagination',_vm.iPagination,false))])],2):_vm._e(),_c('popins-list-dropdown',{attrs:{"visible":_vm.showRowAction,"layout":['label'],"options":_vm.rowActions,"target":_vm.currentRowAction,"position":"bottom-center"}}),(!_vm.isEmpty)?_c('popins-filters',{attrs:{"filters":_vm.filters,"visible":_vm.showFilters},on:{"close":function($event){_vm.showFilters = false},"change":_vm.onFilterChange}}):_vm._e()],1)}
var tablevue_type_template_id_335e5d4f_staticRenderFns = []


// CONCATENATED MODULE: ../data-table/src/table.vue?vue&type=template&id=335e5d4f&

// CONCATENATED MODULE: ../data-table/src/table-actions.js


/* harmony default export */ var table_actions = ({
  data() {
    return {
      currentRowAction: null,
      currentRow: null,
      showRowAction: false,
      showPageAction: false,
      showPagesAction: false,
    }
  },

  computed: {
    hasActions() {
      return this.actions && this.actions.length;
    },

    hasGlobalActions() {
      return this.globalActions.length > 0;
    },

    hasPageActions() {
      return this.pageActions.length > 0;
    },

    hasPagesActions() {
      return this.pagesActions.length > 0;
    },

    hasPartialActions() {
      return this.partialActions.length > 0;
    },

    hasSingleActions() {
      return this.singleActions.length > 0;
    },

    globalActions() {
      return this.hasActions ? this.actions.filter(action => action.mode & Action.GLOBAL) : [];
    },

    partialActions() {
      return this.hasActions ? this.actions.filter(action => action.mode & Action.SOME) : [];
    },

    pageActions() {
      return this.hasActions ? this.actions.filter(action => action.mode & Action.PAGE) : [];
    },

    pagesActions() {
      return this.hasActions ? this.actions.filter(action => action.mode & Action.PAGES) : [];
    },

    singleActions() {
      return this.hasActions ? this.actions.filter(action => action.mode & Action.SINGLE) : [];
    },

    rowActions() {
      let ret = this.singleActions.map(action => {
        let r = {
          label: action.label,
        }

        if (action.action) {
          r.event = {
            click: () => {
              this.showRowAction = false;
              action.action(this.currentRow);
            }
          }
        }

        if (action.href) {
          r.href = action.href;
        }

        return r;
      });

      return ret;
    }
  },

  methods: {
    getKeyForAction(action){
      return `${action.label}-${(Math.random() * 99999) | 0}` 
    },

    getPageActionClick(action) {
      if (action.action) {
        action.action(this.selection);
      }

      this.deselectAllPages();
    },

    toggleRowActions(event, row) {
      if (this.currentRow == row) {
        this.showRowAction = false;
        this.currentRow = null;
        return;
      }

      this.currentRow = row;
      this.currentRowAction = event.currentTarget;
      this.showRowAction = true;
    }
  }
});

// CONCATENATED MODULE: ../data-table/src/table-columns.js


/* harmony default export */ var table_columns = ({
    computed: {
        nColumns() {
            let ret = this.visibleColumns.length;

            if ([Selection.PAGE, Selection.PAGES].includes(this.select)) {
                ret++;
            }

            if (this.hasSingleActions) {
                ret++;
            }

            return ret;
        },

        visibleColumns() {
            return this.columns.filter(col => !col.hasOwnProperty('visible') || col.visible == true)
        },
    },

    methods: {
        getColumnClasses(col) {
            return {
                'data-table__column': true,

                '-s': col.size === 's',
                '-m': col.size === 'm',
                '-l': col.size === 'l',

                '-is-visible': this.isColumnVisible(col),

                '-is-sortable': this.isColumnSortable(col),
                '-sort-asc': this.isColumnSortable(col) && this.getColumnSort(col) === Sort.ASC,
                '-sort-desc': this.isColumnSortable(col) && this.getColumnSort(col) === Sort.DESC,

                '-type-string': !col.type || (col.type && col.type) === 'String',
                '-type-number': col.type && col.type === 'Number',
                '-type-date': col.type && col.type === 'Date',
                '-type-boolean': col.type && col.type === 'Boolean'
            }
        },

        getColumnListeners(col) {
            let ret = {};
            if (this.isColumnSortable(col)) {
                ret.click = this.onColumnSort.bind(this, col);
            }

            return ret;
        },

        getColumnSort(col) {
            let index = Sort.ALL.indexOf(col.sort);
            if (index == -1) {
                index = 0;
            }
            return Sort.ALL[index];
        },

        isColumnVisible(col) {
            return col.hasOwnProperty('visible') ? col.visible : true;
        },

        isColumnSortable(col) {
            return col.hasOwnProperty('sortable') && col.sortable === true || false
        },

        onColumnSort(col, event) {
            let index = Sort.ALL.indexOf(col.sort);
            if (index == -1) {
                index = 0;
            }

            let next = index + 1 < Sort.ALL.length ? index + 1 : 0;
            col.sort = Sort.ALL[next];
            this.$emit('sort', { event, direction: col.sort, fqn: col.fqn });
        },
    }
});

// CONCATENATED MODULE: ../data-table/src/table-filters.js


/* harmony default export */ var table_filters = ({
    
    data() {
        return {
            showFilters: false,
            currentFilters: null
        }
    },

    computed: {
        filters() {
            let ret = [];

            this.columns.forEach(column => {
                if (column.hasOwnProperty('filters')){
                    ret.push({
                        column: column,
                        filters: column.filters,
                        fqn: column.fqn,
                        priority: column.filters.priority || Priority.MEDIUM
                    })
                }
            })

            return ret;
        },
        
        hasFilters(){
            return this.filters && this.filters.length;
        },

        hasPriorityFilters(){
            return this.priorityFilters && this.priorityFilters.length;
        },
        
        nCurrentFilters(){
            return this.currentFilters ? this.currentFilters.length : 0;
        },

        priorityFilters() {
            return this.filters.filter(f => {
                return [Priority.HIGH, Priority.HIGHEST].includes(f.priority);
            })
        },
    },
    
    methods: {
        onFilterChange(data){
            this.currentFilters = data;
            this.$emit('filter', data);
        }
    }
});

// CONCATENATED MODULE: ../data-table/src/table-rows.js
/* harmony default export */ var table_rows = ({
    computed: {
        isEmpty() {
            return this.rows.length == 0;
        },
    },

    methods: {
        getRowListeners(row, index) {
            let ret = {};
            
            // Prevent misunderstanding a click on checkbox for a click on a row
            const onRowClick = (row) => {
                let c = event && event.target.className;

                if (c.indexOf('checkbox') === -1 && row.event && row.event.click){
                    row.event.click();
                }
            }

            ret.click = onRowClick.bind(null, row);

            return Object.assign( Object.assign({}, row.event), ret );
        },

        getRowClasses(row){
          return {
            'data-table__row': true,

            '-is-interactive': row.event && row.event.hasOwnProperty('click')
          }

          return ret;
        },

        getCellClasses(cell, colIndex){
            let col = this.columns[colIndex];
            let type = col && col.type ? col.type : 'String';

            let ret = {
                '-type-string': type === 'String',
                '-type-number': type === 'Number',
                '-type-date': type === 'Date',
                '-type-boolean': type === 'Boolean'
            };

            return ret;
        },

        isRowChecked(row) {
            return this.selection.includes(row);
        }
    }
});

// CONCATENATED MODULE: ../data-table/src/table-selection.js


/* harmony default export */ var table_selection = ({
  data() {
    return {
      selection: [],
      allPagesSelected: false,
    }
  },

  computed: {
    nSelected() {
      return this.selection.length
    },

    hasSelection() {
      return this.nSelected > 0;
    },

    pageSelectionAllowed() {
      return this.select === Selection.PAGE;
    },

    pagesSelectionAllowed() {
      return this.select === Selection.PAGES;
    },

    isSelectable() {
      return [Selection.PAGE, Selection.PAGES].includes(this.select);
    },

    isPartialSelection() {
      let n = this.selection.length;
      return n > 0 && n < this.rows.length;
    },

    isPageSelected() {
      return this.selection.length === this.rows.length;
    },

    isAllPagesSelected() {
      return this.isPageSelected && this.select == Selection.PAGES && this.allPagesSelected;
    },
  },

  methods: {
    selectAllInPage() {
      this.selection = [...this.rows];
      this.$emit('selection', { event, rows: this.selection, mode: Selection.PAGE });
    },

    selectAllPages() {
      this.selection = [...this.rows];
      this.allPagesSelected = true;
      this.$emit('selection', { event, rows: this.selection, mode: Selection.PAGES });
    },

    deselectAllInPage() {
      this.selection = [];
      this.$emit('selection', { event, rows: this.selection, mode: Selection.PAGE });
    },

    deselectAllPages() {
      this.selection = [];
      this.allPagesSelected = false;
      this.$emit('selection', { event, rows: this.selection, mode: Selection.PAGES });
    },

    onRowSelection(event, row) {
      // event.preventDefault();
      // event.stopImmediatePropagation();

      if (!row.hasOwnProperty('fqn')) {
        console.warn('spices.pepper.data-table', 'Missing required property fqn. The selection functionnality might not work properly.');
        return;
      }

      let rdata = this.rows.filter(r => row.fqn === r.fqn)[0];
      let i = this.selection.indexOf(rdata);
      i == -1 ? this.selection.push(row) : this.selection.splice(i, 1);

      this.$emit('selection', event, this.selection, Selection.SOME);
    },

    toggleSelectAllInPage() {
      this.isPageSelected ?
        this.deselectAllPages() :
        this.selectAllInPage();
    },
  }
});

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../data-table/src/popins-filters.vue?vue&type=template&id=38c20e04&
var popins_filtersvue_type_template_id_38c20e04_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popins-modal',{attrs:{"klass":{ 'popins-filters': true },"closable":false,"visible":_vm.visible},on:{"close":_vm.close},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',{staticClass:"row"},[_c('h1',{staticClass:"popins-filters__title"},[_vm._v("Filters")]),_c('actions-button',{attrs:{"icon-pre":"cross","size":"s"},on:{"click":_vm.close}})],1)]},proxy:true},{key:"footer",fn:function(){return [_c('actions-button',{attrs:{"appearance":"subtle","intent":"danger"},on:{"click":_vm.clear}},[_vm._v("Clear all filters")]),_c('div',{staticClass:"group"},[_c('actions-button',{on:{"click":_vm.close}},[_vm._v("Cancel")]),_c('actions-button',{attrs:{"appearance":"primary","disabled":!_vm.isValid},on:{"click":_vm.save}},[_vm._v("Apply")])],1)]},proxy:true}])},[_vm._l((_vm.childs),function(child,i){return _c('data-filter',{key:i,attrs:{"fields":_vm.fields,"operators":child.operators,"values":child.values,"layout":['field', 'operator', 'value', 'remove'],"type":"string","value":child}})}),(_vm.current)?_c('data-filter',{attrs:{"fields":_vm.fields,"layout":['field', 'operator', 'value', 'add'],"operators":_vm.currentOperators,"type":"string"},on:{"add":_vm.addFilter},model:{value:(_vm.current),callback:function ($$v) {_vm.current=$$v},expression:"current"}}):_vm._e()],2)}
var popins_filtersvue_type_template_id_38c20e04_staticRenderFns = []


// CONCATENATED MODULE: ../data-table/src/popins-filters.vue?vue&type=template&id=38c20e04&

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../data-table/src/popins-filters.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var popins_filtersvue_type_script_lang_js_ = ({
    name: "PopinsFilters",

    props: {
        filters: {
            type: Array
        },

        visible: {
            type: Boolean,
            default: false
        }
    },

    data(){
        return {
            current: null,
            childs: []
        }
    },

    computed: {
        fields(){
            let ret = [];

            this.filters.forEach(filter => {
                ret.push({
                    label: filter.column.label,
                    value: filter.fqn
                })
            })

            return ret;
        },

        currentColumn(){
            let ret = this.filters.filter( f => f.fqn === this.current.field);
            return ret.length ? ret[0] : null;
        },

        currentOperators(){
            let operators = this.currentColumn ? this.currentColumn.filters.operators : [];
            return operators.map( o => {
                return {label: o, value:o}
            });
        },

        isValid(){
            return true;
            //return this.childs && this.childs.length;
        }
    },

    methods: {
        save(){ 
            this.$emit('change', this.childs);
            this.close();
        },

        clear(){
            this.childs = [];
            this.reset();
        },

        close(){
            this.$emit('close');
        },

        getOperatorsForColumn( column ){
            console.log('getOperators', column);
        },

        reset(){
            this.current = {
                field: null,
                operator: null,
                value: null
            };
        },

        addFilter(data){
            this.childs.push({
                column: this.currentColumn,
                operators: this.currentOperators,
                values: null,

                field: data.field,
                operator: data.operator,
                value: data.value
            });

            this.reset();
        }
    },

    mounted(){
        this.reset();
    }
});

// CONCATENATED MODULE: ../data-table/src/popins-filters.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_popins_filtersvue_type_script_lang_js_ = (popins_filtersvue_type_script_lang_js_); 
// CONCATENATED MODULE: ../data-table/src/popins-filters.vue





/* normalize component */

var popins_filters_component = normalizeComponent(
  src_popins_filtersvue_type_script_lang_js_,
  popins_filtersvue_type_template_id_38c20e04_render,
  popins_filtersvue_type_template_id_38c20e04_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var popins_filters = (popins_filters_component.exports);
// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../data-table/src/table.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






 










/* harmony default export */ var tablevue_type_script_lang_js_ = ({
  name: 'DataTable',

  components: {
    ActionsButton: src_button,
    DataPagination: pagination,
    FormsCheckbox: src_checkbox,
    FormsInput: input,
    FormsSelect: src_select,
    PopinsFilters: popins_filters,
    PopinsListDropdown: list
  },

  mixins: [
    table_actions, 
    table_columns,
    table_filters,
    table_rows,
    table_selection
  ],

  props: {
    actions: {
      type: Array,
    },

    appearance: {
      type: String,
      default: Appearance.DEFAULT
    },

    columns: {
      type: Array,
      required: true,
      validator: (values) => {
        return values.filter(value => {
          return value.hasOwnProperty('fqn');
        }).length === values.length;
      }
    },

    layout: {
      type: Object,
      default: () => {
        return {
          header: ['filters', 'search', 'pagination'],
          body: ['table'],
          footer: ['pagination']
        }
      },
      validator: (values) => {
        let ret = true;

        Object.values(values).forEach(items => {
          items.forEach(item => {
            if(!['filters', 'search', 'pagination', 'table'].includes(item)) {
              ret = false;
            }
          });
        });

        return ret;
      }
    },

    loading: {
      type: Boolean,
      default: false
    },

    pagination: {
      type: Object
    },

    rows: {
      type: Array,
      required: true
    },

    searchable: {
      type: Boolean,
      default: false
    },

    select: {
      type: Number,
      default: 0
    }
  },

  computed: {
    attrs(){
      return {
        class: this.classes
      }
    },

    classes(){
      return {
        'data-table': true,

        '-is-loading': this.loading === true
      }
    },

    iPagination(){
      let ret = Object.assign({}, this.pagination);
      ret = Object.assign(ret, {
        size: this.size
      });

      return ret;
    }
  },

  methods: {
    onPageChange(event, page) {
      this.$emit('page', event, page)
    },

    onSizeChange(event, pageSize) {
      this.$emit('sizeChange', event, pageSize);
    },

    onSearch(value) {
      this.$emit('search', null, value);
    },
  }
});

// CONCATENATED MODULE: ../data-table/src/table.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_tablevue_type_script_lang_js_ = (tablevue_type_script_lang_js_); 
// CONCATENATED MODULE: ../data-table/src/table.vue





/* normalize component */

var table_component = normalizeComponent(
  src_tablevue_type_script_lang_js_,
  tablevue_type_template_id_335e5d4f_render,
  tablevue_type_template_id_335e5d4f_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var table = (table_component.exports);
// EXTERNAL MODULE: ../data-table/package.json
var data_table_package = __webpack_require__("08d2");

// CONCATENATED MODULE: ../data-table/src/index.js


table.meta = data_table_package



// CONCATENATED MODULE: ../pepper-pepper/src/components/data.js







// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../forms-autocomplete/src/autocomplete.vue?vue&type=template&id=62f4df44&
var autocompletevue_type_template_id_62f4df44_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('forms-control',_vm._b({directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.outside),expression:"outside"}],ref:"control",class:_vm.classes,on:{"click":_vm.focus},scopedSlots:_vm._u([{key:"before",fn:function(){return [_vm._t("before")]},proxy:true},{key:"default",fn:function(){return [_vm._t("default")]},proxy:true},{key:"after",fn:function(){return [_vm._t("after")]},proxy:true},{key:"prefix",fn:function(){return [_vm._t("prefix")]},proxy:true},{key:"content",fn:function(){return [(_vm.multiple)?_vm._l((_vm.value),function(v,i){return _c('data-tag',{key:i,staticClass:"forms-autocomplete__value",attrs:{"closable":"","interactive":"","size":_vm.size,"value":v},on:{"close":_vm.onTagClose}},[_vm._v(_vm._s(_vm.labelForEntry(v)))])}):_vm._e(),(((_vm.inputAttrs).type)==='checkbox')?_c('input',_vm._g(_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.term),expression:"term"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.term)?_vm._i(_vm.term,null)>-1:(_vm.term)},on:{"change":function($event){var $$a=_vm.term,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.term=$$a.concat([$$v]))}else{$$i>-1&&(_vm.term=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.term=$$c}}}},'input',_vm.inputAttrs,false),_vm.listeners)):(((_vm.inputAttrs).type)==='radio')?_c('input',_vm._g(_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.term),expression:"term"}],attrs:{"type":"radio"},domProps:{"checked":_vm._q(_vm.term,null)},on:{"change":function($event){_vm.term=null}}},'input',_vm.inputAttrs,false),_vm.listeners)):_c('input',_vm._g(_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.term),expression:"term"}],attrs:{"type":(_vm.inputAttrs).type},domProps:{"value":(_vm.term)},on:{"input":function($event){if($event.target.composing){ return; }_vm.term=$event.target.value}}},'input',_vm.inputAttrs,false),_vm.listeners)),_c('popins-popin',{ref:"dropdown",staticClass:"forms-autocomplete",attrs:{"visible":_vm.showSuggestions,"position":"bottom-center","width":"100%","target":_vm.$refs.control,"transition":"bottom"}},[_c('div',{staticClass:"forms-autocomplete__suggestions"},[(_vm.count > 0 && !_vm.loading)?_vm._t("results",_vm._l((_vm.filtered),function(entry,i){return _c('button',_vm._b({key:i,on:{"click":function($event){return _vm.select(i)}}},'button',_vm.itemAttrs(i),false),[_vm._t("result",[(entry.parts)?_vm._l((entry.parts),function(part,i){return _c('span',{key:i,class:{ 'forms-autocomplete__part': !part.term, 'forms-autocomplete__term': part.term }},[_vm._v(_vm._s(part.label))])}):[_vm._v(_vm._s(entry[_vm.property]))]],{"value":entry})],2)}),{"data":_vm.filtered,"attrs":_vm.itemAttrs,"select":_vm.select,"selectedClass":_vm.itemSelectedClass}):_vm._e(),(_vm.loading)?_c('div',{staticClass:"forms-autocomplete__loading"},[_c('ui-loader',{attrs:{"size":_vm.size}})],1):_vm._e(),(_vm.count === 0 && !_vm.loading && _vm.allowAdd)?_c('div',{staticClass:"forms-autocomplete__add"},[_c('button',_vm._b({on:{"click":_vm.onAddClick}},'button',_vm.itemAttrs(0),false),[_vm._v(_vm._s(_vm.term)+" "),_c('div',{staticClass:"forms-autocomplete__hint"},[_vm._v("+ Add")])])]):_vm._e(),(_vm.count === 0 && !_vm.loading && !_vm.allowAdd)?_c('div',{staticClass:"forms-autocomplete__noresults"},[_vm._t("no-results",[_vm._v("No matching result")],{"search":_vm.term})],2):_vm._e()],2)])]},proxy:true},{key:"suffix",fn:function(){return [_vm._t("suffix")]},proxy:true}],null,true)},'forms-control',_vm.$props,false))}
var autocompletevue_type_template_id_62f4df44_staticRenderFns = []


// CONCATENATED MODULE: ../forms-autocomplete/src/autocomplete.vue?vue&type=template&id=62f4df44&

// CONCATENATED MODULE: ../forms-autocomplete/src/data.js
/* harmony default export */ var data = ({ 
  methods: {
    /**
     * Commit a value. (Save)
     * @param {*} value 
     */
    commitValue(value){
      let ret = null;
      
      if (this.multiple){
        ret = [ ...this.value ];

        if (!this.hasValue(value)){
          ret.push(value)
        }
      }
      else{
        ret = value;
      }

      if (ret){
        this.propagateInput(ret);
        this.propagateChange(ret);
        this.updateSuggestions();
      }
    },

    /**
     * Whether the given value is already part of the set or not
     * @param {*} value 
     * @return {Boolean}
     */
    hasValue(value){
      return this.multiple ? this.value.includes(value) : this.value === value;
    },

    /**
     * Convert the given string to an object
     * @param {String} value 
     * @return {Object}
     */
    termToValue(value){
      let ret = { isNew: true };
      ret[this.property] = value || this.term;
      return ret;
    },

    /**
     * Toggle the given value
     * @param {*} value 
     */
    toggleValue(value){
      this.hasValue(value) ? this.commitValue(value) : this.removeValue(value);
    },

    propagateInput(value){
      this.$emit('input', value);
    },

    propagateChange(value){
      this.$emit('change', value);

      this.$nextTick(() => {
        // AutoHide
        if (this.autoHide) {
          this.focused = false;
        }

        // AutoClear
        if (this.autoClear) {
          this.term = '';
        }
      })
    },

    /**
     * Remove the value from the selected values
     * @param {*} value 
     */
    removeValue(value){
      let ret = null;

      if (this.multiple){
        ret = [...this.value];

        let i = ret.indexOf(value);
        if (i != -1){
          ret.splice(i, 1);
        }
      }

      this.propagateInput(ret);
      this.propagateChange(ret);
      this.updateSuggestions();
    }
  }
});

// CONCATENATED MODULE: ../forms-autocomplete/src/input.js


/* harmony default export */ var src_input = ({

  data(){
    return {
      term: '',
    }
  },

  computed: {
    inputAttrs() {
      return {
        type: 'text',
        class: 'forms-control__field',
        placeholder: this.placeholder,
        ref: 'input'
      }
    },

    listeners() {
      let _this = this;
      let ret = {
        change(event)  { _this.onFieldChange(event) },
        focus(event)   { _this.onFieldFocus(event) },
        keyup(event)   { _this.onFieldKeyUp.call(_this, event) },
      }

      return ret;
    },

  },

  watch: {
    term(newValue) {
      this.updateSuggestions();
      this.propagateInput(this.term);
    }
  },

  methods: {
    onFieldChange(event) {
      event.preventDefault();
    },

    onFieldFocus(event) {
      this.focused = true;
      this.updateSuggestions();
      this.$emit('focus', new Event('focus'));
    },

    onFieldKeyUp(event) {
      let char = event.which ? event.which : event.keyCode;
      this.focused = true;

      // down
      if (char == KeyCode.DOWN_ARROW) {
        event.preventDefault();
        this.moveDown()
      }

      // up
      if (char == KeyCode.UP_ARROW) {
        event.preventDefault();
        this.moveUp();
      }

      // enter
      if (char == KeyCode.ENTER) {
        event.preventDefault();

        console.log('enter', this.hasSuggestions, this.selectedIndex);

        // Is there a selection ?
        if (this.hasSuggestions && this.selectedIndex != -1) {
          this.select(this.selectedIndex);
        }

        // Is there a value
        else if (this.term.length > 0 && this.allowAdd) {
          this.commitValue(this.termToValue());
        }
      }

      // tab
      if (char == KeyCode.TAB) {
        this.cancel();
      }

      // escape
      if (char == KeyCode.ESCAPE) {
        this.cancel();
      }
    },
  }
});

// CONCATENATED MODULE: ../forms-autocomplete/src/suggestion.js


/* harmony default export */ var suggestion = ({

  data() {
    return {
      entries: [],
      filtered: [],
      selectedIndex: -1,
    }
  },

  computed: {
    count() {
      return this.filtered ? this.filtered.length : 0;
    },

    hasSuggestions() {
      return this.count > 0;
    },

    showSuggestions() {
      return this.focused;
    },
  },

  watch: {
    options(value) {
      this.entries = this.filtered = value;
      this.updateSuggestions();
    },
  },

  methods: {

    /**
     * Cancel the display of the suggestions
     */
    cancel() {
      if (!this.focused) {
        return;
      }

      this.$emit('cancel', new Event('cancel'));
      this.focused = false;

      if (!this.multiple){
        this.term = this.value && this.value.hasOwnProperty(this.property) ? this.value[this.property] : '';
      }
    },

    /**
     * Compute the parts of a suggestion item
     * 
     */
    computeSuggestionParts(item) {
      /**
       *  [
       *  {label: 'Central of '},
       *  {label: 'Af', term: true},
       *  {label: 'rique'}
       * ]
       */

      if (!item.hasOwnProperty(this.property)) {
        console.warn('[@spices/pepper - Forms.Autocomplete]', 'The property (%s) is not present in the dataset', this.property);
      }

      let ret = [];
      let oterm = item[this.property];
      let term = this.caseSensitive === false ? oterm.toLowerCase() : oterm;
      let search = this.term || '';
      search = this.caseSensitive === false ? search.toLowerCase() : search;
      let length = search.length;
      let start = 0;
      let index;

      // Empty string
      if (length == 0) {
        ret.push({
          label: oterm
        });
        return ret;
      }

      while ((index = term.indexOf(search, start)) > -1) {
        ret.push({
          label: oterm.substring(start, index)
        });

        ret.push({
          label: oterm.substring(index, index + length),
          term: true
        });

        start = index + length;
      }

      if (ret.length > 0) {
        ret.push({
          label: oterm.substr(start)
        })
      }

      // Pattern not found
      if (ret.length == 0) {
        ret.push({
          label: oterm
        });
        return ret;
      }

      return ret;
    },

    /**
     *  Suggestion Item Attributes
     */
    itemAttrs(index) {
      return {
        class: this.itemClasses(index)
      }
    },

    /**
     * Suggestion Item Classes
     * 
     * @param {Number} index 
     */
    itemClasses(index) {
      let ret = Object.assign({}, this.itemSelectedClass(index));
      ret = Object.assign(ret, {
        'forms-autocomplete__entry': true,
      });
      return ret
    },

    itemSelectedClass(index) {
      return { "-is-selected": index === this.selectedIndex };
    },

    labelForEntry(entry){
      return entry && entry.hasOwnProperty(this.property) ? entry[this.property] : '';
    },

    moveDown() {
      if (this.selectedIndex + 1 > this.filtered.length - 1) {
        this.selectedIndex = 0;
      } else {
        this.selectedIndex += 1;
      }
    },

    moveUp() {
      if (this.selectedIndex - 1 < 0) {
        this.selectedIndex = this.filtered.length - 1;
      } else {
        this.selectedIndex -= 1;
      }
    },

    onAddClick(){
      this.commitValue(this.termToValue());
    },

    propagateSelection(entry, value){
      this.$emit("selected", entry, value);
    },

    select(index) {
      if (this.hasSuggestions) {
        let entry = this.filtered[index]
        let value = entry[this.property];

        this.propagateSelection(entry, value);
        this.commitValue(entry);
        this.focus();
      }
    },

    updateSuggestions() {
      if (
        this.term === undefined || !isString(this.term) || (this.term.length <= this.threshold && this.term.length !== 0)) {
        return
      }

      // Provide the filtered entries
      let ret = null;
      let p = null;
      let t = this.caseSensitive === false ? this.term.toLowerCase() : this.term;

      if (this.provider) {
        p = Promise.resolve(this.provider(t));
      }
      else {
        let d = this.entries || [];
        p = Promise.resolve(d.filter(entry => {
          let e = entry[this.property] || '';
          let hasValue = false

          if (this.caseSensitive === false) {
            e = e.toLowerCase();
          }

          if (this.multiple){
            // Check if the value already exists
            this.value.forEach(v => {
              v = this.caseSensitive === false ? v[this.property].toLowerCase() : v[this.property];

              if (v === e){
                hasValue = true
              }
            })
          }

          return this.multiple ? !this.value.includes(entry) && !hasValue && e.includes(t) : e.includes(t);
        }));
      }

      Promise.resolve(p).then(data => {
        // Find all the parts
        data.forEach(item => {
          item.parts = this.computeSuggestionParts(item);
        });

        this.selectedIndex = -1;
        this.filtered = data;
      });
    },
  }
});

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../forms-autocomplete/src/autocomplete.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var autocompletevue_type_script_lang_js_ = ({
  name: "FormsAutocomplete",

  components: {
    FormsControl: control,
    PopinsPopin: popin
  },

  directives: {
    ClickOutside: clickoutside
  },

  extends: control,

  mixins: [
    data,
    src_input,
    suggestion
  ],

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    allowAdd: {
      type: Boolean,
      default: false
    },

    autoClear: {
      type: Boolean,
      default: false
    },

    autoFill: {
      type: Boolean,
      default: true
    },

    autoHide: {
      type: Boolean,
      default: true
    },

    caseSensitive: {
      type: Boolean,
      default: false
    },

    multiple: {
      type: Boolean,
      default: false
    },

    options: {
      type: Array
    },

    placeholder: {
      type: String
    },

    property: {
      type: String,
      default: 'label'
    },

    provider: {
      type: Function
    },

    threshold: {
      type: Number,
      default: 0
    },

    value: {
      type: [Object, Array]
    },
  },

  data(){
    return {
      focused: false,
      outside: {
        handler: this.onClickOutside,
        middleware: this.clickOutsideMiddleware
      },
      searching: false,
    }
  },

  computed: {
    classes(){
      return {
        'forms-autocomplete': true,
        '-icon-pre': this.iconPre,
        '-icon-pre-disabled': this.iconPreDisabled,
        '-icon-pre-interactive': this.iconPreInteractive,
        '-icon-post': this.iconPost,
        '-icon-post-disabled': this.iconPostDisabled,
        '-icon-post-interactive': this.iconPostInteractive,

        '-has-prefix': this.prefix && this.prefix.length > 0,
        '-has-suffix': this.suffix && this.suffix.length > 0,

        '-is-active': this.showSuggestions === true
      }
    },
    
  },

  watch: {
    provider(value){
      this.updateSuggestions();
    },

    value(newValue){
      if (!this.multiple){
        this.term = newValue == null ? '' : newValue[this.property];
      }

      this.updateSuggestions();
    },    
  },

  methods: {

    /**
     * Set the focus on the field
     */
    focus(){
      this.$refs.input.focus();
    },

    clickOutsideMiddleware(event){
      let isSelf = this.$el.contains(event.target) === false;
      let isDropdown = this.$refs.dropdown.$el.contains(event.target) === false;
      return isSelf && isDropdown;
    },

    onClickOutside (event) {
      this.cancel();
    },

    onTagClose(value){
      this.removeValue(value);
    }
  },

  mounted() {
    if (this.provider){
      this.updateSuggestions();
    }
    else{
      this.entries = this.options;
      this.filtered = this.entries;
    }

    if (!this.multiple){
      this.term = this.value == null ? '' : this.value[this.property];
    }
  }
});

// CONCATENATED MODULE: ../forms-autocomplete/src/autocomplete.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_autocompletevue_type_script_lang_js_ = (autocompletevue_type_script_lang_js_); 
// CONCATENATED MODULE: ../forms-autocomplete/src/autocomplete.vue





/* normalize component */

var autocomplete_component = normalizeComponent(
  src_autocompletevue_type_script_lang_js_,
  autocompletevue_type_template_id_62f4df44_render,
  autocompletevue_type_template_id_62f4df44_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var autocomplete = (autocomplete_component.exports);
// EXTERNAL MODULE: ../forms-autocomplete/package.json
var forms_autocomplete_package = __webpack_require__("41f3");

// CONCATENATED MODULE: ../forms-autocomplete/src/index.js



autocomplete.meta = forms_autocomplete_package



// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../forms-choice/src/choice.vue?vue&type=template&id=4097b5b2&
var choicevue_type_template_id_4097b5b2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[(_vm.has('default'))?_c('div',{staticClass:"forms-choice__header"},[_c('forms-label',{staticClass:"forms-choice__label",attrs:{"rel":_vm.id},scopedSlots:_vm._u([{key:"before",fn:function(){return [_vm._t("before")]},proxy:true},{key:"after",fn:function(){return [_vm._t("after")]},proxy:true}],null,true)},[_vm._t("default")],2)],1):_vm._e(),_c('div',{staticClass:"forms-choice__body"},_vm._l((_vm.options),function(option){return _c(_vm.fieldIs,_vm._g(_vm._b({key:option.label,tag:"component",attrs:{"value":option}},'component',_vm.fieldAttrs(option),false),_vm.fieldListeners),[_c('div',{staticClass:"forms-choice__item-label"},[_vm._v(_vm._s(option.label))]),(option.description)?_c('div',{staticClass:"forms-choice__item-description"},[_vm._v(_vm._s(option.description))]):_vm._e()])}),1),(_vm.errors && _vm.errors.length)?_c('div',{staticClass:"forms-choice__footer"},_vm._l((_vm.errors),function(e){return _c('forms-label',{key:e,staticClass:"forms-choice__label",attrs:{"rel":_vm.id,"intent":"danger"}},[_vm._v(_vm._s(e))])}),1):_vm._e()])}
var choicevue_type_template_id_4097b5b2_staticRenderFns = []


// CONCATENATED MODULE: ../forms-choice/src/choice.vue?vue&type=template&id=4097b5b2&

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../forms-choice/src/choice.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var choicevue_type_script_lang_js_ = ({
  name: "FormsChoice",

  components: {
    FormsCheckbox: src_checkbox,
    FormsLabel: label,
    FormsRadio: src_radio
  },

  mixins: [
    slot
  ],

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    appearance: {
      type: String,
      default: 'default',
      values: [Appearance.DEFAULT],
      validator: (value) => [Appearance.DEFAULT].includes(value)
    },

    disabled: {
      type: Boolean,
      default: false
    },

    errors: {
      type: Array,
      property: String,
      default: () => []
    },

    id: {
      type: String,
      default: () => 'choice-' + Math.round( Math.random() * 9999 )
    },

    max: {
      type: Number,
      default: -1
    },

    multiple: {
      type: Boolean,
      default: false
    },

    name: {
      type: String,
      default: () => 'choice-' + Math.round( Math.random() * 9999 )
    },

    options: {
      type: Array,
      required: true
    },

    required: {
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: Size.M,
      values: [Size.S, Size.M, Size.L],
      validator: value => [Size.S, Size.M, Size.L].includes(value)
    },

    value: {}
  },

  computed: {
    classes(){
      return {
        'forms-choice': true,

        '-is-disabled': this.disabled,
        '-is-required': this.required,
        '-is-invalid': this.errors && this.errors.length,

        '-s': this.size === Size.S,
        '-m': this.size === Size.M,
        '-l': this.size === Size.L,

        '-no-label': !this.has('default')
      }
    },
    
    fieldIs(){
      return this.multiple === true ? 'forms-checkbox' : 'forms-radio';
    },

    fieldListeners(){
      let ret = {
        change: this.multiple === true ? this.onFieldCheckboxChange : this.onFieldRadioChange
      };

      return ret;
    },

    maxed(){
      return Array.isArray(this.value) && this.max != -1 && this.value.length >= this.max;
    }
  },

  methods: {
    fieldAttrs(option){
      let ret = {
        class: "forms-choice__field",
        disabled: this.disabled,
        name: this.name,
        value: this.value
      }

      // set the checked for the checkbox
      if (this.multiple === true){
        ret.checked = this.value.includes(option);
        ret.disabled = this.disabled || (!ret.checked && this.maxed)
      }

      // set the modelValue for the radio
      else{
        ret.modelValue = this.value;
      }

      return ret;
    },

    onFieldRadioChange(value){
      this.$emit('change', value);
    },
    
    onFieldCheckboxChange(checked, value){
      let opt = value.value;
      let index = this.value.indexOf(opt);

      let ret = [...this.value];

      if (checked === false && index != -1){
        ret.splice(index, 1);
      }

      if (checked === true && index == -1){
        ret.push(opt);
      }

      this.$emit('change', ret);
    }
  },
});

// CONCATENATED MODULE: ../forms-choice/src/choice.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_choicevue_type_script_lang_js_ = (choicevue_type_script_lang_js_); 
// CONCATENATED MODULE: ../forms-choice/src/choice.vue





/* normalize component */

var choice_component = normalizeComponent(
  src_choicevue_type_script_lang_js_,
  choicevue_type_template_id_4097b5b2_render,
  choicevue_type_template_id_4097b5b2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var choice = (choice_component.exports);
// EXTERNAL MODULE: ../forms-choice/package.json
var forms_choice_package = __webpack_require__("ff3f");

// CONCATENATED MODULE: ../forms-choice/src/index.js



choice.meta = forms_choice_package



// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../forms-iterable/src/iterable.vue?vue&type=template&id=f595e3ca&
var iterablevue_type_template_id_f595e3ca_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({},'div',_vm.attrs,false),[(_vm.hasLabel)?_c('div',{staticClass:"forms-iterable__header"},[_c('forms-label',{staticClass:"forms-iterable__label",attrs:{"rel":_vm.id},scopedSlots:_vm._u([{key:"before",fn:function(){return [_vm._t("before")]},proxy:true},{key:"after",fn:function(){return [_vm._t("after")]},proxy:true}],null,true)},[_vm._t("default")],2)],1):_vm._e(),_c('div',{staticClass:"forms-iterable__body"},[_c('div',{staticClass:"forms-iterable__labels"},_vm._l((_vm.options),function(entry){return _c('forms-label',{key:entry.property,staticClass:"forms-iterable__label"},[_vm._v(_vm._s(entry.label))])}),1),_vm._l((_vm.value),function(val,i){return _c('article',{key:i,staticClass:"forms-iterable__entry"},[_c('div',{staticClass:"forms-iterable__entry-items"},_vm._l((_vm.options),function(entry,index){return _c(_vm.isForEntry(entry),_vm._g(_vm._b({key:entry.property,tag:"component",model:{value:(val[entry.property]),callback:function ($$v) {_vm.$set(val, entry.property, $$v)},expression:"val[entry.property]"}},'component',_vm.attrsForEntry(entry, index),false),_vm.listenersForEntry(entry)))}),1),_c('div',{staticClass:"forms-iterable__entry-actions"},[_c('actions-button',{staticClass:"forms-iterable__remove",attrs:{"icon-pre":"minus"},on:{"click":function($event){return _vm.onRemoveValue(val, i)}}})],1)])}),_c('article',{staticClass:"forms-iterable__entry -is-new"},[_c('div',{staticClass:"forms-iterable__entry-items"},_vm._l((_vm.options),function(entry){return _c(_vm.isForEntry(entry),_vm._g(_vm._b({key:entry.property,tag:"component",model:{value:(_vm.data[entry.property]),callback:function ($$v) {_vm.$set(_vm.data, entry.property, $$v)},expression:"data[entry.property]"}},'component',_vm.attrsForEntry(entry),false),_vm.listenersForEntry(entry)))}),1),_c('div',{staticClass:"forms-iterable__entry-actions"},[_c('actions-button',{staticClass:"forms-iterable__add",attrs:{"icon-pre":"plus","disabled":true}})],1)])],2)])}
var iterablevue_type_template_id_f595e3ca_staticRenderFns = []


// CONCATENATED MODULE: ../forms-iterable/src/iterable.vue?vue&type=template&id=f595e3ca&

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../forms-iterable/src/iterable.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var iterablevue_type_script_lang_js_ = ({
  name: 'FormsIterable',

  components: {
    ActionsButton: src_button,
    FormsCheckbox: src_checkbox,
    FormsInput: input,
    FormsSelect: src_select
  },

  model: {
    prop: 'value', 
    event: 'change'
  },

  props: {
    appearance: {
      type: String,
      default: Appearance.DEFAULT
    },

    disabled: {
      type: Boolean,
      default: false
    },

    id: {
      type: String,
      default: () => 'forms-iterable-' + Math.round( Math.random() * 9999999 )
    },

    options: {
      type: Array,
      required: true,
      validator: value => {
        let ret = true;
        value.forEach(option => {
          if (!option.property){
            console.warn('[@spices/pepper - FormsIterable]', 'Missing property for option', option);
            ret = false;
          }
        })

        return ret;
      }
    },

    size: {
      type: String,
      default: Size.M,
      values: [Size.S, Size.M],
      validator: value => [Size.S, Size.M].includes(value)
    },

    value: {}
  },

  data() {
    return {
      data: {}
    }
  },

  computed: {
    attrs(){
      return {
        class: this.classes,
        disabled: this.disabled === true
      }
    },

    classes(){
      return {
        'forms-iterable': true,

        '-s': this.size === Size.S,

        '-is-disabled': this.disabled === true,
        '-no-label': !this.hasLabel
      }
    },

    hasAfter(){
      return this.hasSlot('after');
    },

    hasBefore(){
      return this.hasSlot('before');
    },

    hasLabel(){
      return this.hasSlot('default');
    },

    listeners(){
      return {
        change: this.onFormComplete 
      }
    },
  },

  methods: {
    attrsForEntry(entry, index = -1) {
      let ret = Object.assign({}, entry);
      ret = Object.assign(ret, {
        class: this.classesForEntry(entry),
        ref: index == -1 ? entry.property : `${entry.property}-${index}`,
        required: true,
        size: this.size,
        type: this.typeForEntry(entry),
      });

      return ret;
    },

    classesForEntry(entry){
      return {
        'forms-iterable__entry-item': true
      }
    },

    hasSlot(name){
      return !!this.$slots[name];
    },

    isForEntry(entry) {
      let ret = 'forms-input';

      switch (entry.type) {
        case Boolean:
          ret = 'forms-checkbox';
          break;
        case Array:
          ret = 'forms-select';
          break;
      }

      if (entry.component){
        ret = entry.component
      }

      return ret;
    },

    labelForValue(entry, i) {
      let ret = '';

      if(i === 0) {
        ret = entry.label;
      }

      return ret;
    },

    listenersForEntry(entry){
      let events = entry.events || {};
      let ret = Object.assign({}, events);
      ret = Object.assign(ret, this.listeners);

      return ret;
    },

    typeForEntry(entry) {
      let ret = 'text';

      switch (entry.type) {
        case Number:
          ret = 'number';
          break;
        case Date:
          ret = 'date';
          break;
      }

      return ret;
    },

    onFormComplete() {
      let ret = true;

      this.options.forEach(o => {
        if(['', 0, null, undefined].includes(this.data[o.property])) {
          ret = false;
        }
      })

      if(ret) {
        let first = this.options[0].property;
        let comp = this.$refs[first];

        if (comp && comp.hasOwnProperty('focus')){
          comp.focus();
        }
        else{
          console.log('[@spices/pepper - FormsIterable]', 'focus methods not implemented for component', comp);
        }
        this.$emit('change', [...this.value, this.data]);
        this.data = {};
      }
    },

    onRemoveValue(value, index) {
      let data = [ ...this.value ];
      data.splice(index, 1);

      this.$emit('change', data);
    }
  }
});

// CONCATENATED MODULE: ../forms-iterable/src/iterable.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_iterablevue_type_script_lang_js_ = (iterablevue_type_script_lang_js_); 
// CONCATENATED MODULE: ../forms-iterable/src/iterable.vue





/* normalize component */

var iterable_component = normalizeComponent(
  src_iterablevue_type_script_lang_js_,
  iterablevue_type_template_id_f595e3ca_render,
  iterablevue_type_template_id_f595e3ca_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var iterable = (iterable_component.exports);
// EXTERNAL MODULE: ../forms-iterable/package.json
var forms_iterable_package = __webpack_require__("a18e");

// CONCATENATED MODULE: ../forms-iterable/src/index.js



iterable.meta = forms_iterable_package



// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../forms-list/src/list.vue?vue&type=template&id=2c10af5e&
var listvue_type_template_id_2c10af5e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({},'div',_vm.attrs,false),[(_vm.hasActions || _vm.add)?_c('div',{staticClass:"forms-list__header"},[(_vm.add)?_c('div',{staticClass:"forms-list__add"},[_vm._t("add",[_c('forms-autocomplete',{attrs:{"auto-clear":true,"auto-fill":false,"icon-post":"search","disabled":_vm.isDisabled,"placeholder":_vm.placeholder,"provider":_vm.provider,"size":_vm.size},on:{"change":_vm.onAddChange,"focus":_vm.hideActions}})])],2):_vm._e(),(_vm.add && _vm.hasHeaderActions)?_c('div',{staticClass:"forms-list__actionscta"},[_c('actions-button',{ref:"actionscta",attrs:{"disabled":_vm.isDisabled,"icon-pre":"dot-dot-dot","size":_vm.size},on:{"click":_vm.toggleGlobalActions}})],1):_vm._e(),(!_vm.add && _vm.hasHeaderActions)?_c('div',{staticClass:"forms-list__actions"},_vm._l((_vm.headerActions),function(action){return _c('actions-button',{key:_vm.getKeyForAction(action),attrs:{"disabled":_vm.isDisabled,"size":_vm.size},on:{"click":function($event){return _vm.getPageActionClick(action)}}},[_vm._v(_vm._s(action.label))])}),1):_vm._e()]):_vm._e(),_c('div',{staticClass:"forms-list__body"},[_c('div',{staticClass:"forms-list__loading"},[(_vm.loading)?_c('ui-loader',{attrs:{"size":"l"}}):_vm._e()],1),(_vm.isEmpty)?_c('div',{staticClass:"forms-list__empty"},[_vm._t("empty",[_c('data-empty',{attrs:{"title":"No results","description":"The current parameters yield to no results.","size":_vm.size}})])],2):_c('ul',{ref:"list",staticClass:"forms-list__content"},_vm._l((_vm.value),function(entry,i){return _c('li',{key:i,staticClass:"forms-list__entry"},[(_vm.isSelectable && !_vm.isSorting)?_c('div',{staticClass:"forms-list__entry-selection"},[(_vm.select > 0)?_c('forms-checkbox',{attrs:{"checked":_vm.isEntryChecked(entry),"size":_vm.size},on:{"change":function($event){return _vm.onSelection($event, entry)}}}):_vm._e()],1):_vm._e(),(_vm.isSorting)?_c('div',{staticClass:"forms-list__entry-sort"},[_c('button',{staticClass:"forms-list__entry-handle"})]):_vm._e(),_c('div',_vm._g({staticClass:"forms-list__entry-body"},_vm.entryListeners(entry)),[_vm._t("entry",[_vm._v(_vm._s(entry[_vm.property]))],{"entry":entry})],2),(!_vm.isSorting && _vm.hasSingleActions)?_c('div',{staticClass:"forms-list__entry-action"},[_c('actions-button',{attrs:{"icon-pre":"dot-dot-dot","size":_vm.size},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.toggleEntryActions($event, entry)}}})],1):_vm._e()])}),0)]),(!_vm.isEmpty)?_c('footer',{staticClass:"forms-list__footer"},[_c('div',{staticClass:"forms-list__count"},[_vm._t("count",[_vm._v(_vm._s(_vm.countLabel))],{"nEntries":_vm.nEntries,"nSelected":_vm.nSelected})],2)]):_vm._e(),_c('popins-list-dropdown',{attrs:{"visible":_vm.showEntryAction,"layout":['label'],"options":_vm.entryDropdownActions,"size":_vm.size,"target":_vm.currentEntryAction}}),_c('popins-list-dropdown',{attrs:{"visible":_vm.showGlobalAction,"layout":['label'],"options":_vm.headerDropdownActions,"size":_vm.size,"target":_vm.$refs.actionscta}})],1)}
var listvue_type_template_id_2c10af5e_staticRenderFns = []


// CONCATENATED MODULE: ../forms-list/src/list.vue?vue&type=template&id=2c10af5e&

// CONCATENATED MODULE: ../forms-list/src/list-actions.js


/* harmony default export */ var list_actions = ({
  data() {
    return {
      currentEntryAction: null,
      currentEntry: null,
      showEntryAction: false,
      showGlobalAction: false,
      showPageAction: false,
      showPagesAction: false,
    }
  },

  computed: {
    hasActions() {
      return this.actions && this.actions.length;
    },

    hasGlobalActions() {
      return this.globalActions.length > 0;
    },

    hasHeaderActions(){
      return this.headerActions.length > 0;
    },

    hasPageActions() {
      return this.pageActions.length > 0;
    },

    hasPagesActions() {
      return this.pagesActions.length > 0;
    },

    hasPartialActions() {
      return this.partialActions.length > 0;
    },

    hasSingleActions() {
      return this.singleActions.length > 0;
    },

    globalActions() {
      let ret = this.hasActions ? this.actions.filter(action => action.mode & Action.GLOBAL) : [];

      if (this.sortable && !this.isSorting){
        ret.push(this.sortAction);
      }
      else if (this.sortable && this.isSorting){
        ret = [this.confirmAction];
      }

      return ret;
    },

    partialActions() {
      return this.getActionsForMask(Action.SOME);
    },
    
    pageActions() {
      return this.getActionsForMask(Action.PAGE);
    },
    
    pagesActions() {
      return this.getActionsForMask(Action.PAGES);
    },
    
    singleActions() {
      return this.getActionsForMask(Action.SINGLE);
    },

    entryDropdownActions() {
      return this.actionListToDropdown(this.singleActions, this.currentEntry);
    },

    headerActions(){
      let mask = 0;
      // mask += !this.hasSelection && !this.isEmpty ? Action.SINGLE : 0;
      mask += !this.hasSelection ? Action.GLOBAL : 0;
      mask += this.isPartialSelection && !this.isEmpty ? Action.SOME : 0;
      mask += this.isPageSelected && !this.isEmpty ? Action.PAGE : 0;
      mask += this.isAllPagesSelected && !this.isEmpty ? Action.PAGES : 0;

      let ret = this.getActionsForMask(mask);
      if (this.sortable && !this.isSorting) {
        ret.push(this.sortAction);
      }
      else if (this.sortable && this.isSorting) {
        ret = [this.confirmAction];
      }

      return ret;
    },

    headerDropdownActions(){
      return this.actionListToDropdown(this.headerActions, this.selection);
    }
  },

  methods: {
    actionListToDropdown(list, args){
      return list.map(action => {
        let r = {
          label: action.label,
        }

        if (action.action) {
          r.event = {
            click: () => {
              this.showEntryAction = false;
              this.showGlobalAction = false;
              action.action(args);
            }
          }
        }

        if (action.href) {
          r.href = action.href;
        }

        return r;
      });
    },

    getActionsForMask(mask){
      return this.hasActions ? this.actions.filter(action => action.mode & mask) : [];
    },

    getKeyForAction(action) {
      return `${action.label}-${(Math.random() * 99999) | 0}`
    },

    getPageActionClick(action) {
      if (action.action) {
        action.action(this.selection);
      }
      
      this.hasSelection && this.deselectAllPages();
    },

    hideActions(){
      this.hideEntryActions();
      this.hideGlobalAction();
    },

    hideGlobalAction(){
      this.showGlobalAction = false;
    },

    hideEntryActions(){
      this.showEntryAction = false;
      this.currentEntry = null;
    },

    displayEntryAction(entry){
      this.currentEntry = entry;
      this.currentEntryAction = event.currentTarget;
      this.showEntryAction = true;
    },

    displayGlobalAction(){
      this.showGlobalAction = true;
    },

    toggleEntryActions(event, entry) {
      if (this.showEntryAction){
        this.hideEntryActions();
      }
      else{
        this.displayEntryAction(entry);
        this.hideGlobalAction();
      }
    },

    toggleGlobalActions(event){
      this.showGlobalAction ? this.hideGlobalAction() : this.displayGlobalAction();
      this.hideEntryActions();
    }
  }
});

// CONCATENATED MODULE: ../forms-list/src/list-add.js
/* harmony default export */ var list_add = ({
  methods: {
    onAddChange(value, entry){
      let ret = [ ...this.value ];
      let n = entry ? entry : value;
      ret.push(n);

      this.$emit('add', n, ret);
    }
  }
});

// CONCATENATED MODULE: ../forms-list/src/list-selection.js


/* harmony default export */ var list_selection = ({
  data() {
    return {
      selection: [],
      allPagesSelected: false,
    }
  },

  computed: {
    countLabel(){
      return this.hasSelection ? `${this.nSelected}/${this.nEntries} entrie(s) selected` : `${this.nEntries} entries`;
    },

    hasSelection() {
      return this.nSelected > 0;
    },

    isSelectable() {
      return [Selection.PAGE, Selection.PAGES].includes(this.select);
    },

    isPartialSelection() {
      let n = this.selection.length;
      return n > 0 && n < this.value.length;
    },

    isPageSelected() {
      return this.selection.length === this.value.length;
    },

    isAllPagesSelected() {
      return this.isPageSelected && this.select == Selection.PAGES && this.allPagesSelected;
    },

    nSelected() {
      return this.selection.length
    },

    pageSelectionAllowed() {
      return this.select === Selection.PAGE;
    },

    pagesSelectionAllowed() {
      return this.select === Selection.PAGES;
    },    
  },

  methods: {
    selectAllInPage() {
      this.selection = [...this.value];
      this.$emit('selection', { event, rows: this.selection, mode: Selection.PAGE });
    },
    
    selectAllPages() {
      this.selection = [...this.value];
      this.allPagesSelected = true;
      this.$emit('selection', { event, rows: this.selection, mode: Selection.PAGES });
    },
    
    deselectAllInPage() {
      this.selection = [];
      this.allPagesSelected = false;
      this.$emit('selection', { event, rows: this.selection, mode: Selection.PAGE });
    },
    
    deselectAllPages() {
      this.selection = [];
      this.allPagesSelected = false;
      this.$emit('selection', { event, rows: this.selection, mode: Selection.PAGES });
    },
    
    isEntryChecked(entry) {
      return this.selection.includes(entry);
    },
    
    onSelection(event, entry) {
      if (!entry.hasOwnProperty(this.property)) {
        console.warn('spices.pepper.data-list', 'Missing requested property "%s". The selection functionnality might not work properly.', this.property);
        return;
      }

      let rdata = this.value.filter(r => entry.$id === r.$id)[0];
      let i = this.selection.indexOf(rdata);
      i == -1 ? this.selection.push(entry) : this.selection.splice(i, 1);

      this.$emit('selection', event, this.selection, Selection.SOME);
    },

    toggleSelectAllInPage() {
      this.isPageSelected ?
        this.deselectAllPages() :
        this.selectAllInPage();
    },
  }
});

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/sortablejs/modular/sortable.esm.js
/**!
 * Sortable 1.10.2
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var version = "1.10.2";

function userAgent(pattern) {
  if (typeof window !== 'undefined' && window.navigator) {
    return !!
    /*@__PURE__*/
    navigator.userAgent.match(pattern);
  }
}

var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var Edge = userAgent(/Edge/i);
var FireFox = userAgent(/firefox/i);
var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
var IOS = userAgent(/iP(ad|od|hone)/i);
var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);

var captureMode = {
  capture: false,
  passive: false
};

function on(el, event, fn) {
  el.addEventListener(event, fn, !IE11OrLess && captureMode);
}

function off(el, event, fn) {
  el.removeEventListener(event, fn, !IE11OrLess && captureMode);
}

function matches(
/**HTMLElement*/
el,
/**String*/
selector) {
  if (!selector) return;
  selector[0] === '>' && (selector = selector.substring(1));

  if (el) {
    try {
      if (el.matches) {
        return el.matches(selector);
      } else if (el.msMatchesSelector) {
        return el.msMatchesSelector(selector);
      } else if (el.webkitMatchesSelector) {
        return el.webkitMatchesSelector(selector);
      }
    } catch (_) {
      return false;
    }
  }

  return false;
}

function getParentOrHost(el) {
  return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}

function closest(
/**HTMLElement*/
el,
/**String*/
selector,
/**HTMLElement*/
ctx, includeCTX) {
  if (el) {
    ctx = ctx || document;

    do {
      if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
        return el;
      }

      if (el === ctx) break;
      /* jshint boss:true */
    } while (el = getParentOrHost(el));
  }

  return null;
}

var R_SPACE = /\s+/g;

function toggleClass(el, name, state) {
  if (el && name) {
    if (el.classList) {
      el.classList[state ? 'add' : 'remove'](name);
    } else {
      var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
      el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
    }
  }
}

function css(el, prop, val) {
  var style = el && el.style;

  if (style) {
    if (val === void 0) {
      if (document.defaultView && document.defaultView.getComputedStyle) {
        val = document.defaultView.getComputedStyle(el, '');
      } else if (el.currentStyle) {
        val = el.currentStyle;
      }

      return prop === void 0 ? val : val[prop];
    } else {
      if (!(prop in style) && prop.indexOf('webkit') === -1) {
        prop = '-webkit-' + prop;
      }

      style[prop] = val + (typeof val === 'string' ? '' : 'px');
    }
  }
}

function matrix(el, selfOnly) {
  var appliedTransforms = '';

  if (typeof el === 'string') {
    appliedTransforms = el;
  } else {
    do {
      var transform = css(el, 'transform');

      if (transform && transform !== 'none') {
        appliedTransforms = transform + ' ' + appliedTransforms;
      }
      /* jshint boss:true */

    } while (!selfOnly && (el = el.parentNode));
  }

  var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  /*jshint -W056 */

  return matrixFn && new matrixFn(appliedTransforms);
}

function find(ctx, tagName, iterator) {
  if (ctx) {
    var list = ctx.getElementsByTagName(tagName),
        i = 0,
        n = list.length;

    if (iterator) {
      for (; i < n; i++) {
        iterator(list[i], i);
      }
    }

    return list;
  }

  return [];
}

function getWindowScrollingElement() {
  var scrollingElement = document.scrollingElement;

  if (scrollingElement) {
    return scrollingElement;
  } else {
    return document.documentElement;
  }
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */


function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
  if (!el.getBoundingClientRect && el !== window) return;
  var elRect, top, left, bottom, right, height, width;

  if (el !== window && el !== getWindowScrollingElement()) {
    elRect = el.getBoundingClientRect();
    top = elRect.top;
    left = elRect.left;
    bottom = elRect.bottom;
    right = elRect.right;
    height = elRect.height;
    width = elRect.width;
  } else {
    top = 0;
    left = 0;
    bottom = window.innerHeight;
    right = window.innerWidth;
    height = window.innerHeight;
    width = window.innerWidth;
  }

  if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
    // Adjust for translate()
    container = container || el.parentNode; // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
    // Not needed on <= IE11

    if (!IE11OrLess) {
      do {
        if (container && container.getBoundingClientRect && (css(container, 'transform') !== 'none' || relativeToNonStaticParent && css(container, 'position') !== 'static')) {
          var containerRect = container.getBoundingClientRect(); // Set relative to edges of padding box of container

          top -= containerRect.top + parseInt(css(container, 'border-top-width'));
          left -= containerRect.left + parseInt(css(container, 'border-left-width'));
          bottom = top + elRect.height;
          right = left + elRect.width;
          break;
        }
        /* jshint boss:true */

      } while (container = container.parentNode);
    }
  }

  if (undoScale && el !== window) {
    // Adjust for scale()
    var elMatrix = matrix(container || el),
        scaleX = elMatrix && elMatrix.a,
        scaleY = elMatrix && elMatrix.d;

    if (elMatrix) {
      top /= scaleY;
      left /= scaleX;
      width /= scaleX;
      height /= scaleY;
      bottom = top + height;
      right = left + width;
    }
  }

  return {
    top: top,
    left: left,
    bottom: bottom,
    right: right,
    width: width,
    height: height
  };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */


function isScrolledPast(el, elSide, parentSide) {
  var parent = getParentAutoScrollElement(el, true),
      elSideVal = getRect(el)[elSide];
  /* jshint boss:true */

  while (parent) {
    var parentSideVal = getRect(parent)[parentSide],
        visible = void 0;

    if (parentSide === 'top' || parentSide === 'left') {
      visible = elSideVal >= parentSideVal;
    } else {
      visible = elSideVal <= parentSideVal;
    }

    if (!visible) return parent;
    if (parent === getWindowScrollingElement()) break;
    parent = getParentAutoScrollElement(parent, false);
  }

  return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */


function getChild(el, childNum, options) {
  var currentChild = 0,
      i = 0,
      children = el.children;

  while (i < children.length) {
    if (children[i].style.display !== 'none' && children[i] !== Sortable.ghost && children[i] !== Sortable.dragged && closest(children[i], options.draggable, el, false)) {
      if (currentChild === childNum) {
        return children[i];
      }

      currentChild++;
    }

    i++;
  }

  return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */


function lastChild(el, selector) {
  var last = el.lastElementChild;

  while (last && (last === Sortable.ghost || css(last, 'display') === 'none' || selector && !matches(last, selector))) {
    last = last.previousElementSibling;
  }

  return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */


function sortable_esm_index(el, selector) {
  var index = 0;

  if (!el || !el.parentNode) {
    return -1;
  }
  /* jshint boss:true */


  while (el = el.previousElementSibling) {
    if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== Sortable.clone && (!selector || matches(el, selector))) {
      index++;
    }
  }

  return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */


function getRelativeScrollOffset(el) {
  var offsetLeft = 0,
      offsetTop = 0,
      winScroller = getWindowScrollingElement();

  if (el) {
    do {
      var elMatrix = matrix(el),
          scaleX = elMatrix.a,
          scaleY = elMatrix.d;
      offsetLeft += el.scrollLeft * scaleX;
      offsetTop += el.scrollTop * scaleY;
    } while (el !== winScroller && (el = el.parentNode));
  }

  return [offsetLeft, offsetTop];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */


function indexOfObject(arr, obj) {
  for (var i in arr) {
    if (!arr.hasOwnProperty(i)) continue;

    for (var key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
    }
  }

  return -1;
}

function getParentAutoScrollElement(el, includeSelf) {
  // skip to window
  if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
  var elem = el;
  var gotSelf = false;

  do {
    // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
      var elemCSS = css(elem);

      if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
        if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
        if (gotSelf || includeSelf) return elem;
        gotSelf = true;
      }
    }
    /* jshint boss:true */

  } while (elem = elem.parentNode);

  return getWindowScrollingElement();
}

function extend(dst, src) {
  if (dst && src) {
    for (var key in src) {
      if (src.hasOwnProperty(key)) {
        dst[key] = src[key];
      }
    }
  }

  return dst;
}

function isRectEqual(rect1, rect2) {
  return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}

var _throttleTimeout;

function throttle(callback, ms) {
  return function () {
    if (!_throttleTimeout) {
      var args = arguments,
          _this = this;

      if (args.length === 1) {
        callback.call(_this, args[0]);
      } else {
        callback.apply(_this, args);
      }

      _throttleTimeout = setTimeout(function () {
        _throttleTimeout = void 0;
      }, ms);
    }
  };
}

function cancelThrottle() {
  clearTimeout(_throttleTimeout);
  _throttleTimeout = void 0;
}

function scrollBy(el, x, y) {
  el.scrollLeft += x;
  el.scrollTop += y;
}

function clone(el) {
  var Polymer = window.Polymer;
  var $ = window.jQuery || window.Zepto;

  if (Polymer && Polymer.dom) {
    return Polymer.dom(el).cloneNode(true);
  } else if ($) {
    return $(el).clone(true)[0];
  } else {
    return el.cloneNode(true);
  }
}

function setRect(el, rect) {
  css(el, 'position', 'absolute');
  css(el, 'top', rect.top);
  css(el, 'left', rect.left);
  css(el, 'width', rect.width);
  css(el, 'height', rect.height);
}

function unsetRect(el) {
  css(el, 'position', '');
  css(el, 'top', '');
  css(el, 'left', '');
  css(el, 'width', '');
  css(el, 'height', '');
}

var expando = 'Sortable' + new Date().getTime();

function AnimationStateManager() {
  var animationStates = [],
      animationCallbackId;
  return {
    captureAnimationState: function captureAnimationState() {
      animationStates = [];
      if (!this.options.animation) return;
      var children = [].slice.call(this.el.children);
      children.forEach(function (child) {
        if (css(child, 'display') === 'none' || child === Sortable.ghost) return;
        animationStates.push({
          target: child,
          rect: getRect(child)
        });

        var fromRect = _objectSpread({}, animationStates[animationStates.length - 1].rect); // If animating: compensate for current animation


        if (child.thisAnimationDuration) {
          var childMatrix = matrix(child, true);

          if (childMatrix) {
            fromRect.top -= childMatrix.f;
            fromRect.left -= childMatrix.e;
          }
        }

        child.fromRect = fromRect;
      });
    },
    addAnimationState: function addAnimationState(state) {
      animationStates.push(state);
    },
    removeAnimationState: function removeAnimationState(target) {
      animationStates.splice(indexOfObject(animationStates, {
        target: target
      }), 1);
    },
    animateAll: function animateAll(callback) {
      var _this = this;

      if (!this.options.animation) {
        clearTimeout(animationCallbackId);
        if (typeof callback === 'function') callback();
        return;
      }

      var animating = false,
          animationTime = 0;
      animationStates.forEach(function (state) {
        var time = 0,
            target = state.target,
            fromRect = target.fromRect,
            toRect = getRect(target),
            prevFromRect = target.prevFromRect,
            prevToRect = target.prevToRect,
            animatingRect = state.rect,
            targetMatrix = matrix(target, true);

        if (targetMatrix) {
          // Compensate for current animation
          toRect.top -= targetMatrix.f;
          toRect.left -= targetMatrix.e;
        }

        target.toRect = toRect;

        if (target.thisAnimationDuration) {
          // Could also check if animatingRect is between fromRect and toRect
          if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
          (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
            // If returning to same place as started from animation and on same axis
            time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
          }
        } // if fromRect != toRect: animate


        if (!isRectEqual(toRect, fromRect)) {
          target.prevFromRect = fromRect;
          target.prevToRect = toRect;

          if (!time) {
            time = _this.options.animation;
          }

          _this.animate(target, animatingRect, toRect, time);
        }

        if (time) {
          animating = true;
          animationTime = Math.max(animationTime, time);
          clearTimeout(target.animationResetTimer);
          target.animationResetTimer = setTimeout(function () {
            target.animationTime = 0;
            target.prevFromRect = null;
            target.fromRect = null;
            target.prevToRect = null;
            target.thisAnimationDuration = null;
          }, time);
          target.thisAnimationDuration = time;
        }
      });
      clearTimeout(animationCallbackId);

      if (!animating) {
        if (typeof callback === 'function') callback();
      } else {
        animationCallbackId = setTimeout(function () {
          if (typeof callback === 'function') callback();
        }, animationTime);
      }

      animationStates = [];
    },
    animate: function animate(target, currentRect, toRect, duration) {
      if (duration) {
        css(target, 'transition', '');
        css(target, 'transform', '');
        var elMatrix = matrix(this.el),
            scaleX = elMatrix && elMatrix.a,
            scaleY = elMatrix && elMatrix.d,
            translateX = (currentRect.left - toRect.left) / (scaleX || 1),
            translateY = (currentRect.top - toRect.top) / (scaleY || 1);
        target.animatingX = !!translateX;
        target.animatingY = !!translateY;
        css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
        repaint(target); // repaint

        css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
        css(target, 'transform', 'translate3d(0,0,0)');
        typeof target.animated === 'number' && clearTimeout(target.animated);
        target.animated = setTimeout(function () {
          css(target, 'transition', '');
          css(target, 'transform', '');
          target.animated = false;
          target.animatingX = false;
          target.animatingY = false;
        }, duration);
      }
    }
  };
}

function repaint(target) {
  return target.offsetWidth;
}

function calculateRealTime(animatingRect, fromRect, toRect, options) {
  return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}

var plugins = [];
var defaults = {
  initializeByDefault: true
};
var PluginManager = {
  mount: function mount(plugin) {
    // Set default static properties
    for (var option in defaults) {
      if (defaults.hasOwnProperty(option) && !(option in plugin)) {
        plugin[option] = defaults[option];
      }
    }

    plugins.push(plugin);
  },
  pluginEvent: function pluginEvent(eventName, sortable, evt) {
    var _this = this;

    this.eventCanceled = false;

    evt.cancel = function () {
      _this.eventCanceled = true;
    };

    var eventNameGlobal = eventName + 'Global';
    plugins.forEach(function (plugin) {
      if (!sortable[plugin.pluginName]) return; // Fire global events if it exists in this sortable

      if (sortable[plugin.pluginName][eventNameGlobal]) {
        sortable[plugin.pluginName][eventNameGlobal](_objectSpread({
          sortable: sortable
        }, evt));
      } // Only fire plugin event if plugin is enabled in this sortable,
      // and plugin has event defined


      if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
        sortable[plugin.pluginName][eventName](_objectSpread({
          sortable: sortable
        }, evt));
      }
    });
  },
  initializePlugins: function initializePlugins(sortable, el, defaults, options) {
    plugins.forEach(function (plugin) {
      var pluginName = plugin.pluginName;
      if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
      var initialized = new plugin(sortable, el, sortable.options);
      initialized.sortable = sortable;
      initialized.options = sortable.options;
      sortable[pluginName] = initialized; // Add default options from plugin

      _extends(defaults, initialized.defaults);
    });

    for (var option in sortable.options) {
      if (!sortable.options.hasOwnProperty(option)) continue;
      var modified = this.modifyOption(sortable, option, sortable.options[option]);

      if (typeof modified !== 'undefined') {
        sortable.options[option] = modified;
      }
    }
  },
  getEventProperties: function getEventProperties(name, sortable) {
    var eventProperties = {};
    plugins.forEach(function (plugin) {
      if (typeof plugin.eventProperties !== 'function') return;

      _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
    });
    return eventProperties;
  },
  modifyOption: function modifyOption(sortable, name, value) {
    var modifiedValue;
    plugins.forEach(function (plugin) {
      // Plugin must exist on the Sortable
      if (!sortable[plugin.pluginName]) return; // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin

      if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') {
        modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
      }
    });
    return modifiedValue;
  }
};

function dispatchEvent(_ref) {
  var sortable = _ref.sortable,
      rootEl = _ref.rootEl,
      name = _ref.name,
      targetEl = _ref.targetEl,
      cloneEl = _ref.cloneEl,
      toEl = _ref.toEl,
      fromEl = _ref.fromEl,
      oldIndex = _ref.oldIndex,
      newIndex = _ref.newIndex,
      oldDraggableIndex = _ref.oldDraggableIndex,
      newDraggableIndex = _ref.newDraggableIndex,
      originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      extraEventProperties = _ref.extraEventProperties;
  sortable = sortable || rootEl && rootEl[expando];
  if (!sortable) return;
  var evt,
      options = sortable.options,
      onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1); // Support for new CustomEvent feature

  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent(name, {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent(name, true, true);
  }

  evt.to = toEl || rootEl;
  evt.from = fromEl || rootEl;
  evt.item = targetEl || rootEl;
  evt.clone = cloneEl;
  evt.oldIndex = oldIndex;
  evt.newIndex = newIndex;
  evt.oldDraggableIndex = oldDraggableIndex;
  evt.newDraggableIndex = newDraggableIndex;
  evt.originalEvent = originalEvent;
  evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;

  var allEventProperties = _objectSpread({}, extraEventProperties, PluginManager.getEventProperties(name, sortable));

  for (var option in allEventProperties) {
    evt[option] = allEventProperties[option];
  }

  if (rootEl) {
    rootEl.dispatchEvent(evt);
  }

  if (options[onName]) {
    options[onName].call(sortable, evt);
  }
}

var pluginEvent = function pluginEvent(eventName, sortable) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      originalEvent = _ref.evt,
      data = _objectWithoutProperties(_ref, ["evt"]);

  PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread({
    dragEl: dragEl,
    parentEl: parentEl,
    ghostEl: ghostEl,
    rootEl: rootEl,
    nextEl: nextEl,
    lastDownEl: lastDownEl,
    cloneEl: cloneEl,
    cloneHidden: cloneHidden,
    dragStarted: moved,
    putSortable: putSortable,
    activeSortable: Sortable.active,
    originalEvent: originalEvent,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex,
    hideGhostForTarget: _hideGhostForTarget,
    unhideGhostForTarget: _unhideGhostForTarget,
    cloneNowHidden: function cloneNowHidden() {
      cloneHidden = true;
    },
    cloneNowShown: function cloneNowShown() {
      cloneHidden = false;
    },
    dispatchSortableEvent: function dispatchSortableEvent(name) {
      _dispatchEvent({
        sortable: sortable,
        name: name,
        originalEvent: originalEvent
      });
    }
  }, data));
};

function _dispatchEvent(info) {
  dispatchEvent(_objectSpread({
    putSortable: putSortable,
    cloneEl: cloneEl,
    targetEl: dragEl,
    rootEl: rootEl,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex
  }, info));
}

var dragEl,
    parentEl,
    ghostEl,
    rootEl,
    nextEl,
    lastDownEl,
    cloneEl,
    cloneHidden,
    oldIndex,
    newIndex,
    oldDraggableIndex,
    newDraggableIndex,
    activeGroup,
    putSortable,
    awaitingDragStarted = false,
    ignoreNextClick = false,
    sortables = [],
    tapEvt,
    touchEvt,
    lastDx,
    lastDy,
    tapDistanceLeft,
    tapDistanceTop,
    moved,
    lastTarget,
    lastDirection,
    pastFirstInvertThresh = false,
    isCircumstantialInvert = false,
    targetMoveDistance,
    // For positioning ghost absolutely
ghostRelativeParent,
    ghostRelativeParentInitialScroll = [],
    // (left, top)
_silent = false,
    savedInputChecked = [];
/** @const */

var documentExists = typeof document !== 'undefined',
    PositionGhostAbsolutely = IOS,
    CSSFloatProperty = Edge || IE11OrLess ? 'cssFloat' : 'float',
    // This will not pass for IE9, because IE9 DnD only works on anchors
supportDraggable = documentExists && !ChromeForAndroid && !IOS && 'draggable' in document.createElement('div'),
    supportCssPointerEvents = function () {
  if (!documentExists) return; // false when <= IE11

  if (IE11OrLess) {
    return false;
  }

  var el = document.createElement('x');
  el.style.cssText = 'pointer-events:auto';
  return el.style.pointerEvents === 'auto';
}(),
    _detectDirection = function _detectDirection(el, options) {
  var elCSS = css(el),
      elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth),
      child1 = getChild(el, 0, options),
      child2 = getChild(el, 1, options),
      firstChildCSS = child1 && css(child1),
      secondChildCSS = child2 && css(child2),
      firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width,
      secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;

  if (elCSS.display === 'flex') {
    return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
  }

  if (elCSS.display === 'grid') {
    return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
  }

  if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
    var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
    return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
  }

  return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === 'none' || child2 && elCSS[CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
},
    _dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
  var dragElS1Opp = vertical ? dragRect.left : dragRect.top,
      dragElS2Opp = vertical ? dragRect.right : dragRect.bottom,
      dragElOppLength = vertical ? dragRect.width : dragRect.height,
      targetS1Opp = vertical ? targetRect.left : targetRect.top,
      targetS2Opp = vertical ? targetRect.right : targetRect.bottom,
      targetOppLength = vertical ? targetRect.width : targetRect.height;
  return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
},

/**
 * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
 * @param  {Number} x      X position
 * @param  {Number} y      Y position
 * @return {HTMLElement}   Element of the first found nearest Sortable
 */
_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
  var ret;
  sortables.some(function (sortable) {
    if (lastChild(sortable)) return;
    var rect = getRect(sortable),
        threshold = sortable[expando].options.emptyInsertThreshold,
        insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold,
        insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;

    if (threshold && insideHorizontally && insideVertically) {
      return ret = sortable;
    }
  });
  return ret;
},
    _prepareGroup = function _prepareGroup(options) {
  function toFn(value, pull) {
    return function (to, from, dragEl, evt) {
      var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;

      if (value == null && (pull || sameGroup)) {
        // Default pull value
        // Default pull and put value if same group
        return true;
      } else if (value == null || value === false) {
        return false;
      } else if (pull && value === 'clone') {
        return value;
      } else if (typeof value === 'function') {
        return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
      } else {
        var otherGroup = (pull ? to : from).options.group.name;
        return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
      }
    };
  }

  var group = {};
  var originalGroup = options.group;

  if (!originalGroup || _typeof(originalGroup) != 'object') {
    originalGroup = {
      name: originalGroup
    };
  }

  group.name = originalGroup.name;
  group.checkPull = toFn(originalGroup.pull, true);
  group.checkPut = toFn(originalGroup.put);
  group.revertClone = originalGroup.revertClone;
  options.group = group;
},
    _hideGhostForTarget = function _hideGhostForTarget() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, 'display', 'none');
  }
},
    _unhideGhostForTarget = function _unhideGhostForTarget() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, 'display', '');
  }
}; // #1184 fix - Prevent click event on fallback if dragged but item not changed position


if (documentExists) {
  document.addEventListener('click', function (evt) {
    if (ignoreNextClick) {
      evt.preventDefault();
      evt.stopPropagation && evt.stopPropagation();
      evt.stopImmediatePropagation && evt.stopImmediatePropagation();
      ignoreNextClick = false;
      return false;
    }
  }, true);
}

var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
  if (dragEl) {
    evt = evt.touches ? evt.touches[0] : evt;

    var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);

    if (nearest) {
      // Create imitation event
      var event = {};

      for (var i in evt) {
        if (evt.hasOwnProperty(i)) {
          event[i] = evt[i];
        }
      }

      event.target = event.rootEl = nearest;
      event.preventDefault = void 0;
      event.stopPropagation = void 0;

      nearest[expando]._onDragOver(event);
    }
  }
};

var _checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
  if (dragEl) {
    dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
  }
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */


function Sortable(el, options) {
  if (!(el && el.nodeType && el.nodeType === 1)) {
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
  }

  this.el = el; // root element

  this.options = options = _extends({}, options); // Export instance

  el[expando] = this;
  var defaults = {
    group: null,
    sort: true,
    disabled: false,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: false,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: true,
    direction: function direction() {
      return _detectDirection(el, this.options);
    },
    ghostClass: 'sortable-ghost',
    chosenClass: 'sortable-chosen',
    dragClass: 'sortable-drag',
    ignore: 'a, img',
    filter: null,
    preventOnFilter: true,
    animation: 0,
    easing: null,
    setData: function setData(dataTransfer, dragEl) {
      dataTransfer.setData('Text', dragEl.textContent);
    },
    dropBubble: false,
    dragoverBubble: false,
    dataIdAttr: 'data-id',
    delay: 0,
    delayOnTouchOnly: false,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: false,
    fallbackClass: 'sortable-fallback',
    fallbackOnBody: false,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: Sortable.supportPointer !== false && 'PointerEvent' in window,
    emptyInsertThreshold: 5
  };
  PluginManager.initializePlugins(this, el, defaults); // Set default options

  for (var name in defaults) {
    !(name in options) && (options[name] = defaults[name]);
  }

  _prepareGroup(options); // Bind all private methods


  for (var fn in this) {
    if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
      this[fn] = this[fn].bind(this);
    }
  } // Setup drag mode


  this.nativeDraggable = options.forceFallback ? false : supportDraggable;

  if (this.nativeDraggable) {
    // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
  } // Bind events


  if (options.supportPointer) {
    on(el, 'pointerdown', this._onTapStart);
  } else {
    on(el, 'mousedown', this._onTapStart);
    on(el, 'touchstart', this._onTapStart);
  }

  if (this.nativeDraggable) {
    on(el, 'dragover', this);
    on(el, 'dragenter', this);
  }

  sortables.push(this.el); // Restore sorting

  options.store && options.store.get && this.sort(options.store.get(this) || []); // Add animation state manager

  _extends(this, AnimationStateManager());
}

Sortable.prototype =
/** @lends Sortable.prototype */
{
  constructor: Sortable,
  _isOutsideThisEl: function _isOutsideThisEl(target) {
    if (!this.el.contains(target) && target !== this.el) {
      lastTarget = null;
    }
  },
  _getDirection: function _getDirection(evt, target) {
    return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
  },
  _onTapStart: function _onTapStart(
  /** Event|TouchEvent */
  evt) {
    if (!evt.cancelable) return;

    var _this = this,
        el = this.el,
        options = this.options,
        preventOnFilter = options.preventOnFilter,
        type = evt.type,
        touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt,
        target = (touch || evt).target,
        originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target,
        filter = options.filter;

    _saveInputCheckedState(el); // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.


    if (dragEl) {
      return;
    }

    if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
      return; // only left button and enabled
    } // cancel dnd if original target is content editable


    if (originalTarget.isContentEditable) {
      return;
    }

    target = closest(target, options.draggable, el, false);

    if (target && target.animated) {
      return;
    }

    if (lastDownEl === target) {
      // Ignoring duplicate `down`
      return;
    } // Get the index of the dragged element within its parent


    oldIndex = sortable_esm_index(target);
    oldDraggableIndex = sortable_esm_index(target, options.draggable); // Check filter

    if (typeof filter === 'function') {
      if (filter.call(this, evt, target, this)) {
        _dispatchEvent({
          sortable: _this,
          rootEl: originalTarget,
          name: 'filter',
          targetEl: target,
          toEl: el,
          fromEl: el
        });

        pluginEvent('filter', _this, {
          evt: evt
        });
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return; // cancel dnd
      }
    } else if (filter) {
      filter = filter.split(',').some(function (criteria) {
        criteria = closest(originalTarget, criteria.trim(), el, false);

        if (criteria) {
          _dispatchEvent({
            sortable: _this,
            rootEl: criteria,
            name: 'filter',
            targetEl: target,
            fromEl: el,
            toEl: el
          });

          pluginEvent('filter', _this, {
            evt: evt
          });
          return true;
        }
      });

      if (filter) {
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return; // cancel dnd
      }
    }

    if (options.handle && !closest(originalTarget, options.handle, el, false)) {
      return;
    } // Prepare `dragstart`


    this._prepareDragStart(evt, touch, target);
  },
  _prepareDragStart: function _prepareDragStart(
  /** Event */
  evt,
  /** Touch */
  touch,
  /** HTMLElement */
  target) {
    var _this = this,
        el = _this.el,
        options = _this.options,
        ownerDocument = el.ownerDocument,
        dragStartFn;

    if (target && !dragEl && target.parentNode === el) {
      var dragRect = getRect(target);
      rootEl = el;
      dragEl = target;
      parentEl = dragEl.parentNode;
      nextEl = dragEl.nextSibling;
      lastDownEl = target;
      activeGroup = options.group;
      Sortable.dragged = dragEl;
      tapEvt = {
        target: dragEl,
        clientX: (touch || evt).clientX,
        clientY: (touch || evt).clientY
      };
      tapDistanceLeft = tapEvt.clientX - dragRect.left;
      tapDistanceTop = tapEvt.clientY - dragRect.top;
      this._lastX = (touch || evt).clientX;
      this._lastY = (touch || evt).clientY;
      dragEl.style['will-change'] = 'all';

      dragStartFn = function dragStartFn() {
        pluginEvent('delayEnded', _this, {
          evt: evt
        });

        if (Sortable.eventCanceled) {
          _this._onDrop();

          return;
        } // Delayed drag has been triggered
        // we can re-enable the events: touchmove/mousemove


        _this._disableDelayedDragEvents();

        if (!FireFox && _this.nativeDraggable) {
          dragEl.draggable = true;
        } // Bind the events: dragstart/dragend


        _this._triggerDragStart(evt, touch); // Drag start event


        _dispatchEvent({
          sortable: _this,
          name: 'choose',
          originalEvent: evt
        }); // Chosen item


        toggleClass(dragEl, options.chosenClass, true);
      }; // Disable "draggable"


      options.ignore.split(',').forEach(function (criteria) {
        find(dragEl, criteria.trim(), _disableDraggable);
      });
      on(ownerDocument, 'dragover', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'mousemove', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'touchmove', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'mouseup', _this._onDrop);
      on(ownerDocument, 'touchend', _this._onDrop);
      on(ownerDocument, 'touchcancel', _this._onDrop); // Make dragEl draggable (must be before delay for FireFox)

      if (FireFox && this.nativeDraggable) {
        this.options.touchStartThreshold = 4;
        dragEl.draggable = true;
      }

      pluginEvent('delayStart', this, {
        evt: evt
      }); // Delay is impossible for native DnD in Edge or IE

      if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
        if (Sortable.eventCanceled) {
          this._onDrop();

          return;
        } // If the user moves the pointer or let go the click or touch
        // before the delay has been reached:
        // disable the delayed drag


        on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
        on(ownerDocument, 'touchend', _this._disableDelayedDrag);
        on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
        on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
        on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
        options.supportPointer && on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
        _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
      } else {
        dragStartFn();
      }
    }
  },
  _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(
  /** TouchEvent|PointerEvent **/
  e) {
    var touch = e.touches ? e.touches[0] : e;

    if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
      this._disableDelayedDrag();
    }
  },
  _disableDelayedDrag: function _disableDelayedDrag() {
    dragEl && _disableDraggable(dragEl);
    clearTimeout(this._dragStartTimer);

    this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function _disableDelayedDragEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._disableDelayedDrag);
    off(ownerDocument, 'touchend', this._disableDelayedDrag);
    off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
    off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function _triggerDragStart(
  /** Event */
  evt,
  /** Touch */
  touch) {
    touch = touch || evt.pointerType == 'touch' && evt;

    if (!this.nativeDraggable || touch) {
      if (this.options.supportPointer) {
        on(document, 'pointermove', this._onTouchMove);
      } else if (touch) {
        on(document, 'touchmove', this._onTouchMove);
      } else {
        on(document, 'mousemove', this._onTouchMove);
      }
    } else {
      on(dragEl, 'dragend', this);
      on(rootEl, 'dragstart', this._onDragStart);
    }

    try {
      if (document.selection) {
        // Timeout neccessary for IE9
        _nextTick(function () {
          document.selection.empty();
        });
      } else {
        window.getSelection().removeAllRanges();
      }
    } catch (err) {}
  },
  _dragStarted: function _dragStarted(fallback, evt) {

    awaitingDragStarted = false;

    if (rootEl && dragEl) {
      pluginEvent('dragStarted', this, {
        evt: evt
      });

      if (this.nativeDraggable) {
        on(document, 'dragover', _checkOutsideTargetEl);
      }

      var options = this.options; // Apply effect

      !fallback && toggleClass(dragEl, options.dragClass, false);
      toggleClass(dragEl, options.ghostClass, true);
      Sortable.active = this;
      fallback && this._appendGhost(); // Drag start event

      _dispatchEvent({
        sortable: this,
        name: 'start',
        originalEvent: evt
      });
    } else {
      this._nulling();
    }
  },
  _emulateDragOver: function _emulateDragOver() {
    if (touchEvt) {
      this._lastX = touchEvt.clientX;
      this._lastY = touchEvt.clientY;

      _hideGhostForTarget();

      var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
      var parent = target;

      while (target && target.shadowRoot) {
        target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
        if (target === parent) break;
        parent = target;
      }

      dragEl.parentNode[expando]._isOutsideThisEl(target);

      if (parent) {
        do {
          if (parent[expando]) {
            var inserted = void 0;
            inserted = parent[expando]._onDragOver({
              clientX: touchEvt.clientX,
              clientY: touchEvt.clientY,
              target: target,
              rootEl: parent
            });

            if (inserted && !this.options.dragoverBubble) {
              break;
            }
          }

          target = parent; // store last element
        }
        /* jshint boss:true */
        while (parent = parent.parentNode);
      }

      _unhideGhostForTarget();
    }
  },
  _onTouchMove: function _onTouchMove(
  /**TouchEvent*/
  evt) {
    if (tapEvt) {
      var options = this.options,
          fallbackTolerance = options.fallbackTolerance,
          fallbackOffset = options.fallbackOffset,
          touch = evt.touches ? evt.touches[0] : evt,
          ghostMatrix = ghostEl && matrix(ghostEl, true),
          scaleX = ghostEl && ghostMatrix && ghostMatrix.a,
          scaleY = ghostEl && ghostMatrix && ghostMatrix.d,
          relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent),
          dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1),
          dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1); // only set the status to dragging, when we are actually dragging

      if (!Sortable.active && !awaitingDragStarted) {
        if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
          return;
        }

        this._onDragStart(evt, true);
      }

      if (ghostEl) {
        if (ghostMatrix) {
          ghostMatrix.e += dx - (lastDx || 0);
          ghostMatrix.f += dy - (lastDy || 0);
        } else {
          ghostMatrix = {
            a: 1,
            b: 0,
            c: 0,
            d: 1,
            e: dx,
            f: dy
          };
        }

        var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
        css(ghostEl, 'webkitTransform', cssMatrix);
        css(ghostEl, 'mozTransform', cssMatrix);
        css(ghostEl, 'msTransform', cssMatrix);
        css(ghostEl, 'transform', cssMatrix);
        lastDx = dx;
        lastDy = dy;
        touchEvt = touch;
      }

      evt.cancelable && evt.preventDefault();
    }
  },
  _appendGhost: function _appendGhost() {
    // Bug if using scale(): https://stackoverflow.com/questions/2637058
    // Not being adjusted for
    if (!ghostEl) {
      var container = this.options.fallbackOnBody ? document.body : rootEl,
          rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container),
          options = this.options; // Position absolutely

      if (PositionGhostAbsolutely) {
        // Get relatively positioned parent
        ghostRelativeParent = container;

        while (css(ghostRelativeParent, 'position') === 'static' && css(ghostRelativeParent, 'transform') === 'none' && ghostRelativeParent !== document) {
          ghostRelativeParent = ghostRelativeParent.parentNode;
        }

        if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
          if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
          rect.top += ghostRelativeParent.scrollTop;
          rect.left += ghostRelativeParent.scrollLeft;
        } else {
          ghostRelativeParent = getWindowScrollingElement();
        }

        ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
      }

      ghostEl = dragEl.cloneNode(true);
      toggleClass(ghostEl, options.ghostClass, false);
      toggleClass(ghostEl, options.fallbackClass, true);
      toggleClass(ghostEl, options.dragClass, true);
      css(ghostEl, 'transition', '');
      css(ghostEl, 'transform', '');
      css(ghostEl, 'box-sizing', 'border-box');
      css(ghostEl, 'margin', 0);
      css(ghostEl, 'top', rect.top);
      css(ghostEl, 'left', rect.left);
      css(ghostEl, 'width', rect.width);
      css(ghostEl, 'height', rect.height);
      css(ghostEl, 'opacity', '0.8');
      css(ghostEl, 'position', PositionGhostAbsolutely ? 'absolute' : 'fixed');
      css(ghostEl, 'zIndex', '100000');
      css(ghostEl, 'pointerEvents', 'none');
      Sortable.ghost = ghostEl;
      container.appendChild(ghostEl); // Set transform-origin

      css(ghostEl, 'transform-origin', tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + '% ' + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + '%');
    }
  },
  _onDragStart: function _onDragStart(
  /**Event*/
  evt,
  /**boolean*/
  fallback) {
    var _this = this;

    var dataTransfer = evt.dataTransfer;
    var options = _this.options;
    pluginEvent('dragStart', this, {
      evt: evt
    });

    if (Sortable.eventCanceled) {
      this._onDrop();

      return;
    }

    pluginEvent('setupClone', this);

    if (!Sortable.eventCanceled) {
      cloneEl = clone(dragEl);
      cloneEl.draggable = false;
      cloneEl.style['will-change'] = '';

      this._hideClone();

      toggleClass(cloneEl, this.options.chosenClass, false);
      Sortable.clone = cloneEl;
    } // #1143: IFrame support workaround


    _this.cloneId = _nextTick(function () {
      pluginEvent('clone', _this);
      if (Sortable.eventCanceled) return;

      if (!_this.options.removeCloneOnHide) {
        rootEl.insertBefore(cloneEl, dragEl);
      }

      _this._hideClone();

      _dispatchEvent({
        sortable: _this,
        name: 'clone'
      });
    });
    !fallback && toggleClass(dragEl, options.dragClass, true); // Set proper drop events

    if (fallback) {
      ignoreNextClick = true;
      _this._loopId = setInterval(_this._emulateDragOver, 50);
    } else {
      // Undo what was set in _prepareDragStart before drag started
      off(document, 'mouseup', _this._onDrop);
      off(document, 'touchend', _this._onDrop);
      off(document, 'touchcancel', _this._onDrop);

      if (dataTransfer) {
        dataTransfer.effectAllowed = 'move';
        options.setData && options.setData.call(_this, dataTransfer, dragEl);
      }

      on(document, 'drop', _this); // #1276 fix:

      css(dragEl, 'transform', 'translateZ(0)');
    }

    awaitingDragStarted = true;
    _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
    on(document, 'selectstart', _this);
    moved = true;

    if (Safari) {
      css(document.body, 'user-select', 'none');
    }
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function _onDragOver(
  /**Event*/
  evt) {
    var el = this.el,
        target = evt.target,
        dragRect,
        targetRect,
        revert,
        options = this.options,
        group = options.group,
        activeSortable = Sortable.active,
        isOwner = activeGroup === group,
        canSort = options.sort,
        fromSortable = putSortable || activeSortable,
        vertical,
        _this = this,
        completedFired = false;

    if (_silent) return;

    function dragOverEvent(name, extra) {
      pluginEvent(name, _this, _objectSpread({
        evt: evt,
        isOwner: isOwner,
        axis: vertical ? 'vertical' : 'horizontal',
        revert: revert,
        dragRect: dragRect,
        targetRect: targetRect,
        canSort: canSort,
        fromSortable: fromSortable,
        target: target,
        completed: completed,
        onMove: function onMove(target, after) {
          return _onMove(rootEl, el, dragEl, dragRect, target, getRect(target), evt, after);
        },
        changed: changed
      }, extra));
    } // Capture animation state


    function capture() {
      dragOverEvent('dragOverAnimationCapture');

      _this.captureAnimationState();

      if (_this !== fromSortable) {
        fromSortable.captureAnimationState();
      }
    } // Return invocation when dragEl is inserted (or completed)


    function completed(insertion) {
      dragOverEvent('dragOverCompleted', {
        insertion: insertion
      });

      if (insertion) {
        // Clones must be hidden before folding animation to capture dragRectAbsolute properly
        if (isOwner) {
          activeSortable._hideClone();
        } else {
          activeSortable._showClone(_this);
        }

        if (_this !== fromSortable) {
          // Set ghost class to new sortable's ghost class
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
          toggleClass(dragEl, options.ghostClass, true);
        }

        if (putSortable !== _this && _this !== Sortable.active) {
          putSortable = _this;
        } else if (_this === Sortable.active && putSortable) {
          putSortable = null;
        } // Animation


        if (fromSortable === _this) {
          _this._ignoreWhileAnimating = target;
        }

        _this.animateAll(function () {
          dragOverEvent('dragOverAnimationComplete');
          _this._ignoreWhileAnimating = null;
        });

        if (_this !== fromSortable) {
          fromSortable.animateAll();
          fromSortable._ignoreWhileAnimating = null;
        }
      } // Null lastTarget if it is not inside a previously swapped element


      if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
        lastTarget = null;
      } // no bubbling and not fallback


      if (!options.dragoverBubble && !evt.rootEl && target !== document) {
        dragEl.parentNode[expando]._isOutsideThisEl(evt.target); // Do not detect for empty insert if already inserted


        !insertion && nearestEmptyInsertDetectEvent(evt);
      }

      !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
      return completedFired = true;
    } // Call when dragEl has been inserted


    function changed() {
      newIndex = sortable_esm_index(dragEl);
      newDraggableIndex = sortable_esm_index(dragEl, options.draggable);

      _dispatchEvent({
        sortable: _this,
        name: 'change',
        toEl: el,
        newIndex: newIndex,
        newDraggableIndex: newDraggableIndex,
        originalEvent: evt
      });
    }

    if (evt.preventDefault !== void 0) {
      evt.cancelable && evt.preventDefault();
    }

    target = closest(target, options.draggable, el, true);
    dragOverEvent('dragOver');
    if (Sortable.eventCanceled) return completedFired;

    if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
      return completed(false);
    }

    ignoreNextClick = false;

    if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = !rootEl.contains(dragEl)) // Reverting item into the original list
    : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
      vertical = this._getDirection(evt, target) === 'vertical';
      dragRect = getRect(dragEl);
      dragOverEvent('dragOverValid');
      if (Sortable.eventCanceled) return completedFired;

      if (revert) {
        parentEl = rootEl; // actualization

        capture();

        this._hideClone();

        dragOverEvent('revert');

        if (!Sortable.eventCanceled) {
          if (nextEl) {
            rootEl.insertBefore(dragEl, nextEl);
          } else {
            rootEl.appendChild(dragEl);
          }
        }

        return completed(true);
      }

      var elLastChild = lastChild(el, options.draggable);

      if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
        // If already at end of list: Do not insert
        if (elLastChild === dragEl) {
          return completed(false);
        } // assign target only if condition is true


        if (elLastChild && el === evt.target) {
          target = elLastChild;
        }

        if (target) {
          targetRect = getRect(target);
        }

        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
          capture();
          el.appendChild(dragEl);
          parentEl = el; // actualization

          changed();
          return completed(true);
        }
      } else if (target.parentNode === el) {
        targetRect = getRect(target);
        var direction = 0,
            targetBeforeFirstSwap,
            differentLevel = dragEl.parentNode !== el,
            differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical),
            side1 = vertical ? 'top' : 'left',
            scrolledPastTop = isScrolledPast(target, 'top', 'top') || isScrolledPast(dragEl, 'top', 'top'),
            scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;

        if (lastTarget !== target) {
          targetBeforeFirstSwap = targetRect[side1];
          pastFirstInvertThresh = false;
          isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
        }

        direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
        var sibling;

        if (direction !== 0) {
          // Check if target is beside dragEl in respective direction (ignoring hidden elements)
          var dragIndex = sortable_esm_index(dragEl);

          do {
            dragIndex -= direction;
            sibling = parentEl.children[dragIndex];
          } while (sibling && (css(sibling, 'display') === 'none' || sibling === ghostEl));
        } // If dragEl is already beside target: Do not insert


        if (direction === 0 || sibling === target) {
          return completed(false);
        }

        lastTarget = target;
        lastDirection = direction;
        var nextSibling = target.nextElementSibling,
            after = false;
        after = direction === 1;

        var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);

        if (moveVector !== false) {
          if (moveVector === 1 || moveVector === -1) {
            after = moveVector === 1;
          }

          _silent = true;
          setTimeout(_unsilent, 30);
          capture();

          if (after && !nextSibling) {
            el.appendChild(dragEl);
          } else {
            target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
          } // Undo chrome's scroll adjustment (has no effect on other browsers)


          if (scrolledPastTop) {
            scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
          }

          parentEl = dragEl.parentNode; // actualization
          // must be done before animation

          if (targetBeforeFirstSwap !== undefined && !isCircumstantialInvert) {
            targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
          }

          changed();
          return completed(true);
        }
      }

      if (el.contains(dragEl)) {
        return completed(false);
      }
    }

    return false;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function _offMoveEvents() {
    off(document, 'mousemove', this._onTouchMove);
    off(document, 'touchmove', this._onTouchMove);
    off(document, 'pointermove', this._onTouchMove);
    off(document, 'dragover', nearestEmptyInsertDetectEvent);
    off(document, 'mousemove', nearestEmptyInsertDetectEvent);
    off(document, 'touchmove', nearestEmptyInsertDetectEvent);
  },
  _offUpEvents: function _offUpEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._onDrop);
    off(ownerDocument, 'touchend', this._onDrop);
    off(ownerDocument, 'pointerup', this._onDrop);
    off(ownerDocument, 'touchcancel', this._onDrop);
    off(document, 'selectstart', this);
  },
  _onDrop: function _onDrop(
  /**Event*/
  evt) {
    var el = this.el,
        options = this.options; // Get the index of the dragged element within its parent

    newIndex = sortable_esm_index(dragEl);
    newDraggableIndex = sortable_esm_index(dragEl, options.draggable);
    pluginEvent('drop', this, {
      evt: evt
    });
    parentEl = dragEl && dragEl.parentNode; // Get again after plugin event

    newIndex = sortable_esm_index(dragEl);
    newDraggableIndex = sortable_esm_index(dragEl, options.draggable);

    if (Sortable.eventCanceled) {
      this._nulling();

      return;
    }

    awaitingDragStarted = false;
    isCircumstantialInvert = false;
    pastFirstInvertThresh = false;
    clearInterval(this._loopId);
    clearTimeout(this._dragStartTimer);

    _cancelNextTick(this.cloneId);

    _cancelNextTick(this._dragStartId); // Unbind events


    if (this.nativeDraggable) {
      off(document, 'drop', this);
      off(el, 'dragstart', this._onDragStart);
    }

    this._offMoveEvents();

    this._offUpEvents();

    if (Safari) {
      css(document.body, 'user-select', '');
    }

    css(dragEl, 'transform', '');

    if (evt) {
      if (moved) {
        evt.cancelable && evt.preventDefault();
        !options.dropBubble && evt.stopPropagation();
      }

      ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);

      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
        // Remove clone(s)
        cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
      }

      if (dragEl) {
        if (this.nativeDraggable) {
          off(dragEl, 'dragend', this);
        }

        _disableDraggable(dragEl);

        dragEl.style['will-change'] = ''; // Remove classes
        // ghostClass is added in dragStarted

        if (moved && !awaitingDragStarted) {
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
        }

        toggleClass(dragEl, this.options.chosenClass, false); // Drag stop event

        _dispatchEvent({
          sortable: this,
          name: 'unchoose',
          toEl: parentEl,
          newIndex: null,
          newDraggableIndex: null,
          originalEvent: evt
        });

        if (rootEl !== parentEl) {
          if (newIndex >= 0) {
            // Add event
            _dispatchEvent({
              rootEl: parentEl,
              name: 'add',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            }); // Remove event


            _dispatchEvent({
              sortable: this,
              name: 'remove',
              toEl: parentEl,
              originalEvent: evt
            }); // drag from one list and drop into another


            _dispatchEvent({
              rootEl: parentEl,
              name: 'sort',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });

            _dispatchEvent({
              sortable: this,
              name: 'sort',
              toEl: parentEl,
              originalEvent: evt
            });
          }

          putSortable && putSortable.save();
        } else {
          if (newIndex !== oldIndex) {
            if (newIndex >= 0) {
              // drag & drop within the same list
              _dispatchEvent({
                sortable: this,
                name: 'update',
                toEl: parentEl,
                originalEvent: evt
              });

              _dispatchEvent({
                sortable: this,
                name: 'sort',
                toEl: parentEl,
                originalEvent: evt
              });
            }
          }
        }

        if (Sortable.active) {
          /* jshint eqnull:true */
          if (newIndex == null || newIndex === -1) {
            newIndex = oldIndex;
            newDraggableIndex = oldDraggableIndex;
          }

          _dispatchEvent({
            sortable: this,
            name: 'end',
            toEl: parentEl,
            originalEvent: evt
          }); // Save sorting


          this.save();
        }
      }
    }

    this._nulling();
  },
  _nulling: function _nulling() {
    pluginEvent('nulling', this);
    rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
    savedInputChecked.forEach(function (el) {
      el.checked = true;
    });
    savedInputChecked.length = lastDx = lastDy = 0;
  },
  handleEvent: function handleEvent(
  /**Event*/
  evt) {
    switch (evt.type) {
      case 'drop':
      case 'dragend':
        this._onDrop(evt);

        break;

      case 'dragenter':
      case 'dragover':
        if (dragEl) {
          this._onDragOver(evt);

          _globalDragOver(evt);
        }

        break;

      case 'selectstart':
        evt.preventDefault();
        break;
    }
  },

  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function toArray() {
    var order = [],
        el,
        children = this.el.children,
        i = 0,
        n = children.length,
        options = this.options;

    for (; i < n; i++) {
      el = children[i];

      if (closest(el, options.draggable, this.el, false)) {
        order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
      }
    }

    return order;
  },

  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function sort(order) {
    var items = {},
        rootEl = this.el;
    this.toArray().forEach(function (id, i) {
      var el = rootEl.children[i];

      if (closest(el, this.options.draggable, rootEl, false)) {
        items[id] = el;
      }
    }, this);
    order.forEach(function (id) {
      if (items[id]) {
        rootEl.removeChild(items[id]);
        rootEl.appendChild(items[id]);
      }
    });
  },

  /**
   * Save the current sorting
   */
  save: function save() {
    var store = this.options.store;
    store && store.set && store.set(this);
  },

  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function closest$1(el, selector) {
    return closest(el, selector || this.options.draggable, this.el, false);
  },

  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function option(name, value) {
    var options = this.options;

    if (value === void 0) {
      return options[name];
    } else {
      var modifiedValue = PluginManager.modifyOption(this, name, value);

      if (typeof modifiedValue !== 'undefined') {
        options[name] = modifiedValue;
      } else {
        options[name] = value;
      }

      if (name === 'group') {
        _prepareGroup(options);
      }
    }
  },

  /**
   * Destroy
   */
  destroy: function destroy() {
    pluginEvent('destroy', this);
    var el = this.el;
    el[expando] = null;
    off(el, 'mousedown', this._onTapStart);
    off(el, 'touchstart', this._onTapStart);
    off(el, 'pointerdown', this._onTapStart);

    if (this.nativeDraggable) {
      off(el, 'dragover', this);
      off(el, 'dragenter', this);
    } // Remove draggable attributes


    Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
      el.removeAttribute('draggable');
    });

    this._onDrop();

    this._disableDelayedDragEvents();

    sortables.splice(sortables.indexOf(this.el), 1);
    this.el = el = null;
  },
  _hideClone: function _hideClone() {
    if (!cloneHidden) {
      pluginEvent('hideClone', this);
      if (Sortable.eventCanceled) return;
      css(cloneEl, 'display', 'none');

      if (this.options.removeCloneOnHide && cloneEl.parentNode) {
        cloneEl.parentNode.removeChild(cloneEl);
      }

      cloneHidden = true;
    }
  },
  _showClone: function _showClone(putSortable) {
    if (putSortable.lastPutMode !== 'clone') {
      this._hideClone();

      return;
    }

    if (cloneHidden) {
      pluginEvent('showClone', this);
      if (Sortable.eventCanceled) return; // show clone at dragEl or original position

      if (rootEl.contains(dragEl) && !this.options.group.revertClone) {
        rootEl.insertBefore(cloneEl, dragEl);
      } else if (nextEl) {
        rootEl.insertBefore(cloneEl, nextEl);
      } else {
        rootEl.appendChild(cloneEl);
      }

      if (this.options.group.revertClone) {
        this.animate(dragEl, cloneEl);
      }

      css(cloneEl, 'display', '');
      cloneHidden = false;
    }
  }
};

function _globalDragOver(
/**Event*/
evt) {
  if (evt.dataTransfer) {
    evt.dataTransfer.dropEffect = 'move';
  }

  evt.cancelable && evt.preventDefault();
}

function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
  var evt,
      sortable = fromEl[expando],
      onMoveFn = sortable.options.onMove,
      retVal; // Support for new CustomEvent feature

  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent('move', {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent('move', true, true);
  }

  evt.to = toEl;
  evt.from = fromEl;
  evt.dragged = dragEl;
  evt.draggedRect = dragRect;
  evt.related = targetEl || toEl;
  evt.relatedRect = targetRect || getRect(toEl);
  evt.willInsertAfter = willInsertAfter;
  evt.originalEvent = originalEvent;
  fromEl.dispatchEvent(evt);

  if (onMoveFn) {
    retVal = onMoveFn.call(sortable, evt, originalEvent);
  }

  return retVal;
}

function _disableDraggable(el) {
  el.draggable = false;
}

function _unsilent() {
  _silent = false;
}

function _ghostIsLast(evt, vertical, sortable) {
  var rect = getRect(lastChild(sortable.el, sortable.options.draggable));
  var spacer = 10;
  return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
}

function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
  var mouseOnAxis = vertical ? evt.clientY : evt.clientX,
      targetLength = vertical ? targetRect.height : targetRect.width,
      targetS1 = vertical ? targetRect.top : targetRect.left,
      targetS2 = vertical ? targetRect.bottom : targetRect.right,
      invert = false;

  if (!invertSwap) {
    // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
    if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
      // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
      // check if past first invert threshold on side opposite of lastDirection
      if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
        // past first invert threshold, do not restrict inverted threshold to dragEl shadow
        pastFirstInvertThresh = true;
      }

      if (!pastFirstInvertThresh) {
        // dragEl shadow (target move distance shadow)
        if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance // over dragEl shadow
        : mouseOnAxis > targetS2 - targetMoveDistance) {
          return -lastDirection;
        }
      } else {
        invert = true;
      }
    } else {
      // Regular
      if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
        return _getInsertDirection(target);
      }
    }
  }

  invert = invert || invertSwap;

  if (invert) {
    // Invert of regular
    if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
      return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
  }

  return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */


function _getInsertDirection(target) {
  if (sortable_esm_index(dragEl) < sortable_esm_index(target)) {
    return 1;
  } else {
    return -1;
  }
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */


function _generateId(el) {
  var str = el.tagName + el.className + el.src + el.href + el.textContent,
      i = str.length,
      sum = 0;

  while (i--) {
    sum += str.charCodeAt(i);
  }

  return sum.toString(36);
}

function _saveInputCheckedState(root) {
  savedInputChecked.length = 0;
  var inputs = root.getElementsByTagName('input');
  var idx = inputs.length;

  while (idx--) {
    var el = inputs[idx];
    el.checked && savedInputChecked.push(el);
  }
}

function _nextTick(fn) {
  return setTimeout(fn, 0);
}

function _cancelNextTick(id) {
  return clearTimeout(id);
} // Fixed #973:


if (documentExists) {
  on(document, 'touchmove', function (evt) {
    if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
      evt.preventDefault();
    }
  });
} // Export utils


Sortable.utils = {
  on: on,
  off: off,
  css: css,
  find: find,
  is: function is(el, selector) {
    return !!closest(el, selector, el, false);
  },
  extend: extend,
  throttle: throttle,
  closest: closest,
  toggleClass: toggleClass,
  clone: clone,
  index: sortable_esm_index,
  nextTick: _nextTick,
  cancelNextTick: _cancelNextTick,
  detectDirection: _detectDirection,
  getChild: getChild
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */

Sortable.get = function (element) {
  return element[expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */


Sortable.mount = function () {
  for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
    plugins[_key] = arguments[_key];
  }

  if (plugins[0].constructor === Array) plugins = plugins[0];
  plugins.forEach(function (plugin) {
    if (!plugin.prototype || !plugin.prototype.constructor) {
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
    }

    if (plugin.utils) Sortable.utils = _objectSpread({}, Sortable.utils, plugin.utils);
    PluginManager.mount(plugin);
  });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */


Sortable.create = function (el, options) {
  return new Sortable(el, options);
}; // Export


Sortable.version = version;

var autoScrolls = [],
    scrollEl,
    scrollRootEl,
    scrolling = false,
    lastAutoScrollX,
    lastAutoScrollY,
    touchEvt$1,
    pointerElemChangedInterval;

function AutoScrollPlugin() {
  function AutoScroll() {
    this.defaults = {
      scroll: true,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: true
    }; // Bind all private methods

    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    }
  }

  AutoScroll.prototype = {
    dragStarted: function dragStarted(_ref) {
      var originalEvent = _ref.originalEvent;

      if (this.sortable.nativeDraggable) {
        on(document, 'dragover', this._handleAutoScroll);
      } else {
        if (this.options.supportPointer) {
          on(document, 'pointermove', this._handleFallbackAutoScroll);
        } else if (originalEvent.touches) {
          on(document, 'touchmove', this._handleFallbackAutoScroll);
        } else {
          on(document, 'mousemove', this._handleFallbackAutoScroll);
        }
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref2) {
      var originalEvent = _ref2.originalEvent;

      // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
      if (!this.options.dragOverBubble && !originalEvent.rootEl) {
        this._handleAutoScroll(originalEvent);
      }
    },
    drop: function drop() {
      if (this.sortable.nativeDraggable) {
        off(document, 'dragover', this._handleAutoScroll);
      } else {
        off(document, 'pointermove', this._handleFallbackAutoScroll);
        off(document, 'touchmove', this._handleFallbackAutoScroll);
        off(document, 'mousemove', this._handleFallbackAutoScroll);
      }

      clearPointerElemChangedInterval();
      clearAutoScrolls();
      cancelThrottle();
    },
    nulling: function nulling() {
      touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
      autoScrolls.length = 0;
    },
    _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
      this._handleAutoScroll(evt, true);
    },
    _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
      var _this = this;

      var x = (evt.touches ? evt.touches[0] : evt).clientX,
          y = (evt.touches ? evt.touches[0] : evt).clientY,
          elem = document.elementFromPoint(x, y);
      touchEvt$1 = evt; // IE does not seem to have native autoscroll,
      // Edge's autoscroll seems too conditional,
      // MACOS Safari does not have autoscroll,
      // Firefox and Chrome are good

      if (fallback || Edge || IE11OrLess || Safari) {
        autoScroll(evt, this.options, elem, fallback); // Listener for pointer element change

        var ogElemScroller = getParentAutoScrollElement(elem, true);

        if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
          pointerElemChangedInterval && clearPointerElemChangedInterval(); // Detect for pointer elem change, emulating native DnD behaviour

          pointerElemChangedInterval = setInterval(function () {
            var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);

            if (newElem !== ogElemScroller) {
              ogElemScroller = newElem;
              clearAutoScrolls();
            }

            autoScroll(evt, _this.options, newElem, fallback);
          }, 10);
          lastAutoScrollX = x;
          lastAutoScrollY = y;
        }
      } else {
        // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
        if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
          clearAutoScrolls();
          return;
        }

        autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
      }
    }
  };
  return _extends(AutoScroll, {
    pluginName: 'scroll',
    initializeByDefault: true
  });
}

function clearAutoScrolls() {
  autoScrolls.forEach(function (autoScroll) {
    clearInterval(autoScroll.pid);
  });
  autoScrolls = [];
}

function clearPointerElemChangedInterval() {
  clearInterval(pointerElemChangedInterval);
}

var autoScroll = throttle(function (evt, options, rootEl, isFallback) {
  // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
  if (!options.scroll) return;
  var x = (evt.touches ? evt.touches[0] : evt).clientX,
      y = (evt.touches ? evt.touches[0] : evt).clientY,
      sens = options.scrollSensitivity,
      speed = options.scrollSpeed,
      winScroller = getWindowScrollingElement();
  var scrollThisInstance = false,
      scrollCustomFn; // New scroll root, set scrollEl

  if (scrollRootEl !== rootEl) {
    scrollRootEl = rootEl;
    clearAutoScrolls();
    scrollEl = options.scroll;
    scrollCustomFn = options.scrollFn;

    if (scrollEl === true) {
      scrollEl = getParentAutoScrollElement(rootEl, true);
    }
  }

  var layersOut = 0;
  var currentParent = scrollEl;

  do {
    var el = currentParent,
        rect = getRect(el),
        top = rect.top,
        bottom = rect.bottom,
        left = rect.left,
        right = rect.right,
        width = rect.width,
        height = rect.height,
        canScrollX = void 0,
        canScrollY = void 0,
        scrollWidth = el.scrollWidth,
        scrollHeight = el.scrollHeight,
        elCSS = css(el),
        scrollPosX = el.scrollLeft,
        scrollPosY = el.scrollTop;

    if (el === winScroller) {
      canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
      canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
    } else {
      canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
      canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
    }

    var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
    var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);

    if (!autoScrolls[layersOut]) {
      for (var i = 0; i <= layersOut; i++) {
        if (!autoScrolls[i]) {
          autoScrolls[i] = {};
        }
      }
    }

    if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
      autoScrolls[layersOut].el = el;
      autoScrolls[layersOut].vx = vx;
      autoScrolls[layersOut].vy = vy;
      clearInterval(autoScrolls[layersOut].pid);

      if (vx != 0 || vy != 0) {
        scrollThisInstance = true;
        /* jshint loopfunc:true */

        autoScrolls[layersOut].pid = setInterval(function () {
          // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
          if (isFallback && this.layer === 0) {
            Sortable.active._onTouchMove(touchEvt$1); // To move ghost if it is positioned absolutely

          }

          var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
          var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;

          if (typeof scrollCustomFn === 'function') {
            if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== 'continue') {
              return;
            }
          }

          scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
        }.bind({
          layer: layersOut
        }), 24);
      }
    }

    layersOut++;
  } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));

  scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);

var drop = function drop(_ref) {
  var originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      dragEl = _ref.dragEl,
      activeSortable = _ref.activeSortable,
      dispatchSortableEvent = _ref.dispatchSortableEvent,
      hideGhostForTarget = _ref.hideGhostForTarget,
      unhideGhostForTarget = _ref.unhideGhostForTarget;
  if (!originalEvent) return;
  var toSortable = putSortable || activeSortable;
  hideGhostForTarget();
  var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
  var target = document.elementFromPoint(touch.clientX, touch.clientY);
  unhideGhostForTarget();

  if (toSortable && !toSortable.el.contains(target)) {
    dispatchSortableEvent('spill');
    this.onSpill({
      dragEl: dragEl,
      putSortable: putSortable
    });
  }
};

function Revert() {}

Revert.prototype = {
  startIndex: null,
  dragStart: function dragStart(_ref2) {
    var oldDraggableIndex = _ref2.oldDraggableIndex;
    this.startIndex = oldDraggableIndex;
  },
  onSpill: function onSpill(_ref3) {
    var dragEl = _ref3.dragEl,
        putSortable = _ref3.putSortable;
    this.sortable.captureAnimationState();

    if (putSortable) {
      putSortable.captureAnimationState();
    }

    var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);

    if (nextSibling) {
      this.sortable.el.insertBefore(dragEl, nextSibling);
    } else {
      this.sortable.el.appendChild(dragEl);
    }

    this.sortable.animateAll();

    if (putSortable) {
      putSortable.animateAll();
    }
  },
  drop: drop
};

_extends(Revert, {
  pluginName: 'revertOnSpill'
});

function Remove() {}

Remove.prototype = {
  onSpill: function onSpill(_ref4) {
    var dragEl = _ref4.dragEl,
        putSortable = _ref4.putSortable;
    var parentSortable = putSortable || this.sortable;
    parentSortable.captureAnimationState();
    dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
    parentSortable.animateAll();
  },
  drop: drop
};

_extends(Remove, {
  pluginName: 'removeOnSpill'
});

var lastSwapEl;

function SwapPlugin() {
  function Swap() {
    this.defaults = {
      swapClass: 'sortable-swap-highlight'
    };
  }

  Swap.prototype = {
    dragStart: function dragStart(_ref) {
      var dragEl = _ref.dragEl;
      lastSwapEl = dragEl;
    },
    dragOverValid: function dragOverValid(_ref2) {
      var completed = _ref2.completed,
          target = _ref2.target,
          onMove = _ref2.onMove,
          activeSortable = _ref2.activeSortable,
          changed = _ref2.changed,
          cancel = _ref2.cancel;
      if (!activeSortable.options.swap) return;
      var el = this.sortable.el,
          options = this.options;

      if (target && target !== el) {
        var prevSwapEl = lastSwapEl;

        if (onMove(target) !== false) {
          toggleClass(target, options.swapClass, true);
          lastSwapEl = target;
        } else {
          lastSwapEl = null;
        }

        if (prevSwapEl && prevSwapEl !== lastSwapEl) {
          toggleClass(prevSwapEl, options.swapClass, false);
        }
      }

      changed();
      completed(true);
      cancel();
    },
    drop: function drop(_ref3) {
      var activeSortable = _ref3.activeSortable,
          putSortable = _ref3.putSortable,
          dragEl = _ref3.dragEl;
      var toSortable = putSortable || this.sortable;
      var options = this.options;
      lastSwapEl && toggleClass(lastSwapEl, options.swapClass, false);

      if (lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
        if (dragEl !== lastSwapEl) {
          toSortable.captureAnimationState();
          if (toSortable !== activeSortable) activeSortable.captureAnimationState();
          swapNodes(dragEl, lastSwapEl);
          toSortable.animateAll();
          if (toSortable !== activeSortable) activeSortable.animateAll();
        }
      }
    },
    nulling: function nulling() {
      lastSwapEl = null;
    }
  };
  return _extends(Swap, {
    pluginName: 'swap',
    eventProperties: function eventProperties() {
      return {
        swapItem: lastSwapEl
      };
    }
  });
}

function swapNodes(n1, n2) {
  var p1 = n1.parentNode,
      p2 = n2.parentNode,
      i1,
      i2;
  if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
  i1 = sortable_esm_index(n1);
  i2 = sortable_esm_index(n2);

  if (p1.isEqualNode(p2) && i1 < i2) {
    i2++;
  }

  p1.insertBefore(n2, p1.children[i1]);
  p2.insertBefore(n1, p2.children[i2]);
}

var multiDragElements = [],
    multiDragClones = [],
    lastMultiDragSelect,
    // for selection with modifier key down (SHIFT)
multiDragSortable,
    initialFolding = false,
    // Initial multi-drag fold when drag started
folding = false,
    // Folding any other time
dragStarted = false,
    dragEl$1,
    clonesFromRect,
    clonesHidden;

function MultiDragPlugin() {
  function MultiDrag(sortable) {
    // Bind all private methods
    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    }

    if (sortable.options.supportPointer) {
      on(document, 'pointerup', this._deselectMultiDrag);
    } else {
      on(document, 'mouseup', this._deselectMultiDrag);
      on(document, 'touchend', this._deselectMultiDrag);
    }

    on(document, 'keydown', this._checkKeyDown);
    on(document, 'keyup', this._checkKeyUp);
    this.defaults = {
      selectedClass: 'sortable-selected',
      multiDragKey: null,
      setData: function setData(dataTransfer, dragEl) {
        var data = '';

        if (multiDragElements.length && multiDragSortable === sortable) {
          multiDragElements.forEach(function (multiDragElement, i) {
            data += (!i ? '' : ', ') + multiDragElement.textContent;
          });
        } else {
          data = dragEl.textContent;
        }

        dataTransfer.setData('Text', data);
      }
    };
  }

  MultiDrag.prototype = {
    multiDragKeyDown: false,
    isMultiDrag: false,
    delayStartGlobal: function delayStartGlobal(_ref) {
      var dragged = _ref.dragEl;
      dragEl$1 = dragged;
    },
    delayEnded: function delayEnded() {
      this.isMultiDrag = ~multiDragElements.indexOf(dragEl$1);
    },
    setupClone: function setupClone(_ref2) {
      var sortable = _ref2.sortable,
          cancel = _ref2.cancel;
      if (!this.isMultiDrag) return;

      for (var i = 0; i < multiDragElements.length; i++) {
        multiDragClones.push(clone(multiDragElements[i]));
        multiDragClones[i].sortableIndex = multiDragElements[i].sortableIndex;
        multiDragClones[i].draggable = false;
        multiDragClones[i].style['will-change'] = '';
        toggleClass(multiDragClones[i], this.options.selectedClass, false);
        multiDragElements[i] === dragEl$1 && toggleClass(multiDragClones[i], this.options.chosenClass, false);
      }

      sortable._hideClone();

      cancel();
    },
    clone: function clone(_ref3) {
      var sortable = _ref3.sortable,
          rootEl = _ref3.rootEl,
          dispatchSortableEvent = _ref3.dispatchSortableEvent,
          cancel = _ref3.cancel;
      if (!this.isMultiDrag) return;

      if (!this.options.removeCloneOnHide) {
        if (multiDragElements.length && multiDragSortable === sortable) {
          insertMultiDragClones(true, rootEl);
          dispatchSortableEvent('clone');
          cancel();
        }
      }
    },
    showClone: function showClone(_ref4) {
      var cloneNowShown = _ref4.cloneNowShown,
          rootEl = _ref4.rootEl,
          cancel = _ref4.cancel;
      if (!this.isMultiDrag) return;
      insertMultiDragClones(false, rootEl);
      multiDragClones.forEach(function (clone) {
        css(clone, 'display', '');
      });
      cloneNowShown();
      clonesHidden = false;
      cancel();
    },
    hideClone: function hideClone(_ref5) {
      var _this = this;

      var sortable = _ref5.sortable,
          cloneNowHidden = _ref5.cloneNowHidden,
          cancel = _ref5.cancel;
      if (!this.isMultiDrag) return;
      multiDragClones.forEach(function (clone) {
        css(clone, 'display', 'none');

        if (_this.options.removeCloneOnHide && clone.parentNode) {
          clone.parentNode.removeChild(clone);
        }
      });
      cloneNowHidden();
      clonesHidden = true;
      cancel();
    },
    dragStartGlobal: function dragStartGlobal(_ref6) {
      var sortable = _ref6.sortable;

      if (!this.isMultiDrag && multiDragSortable) {
        multiDragSortable.multiDrag._deselectMultiDrag();
      }

      multiDragElements.forEach(function (multiDragElement) {
        multiDragElement.sortableIndex = sortable_esm_index(multiDragElement);
      }); // Sort multi-drag elements

      multiDragElements = multiDragElements.sort(function (a, b) {
        return a.sortableIndex - b.sortableIndex;
      });
      dragStarted = true;
    },
    dragStarted: function dragStarted(_ref7) {
      var _this2 = this;

      var sortable = _ref7.sortable;
      if (!this.isMultiDrag) return;

      if (this.options.sort) {
        // Capture rects,
        // hide multi drag elements (by positioning them absolute),
        // set multi drag elements rects to dragRect,
        // show multi drag elements,
        // animate to rects,
        // unset rects & remove from DOM
        sortable.captureAnimationState();

        if (this.options.animation) {
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            css(multiDragElement, 'position', 'absolute');
          });
          var dragRect = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            setRect(multiDragElement, dragRect);
          });
          folding = true;
          initialFolding = true;
        }
      }

      sortable.animateAll(function () {
        folding = false;
        initialFolding = false;

        if (_this2.options.animation) {
          multiDragElements.forEach(function (multiDragElement) {
            unsetRect(multiDragElement);
          });
        } // Remove all auxiliary multidrag items from el, if sorting enabled


        if (_this2.options.sort) {
          removeMultiDragElements();
        }
      });
    },
    dragOver: function dragOver(_ref8) {
      var target = _ref8.target,
          completed = _ref8.completed,
          cancel = _ref8.cancel;

      if (folding && ~multiDragElements.indexOf(target)) {
        completed(false);
        cancel();
      }
    },
    revert: function revert(_ref9) {
      var fromSortable = _ref9.fromSortable,
          rootEl = _ref9.rootEl,
          sortable = _ref9.sortable,
          dragRect = _ref9.dragRect;

      if (multiDragElements.length > 1) {
        // Setup unfold animation
        multiDragElements.forEach(function (multiDragElement) {
          sortable.addAnimationState({
            target: multiDragElement,
            rect: folding ? getRect(multiDragElement) : dragRect
          });
          unsetRect(multiDragElement);
          multiDragElement.fromRect = dragRect;
          fromSortable.removeAnimationState(multiDragElement);
        });
        folding = false;
        insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref10) {
      var sortable = _ref10.sortable,
          isOwner = _ref10.isOwner,
          insertion = _ref10.insertion,
          activeSortable = _ref10.activeSortable,
          parentEl = _ref10.parentEl,
          putSortable = _ref10.putSortable;
      var options = this.options;

      if (insertion) {
        // Clones must be hidden before folding animation to capture dragRectAbsolute properly
        if (isOwner) {
          activeSortable._hideClone();
        }

        initialFolding = false; // If leaving sort:false root, or already folding - Fold to new location

        if (options.animation && multiDragElements.length > 1 && (folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
          // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
          var dragRectAbsolute = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            setRect(multiDragElement, dragRectAbsolute); // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
            // while folding, and so that we can capture them again because old sortable will no longer be fromSortable

            parentEl.appendChild(multiDragElement);
          });
          folding = true;
        } // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out


        if (!isOwner) {
          // Only remove if not folding (folding will remove them anyways)
          if (!folding) {
            removeMultiDragElements();
          }

          if (multiDragElements.length > 1) {
            var clonesHiddenBefore = clonesHidden;

            activeSortable._showClone(sortable); // Unfold animation for clones if showing from hidden


            if (activeSortable.options.animation && !clonesHidden && clonesHiddenBefore) {
              multiDragClones.forEach(function (clone) {
                activeSortable.addAnimationState({
                  target: clone,
                  rect: clonesFromRect
                });
                clone.fromRect = clonesFromRect;
                clone.thisAnimationDuration = null;
              });
            }
          } else {
            activeSortable._showClone(sortable);
          }
        }
      }
    },
    dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
      var dragRect = _ref11.dragRect,
          isOwner = _ref11.isOwner,
          activeSortable = _ref11.activeSortable;
      multiDragElements.forEach(function (multiDragElement) {
        multiDragElement.thisAnimationDuration = null;
      });

      if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
        clonesFromRect = _extends({}, dragRect);
        var dragMatrix = matrix(dragEl$1, true);
        clonesFromRect.top -= dragMatrix.f;
        clonesFromRect.left -= dragMatrix.e;
      }
    },
    dragOverAnimationComplete: function dragOverAnimationComplete() {
      if (folding) {
        folding = false;
        removeMultiDragElements();
      }
    },
    drop: function drop(_ref12) {
      var evt = _ref12.originalEvent,
          rootEl = _ref12.rootEl,
          parentEl = _ref12.parentEl,
          sortable = _ref12.sortable,
          dispatchSortableEvent = _ref12.dispatchSortableEvent,
          oldIndex = _ref12.oldIndex,
          putSortable = _ref12.putSortable;
      var toSortable = putSortable || this.sortable;
      if (!evt) return;
      var options = this.options,
          children = parentEl.children; // Multi-drag selection

      if (!dragStarted) {
        if (options.multiDragKey && !this.multiDragKeyDown) {
          this._deselectMultiDrag();
        }

        toggleClass(dragEl$1, options.selectedClass, !~multiDragElements.indexOf(dragEl$1));

        if (!~multiDragElements.indexOf(dragEl$1)) {
          multiDragElements.push(dragEl$1);
          dispatchEvent({
            sortable: sortable,
            rootEl: rootEl,
            name: 'select',
            targetEl: dragEl$1,
            originalEvt: evt
          }); // Modifier activated, select from last to dragEl

          if (evt.shiftKey && lastMultiDragSelect && sortable.el.contains(lastMultiDragSelect)) {
            var lastIndex = sortable_esm_index(lastMultiDragSelect),
                currentIndex = sortable_esm_index(dragEl$1);

            if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
              // Must include lastMultiDragSelect (select it), in case modified selection from no selection
              // (but previous selection existed)
              var n, i;

              if (currentIndex > lastIndex) {
                i = lastIndex;
                n = currentIndex;
              } else {
                i = currentIndex;
                n = lastIndex + 1;
              }

              for (; i < n; i++) {
                if (~multiDragElements.indexOf(children[i])) continue;
                toggleClass(children[i], options.selectedClass, true);
                multiDragElements.push(children[i]);
                dispatchEvent({
                  sortable: sortable,
                  rootEl: rootEl,
                  name: 'select',
                  targetEl: children[i],
                  originalEvt: evt
                });
              }
            }
          } else {
            lastMultiDragSelect = dragEl$1;
          }

          multiDragSortable = toSortable;
        } else {
          multiDragElements.splice(multiDragElements.indexOf(dragEl$1), 1);
          lastMultiDragSelect = null;
          dispatchEvent({
            sortable: sortable,
            rootEl: rootEl,
            name: 'deselect',
            targetEl: dragEl$1,
            originalEvt: evt
          });
        }
      } // Multi-drag drop


      if (dragStarted && this.isMultiDrag) {
        // Do not "unfold" after around dragEl if reverted
        if ((parentEl[expando].options.sort || parentEl !== rootEl) && multiDragElements.length > 1) {
          var dragRect = getRect(dragEl$1),
              multiDragIndex = sortable_esm_index(dragEl$1, ':not(.' + this.options.selectedClass + ')');
          if (!initialFolding && options.animation) dragEl$1.thisAnimationDuration = null;
          toSortable.captureAnimationState();

          if (!initialFolding) {
            if (options.animation) {
              dragEl$1.fromRect = dragRect;
              multiDragElements.forEach(function (multiDragElement) {
                multiDragElement.thisAnimationDuration = null;

                if (multiDragElement !== dragEl$1) {
                  var rect = folding ? getRect(multiDragElement) : dragRect;
                  multiDragElement.fromRect = rect; // Prepare unfold animation

                  toSortable.addAnimationState({
                    target: multiDragElement,
                    rect: rect
                  });
                }
              });
            } // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
            // properly they must all be removed


            removeMultiDragElements();
            multiDragElements.forEach(function (multiDragElement) {
              if (children[multiDragIndex]) {
                parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
              } else {
                parentEl.appendChild(multiDragElement);
              }

              multiDragIndex++;
            }); // If initial folding is done, the elements may have changed position because they are now
            // unfolding around dragEl, even though dragEl may not have his index changed, so update event
            // must be fired here as Sortable will not.

            if (oldIndex === sortable_esm_index(dragEl$1)) {
              var update = false;
              multiDragElements.forEach(function (multiDragElement) {
                if (multiDragElement.sortableIndex !== sortable_esm_index(multiDragElement)) {
                  update = true;
                  return;
                }
              });

              if (update) {
                dispatchSortableEvent('update');
              }
            }
          } // Must be done after capturing individual rects (scroll bar)


          multiDragElements.forEach(function (multiDragElement) {
            unsetRect(multiDragElement);
          });
          toSortable.animateAll();
        }

        multiDragSortable = toSortable;
      } // Remove clones if necessary


      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
        multiDragClones.forEach(function (clone) {
          clone.parentNode && clone.parentNode.removeChild(clone);
        });
      }
    },
    nullingGlobal: function nullingGlobal() {
      this.isMultiDrag = dragStarted = false;
      multiDragClones.length = 0;
    },
    destroyGlobal: function destroyGlobal() {
      this._deselectMultiDrag();

      off(document, 'pointerup', this._deselectMultiDrag);
      off(document, 'mouseup', this._deselectMultiDrag);
      off(document, 'touchend', this._deselectMultiDrag);
      off(document, 'keydown', this._checkKeyDown);
      off(document, 'keyup', this._checkKeyUp);
    },
    _deselectMultiDrag: function _deselectMultiDrag(evt) {
      if (typeof dragStarted !== "undefined" && dragStarted) return; // Only deselect if selection is in this sortable

      if (multiDragSortable !== this.sortable) return; // Only deselect if target is not item in this sortable

      if (evt && closest(evt.target, this.options.draggable, this.sortable.el, false)) return; // Only deselect if left click

      if (evt && evt.button !== 0) return;

      while (multiDragElements.length) {
        var el = multiDragElements[0];
        toggleClass(el, this.options.selectedClass, false);
        multiDragElements.shift();
        dispatchEvent({
          sortable: this.sortable,
          rootEl: this.sortable.el,
          name: 'deselect',
          targetEl: el,
          originalEvt: evt
        });
      }
    },
    _checkKeyDown: function _checkKeyDown(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = true;
      }
    },
    _checkKeyUp: function _checkKeyUp(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = false;
      }
    }
  };
  return _extends(MultiDrag, {
    // Static methods & properties
    pluginName: 'multiDrag',
    utils: {
      /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */
      select: function select(el) {
        var sortable = el.parentNode[expando];
        if (!sortable || !sortable.options.multiDrag || ~multiDragElements.indexOf(el)) return;

        if (multiDragSortable && multiDragSortable !== sortable) {
          multiDragSortable.multiDrag._deselectMultiDrag();

          multiDragSortable = sortable;
        }

        toggleClass(el, sortable.options.selectedClass, true);
        multiDragElements.push(el);
      },

      /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */
      deselect: function deselect(el) {
        var sortable = el.parentNode[expando],
            index = multiDragElements.indexOf(el);
        if (!sortable || !sortable.options.multiDrag || !~index) return;
        toggleClass(el, sortable.options.selectedClass, false);
        multiDragElements.splice(index, 1);
      }
    },
    eventProperties: function eventProperties() {
      var _this3 = this;

      var oldIndicies = [],
          newIndicies = [];
      multiDragElements.forEach(function (multiDragElement) {
        oldIndicies.push({
          multiDragElement: multiDragElement,
          index: multiDragElement.sortableIndex
        }); // multiDragElements will already be sorted if folding

        var newIndex;

        if (folding && multiDragElement !== dragEl$1) {
          newIndex = -1;
        } else if (folding) {
          newIndex = sortable_esm_index(multiDragElement, ':not(.' + _this3.options.selectedClass + ')');
        } else {
          newIndex = sortable_esm_index(multiDragElement);
        }

        newIndicies.push({
          multiDragElement: multiDragElement,
          index: newIndex
        });
      });
      return {
        items: _toConsumableArray(multiDragElements),
        clones: [].concat(multiDragClones),
        oldIndicies: oldIndicies,
        newIndicies: newIndicies
      };
    },
    optionListeners: {
      multiDragKey: function multiDragKey(key) {
        key = key.toLowerCase();

        if (key === 'ctrl') {
          key = 'Control';
        } else if (key.length > 1) {
          key = key.charAt(0).toUpperCase() + key.substr(1);
        }

        return key;
      }
    }
  });
}

function insertMultiDragElements(clonesInserted, rootEl) {
  multiDragElements.forEach(function (multiDragElement, i) {
    var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];

    if (target) {
      rootEl.insertBefore(multiDragElement, target);
    } else {
      rootEl.appendChild(multiDragElement);
    }
  });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */


function insertMultiDragClones(elementsInserted, rootEl) {
  multiDragClones.forEach(function (clone, i) {
    var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];

    if (target) {
      rootEl.insertBefore(clone, target);
    } else {
      rootEl.appendChild(clone);
    }
  });
}

function removeMultiDragElements() {
  multiDragElements.forEach(function (multiDragElement) {
    if (multiDragElement === dragEl$1) return;
    multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
  });
}

Sortable.mount(new AutoScrollPlugin());
Sortable.mount(Remove, Revert);

/* harmony default export */ var sortable_esm = (Sortable);


// CONCATENATED MODULE: ../forms-list/src/list-sort.js



/* harmony default export */ var list_sort = ({

  data(){
    return {
      isSorting: false,
      sortValue: null,
      sorter: null,
      sortPristine: true,
    }
  },

  computed: {
    confirmAction(){
      return {
        label: this.sortConfirm,
        model: Action.GLOBAL,
        action: (row) => { this.stopSort() }
      }
    },

    sortAction(){
      return {
        label: this.sortLabel,
        mode: Action.GLOBAL,
        action: (row) => { this.startSort() }
      }
    },

    sortDisabled(){
      return this.isSorting
    },
  },

  methods: {

    getSorter(){
      let ret = this.sorter;
      if (ret){
        return ret;
      }

      let el = this.$refs.list;
      let opts = {
        animation: 150,
        easing: "cubic-bezier(1, 0, 0, 1)",

        ghostClass: '-ghost',
        chosenClass: '-chosen',
        dragClass: '-drag',

        setData: (dataTransfer, dragEl) => { dataTransfer.hello = 'coucou' },
        onEnd: this.onSortEnd
      };
      
      return this.sorter = sortable_esm.create(el, opts);
    },

    startSort(){
      if (this.isSorting){
        return;
      }

      this.sortValue = [ ...this.value ];
      this.isSorting = true;
      this.sortPristine = true;
      this.getSorter();
      this.getSorter().option("disabled", !this.isSorting);
    },
    
    stopSort(){
      if (!this.isSorting){
        return;
      }
      
      this.isSorting = false;
      this.getSorter().option("disabled", !this.isSorting);
      this.$emit('input', this.sortValue);
    },

    onSortEnd(event){
      this.sortPristine = false;
      this.sortValue = array_move(this.sortValue, event.oldIndex, event.newIndex);
    }
  }
});


function array_move(arr, old_index, new_index) {
  if (new_index >= arr.length) {
    var k = new_index - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr; // for testing
};

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../forms-list/src/list.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var lib_vue_loader_options_forms_list_src_listvue_type_script_lang_js_ = ({
  name: 'FormsList',

  mixins: [
    list_actions, 
    list_add,
    list_selection,
    list_sort
  ],

  model: {
    prop: 'value',
    event: 'input'
  }, 

  props: {
    actions: {
      type: Array,
      default: () => []
    },

    add: {
      type: Boolean,
      default: false
    },

    appearance: {
      type: String,
      default: Appearance.DEFAULT,
      values: [Appearance.DEFAULT],
      validator: (value) => [Appearance.DEFAULT].includes(value)
    },

    events: {
      type: Object
    },

    loading: {
      type: Boolean,
      default: false
    },

    pagination: {
      type: Object
    },

    placeholder: {
      type: String,
      default: 'Enter a value to search for a value to add'
    },

    property: {
      type: String,
      default: 'label'
    },

    provider: {
      type: Function
    },

    select: {
      type: Number,
      default: Selection.NONE,
      values: Selection.ALL,
      validator: value => Selection.ALL.includes(value)
    },

    size: {
      type: String,
      default: Size.M,
      values: [Size.S, Size.M],
      validator: value => [Size.S, Size.M].includes(value)
    },

    sortable: {
      type: Boolean,
      default: false
    },

    sortConfirm: {
      type: String,
      default: 'Confirm'
    },

    sortLabel:{
      type: String,
      default: 'Reorder'
    },

    value: {
      type: Array,
      default: () => [],
      required: true
    }
  },

  computed: {
    attrs(){
      return {
        class: this.classes
      }
    },

    classes(){
      return {
        'forms-list': true,

        '-s': this.size === Size.S,

        '-is-loading': this.loading === true,
        '-is-sorting': this.isSorting === true,

        '-is-interactive': this.hasEvents === true,
      }
    },

    hasEvents(){
      return this.events && Object.keys(this.events).length > 0
    },

    isDisabled(){
      return this.loading || this.disabled
    },

    isEmpty() {
      return this.nEntries == 0
    },

    nEntries(){
      return this.value.length
    }
  },

  watch: {
    value(newVal){
      this.reset()
    }
  },

  methods: {
    entryListeners(entry){
      let ret = {};
      let keys = Object.keys(this.events || {});
      if (keys.length > 0){
        keys.forEach( key => {
          let handler = this.events[key];
          ret[key] = handler.bind(handler, entry);
        })
      }

      return ret;
    },

    reset(){
      if (this.value && this.value.length){
        this.value.forEach(e => {
          e.$id = Symbol();
        })
      }
    }
  },

  mounted(){
    this.reset();
  }
});

// CONCATENATED MODULE: ../forms-list/src/list.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_list_src_listvue_type_script_lang_js_ = (lib_vue_loader_options_forms_list_src_listvue_type_script_lang_js_); 
// CONCATENATED MODULE: ../forms-list/src/list.vue





/* normalize component */

var src_list_component = normalizeComponent(
  forms_list_src_listvue_type_script_lang_js_,
  listvue_type_template_id_2c10af5e_render,
  listvue_type_template_id_2c10af5e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_list = (src_list_component.exports);
// EXTERNAL MODULE: ../forms-list/package.json
var forms_list_package = __webpack_require__("c3a32");

// CONCATENATED MODULE: ../forms-list/src/index.js



src_list.meta = forms_list_package



// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../forms-file/src/component.vue?vue&type=template&id=6bb79a01&
var componentvue_type_template_id_6bb79a01_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({},'div',_vm.attrs,false),[(_vm.hasLabel)?_c('div',{staticClass:"forms-file__header"},[_c('forms-label',{staticClass:"forms-file__label",attrs:{"rel":_vm.id},scopedSlots:_vm._u([{key:"before",fn:function(){return [_vm._t("before")]},proxy:true},{key:"after",fn:function(){return [_vm._t("after")]},proxy:true}],null,true)},[_vm._t("default")],2)],1):_vm._e(),_c('div',{staticClass:"forms-file__body"},[_c('input',_vm._b({on:{"input":_vm.onInputChange}},'input',_vm.inputAttrs,false)),(!_vm.multiple)?_c('label',{staticClass:"forms-file__display",attrs:{"for":_vm.id}},[_c('div',{staticClass:"forms-file__primary"},[(_vm.value && _vm.value.isImage)?_c('div',{staticClass:"forms-file__thumbs",style:({ 'background-image': ("url('" + (_vm.value.src) + "')") })}):_vm._e(),_c('div',{staticClass:"forms-file__label"},[_vm._v(_vm._s(_vm.labelForFile(_vm.value)))])]),(_vm.value)?_c('div',{staticClass:"forms-file__meta"},[_vm._t("meta",[_c('div',{staticClass:"forms-file__meta-entry"},[_c('div',{staticClass:"forms-file__size"},[_vm._v(_vm._s(_vm.value.filesize))])]),_c('div',{staticClass:"forms-file__meta-entry"},[_c('ui-icon',{attrs:{"glyph":_vm.iconForFile(_vm.value)}})],1),(!_vm.value.transferred && !_vm.value.loading)?_c('div',{staticClass:"forms-file__meta-entry"},[_c('ui-icon',{attrs:{"glyph":"upload"}})],1):_vm._e(),(_vm.value.loading)?_c('div',{staticClass:"forms-file__meta-entry"},[_c('ui-loader',{attrs:{"size":"s"}})],1):_vm._e(),(_vm.value.transferred)?_c('div',{staticClass:"forms-file__meta-entry"},[_c('actions-button',{staticClass:"forms-file__clear",attrs:{"icon-post":"cross","size":_vm.size},on:{"click":function($event){return _vm.clear(_vm.value)}}})],1):_vm._e()])],2):_vm._e()]):_c('forms-list',{attrs:{"add":"","size":_vm.size},scopedSlots:_vm._u([{key:"add",fn:function(){return [_c('actions-button',{attrs:{"icon-post":"upload","size":_vm.size},on:{"click":_vm.browse}},[_vm._v(_vm._s(_vm.placeholder))])]},proxy:true},{key:"entry",fn:function(ref){
var entry = ref.entry;
return [_c('div',{staticClass:"forms-file__display"},[_c('div',{staticClass:"forms-file__primary"},[(entry && entry.isImage)?_c('div',{staticClass:"forms-file__thumbs",style:({ 'background-image': ("url('" + (entry.src) + "')") })}):_vm._e(),_c('div',{staticClass:"forms-file__label"},[_vm._v(_vm._s(entry.filename))])]),(entry)?_c('div',{staticClass:"forms-file__meta"},[_vm._t("meta",[_c('div',{staticClass:"forms-file__meta-entry"},[_c('div',{staticClass:"forms-file__size"},[_vm._v(_vm._s(entry.filesize))])]),_c('div',{staticClass:"forms-file__meta-entry"},[_c('ui-icon',{attrs:{"glyph":_vm.iconForFile(entry)}})],1),(!entry.transferred && !entry.loading)?_c('div',{staticClass:"forms-file__meta-entry"},[_c('ui-icon',{attrs:{"glyph":"upload"}})],1):_vm._e(),(entry.loading)?_c('div',{staticClass:"forms-file__meta-entry"},[_c('ui-loader',{attrs:{"size":"s"}})],1):_vm._e(),(!entry.loading)?_c('div',{staticClass:"forms-file__meta-entry"},[_c('actions-button',{staticClass:"forms-file__clear",attrs:{"icon-post":"cross","size":_vm.size},on:{"click":function($event){return _vm.clear(entry)}}})],1):_vm._e()])],2):_vm._e()]),(entry.errors && entry.errors.length > 0)?_c('div',{staticClass:"forms-file__errors"},_vm._l((entry.errors),function(error,i){return _c('forms-label',{key:i,attrs:{"intent":"danger","size":_vm.size}},[_vm._v(_vm._s(error))])}),1):_vm._e()]}}],null,true),model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1),(_vm.value && _vm.value.errors && _vm.value.errors.length)?_c('div',{staticClass:"forms-file__footer forms-file__errors"},_vm._l((_vm.value.errors),function(e){return _c('forms-label',{key:e,staticClass:"forms-file__label",attrs:{"rel":_vm.id,"intent":"danger"}},[_vm._v(_vm._s(e))])}),1):_vm._e()])}
var componentvue_type_template_id_6bb79a01_staticRenderFns = []


// CONCATENATED MODULE: ../forms-file/src/component.vue?vue&type=template&id=6bb79a01&

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../forms-file/src/component.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var componentvue_type_script_lang_js_ = ({
  name: 'FormsFile',

  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    accept: {
      type: String,
      default: MimeType.EXTENSIONS.join(',')
    },

    appearance: {
      type: String,
      default: Appearance.DEFAULT,
      values: [Appearance.DEFAULT],
      validator: (value) => [Appearance.DEFAULT].includes(value)
    },

    copyPaste: {
      type: Boolean,
      default: true
    },

    dragDrop: {
      type: Boolean,
      default: true
    },

    id: {
      type: String,
      default: () => 'forms-file-' + Math.round( Math.random() * 9999999 )
    },

    multiple: {
      type: Boolean,
      default: false
    },

    name: {
      type: String,
      default: () => 'forms-file-' + Math.round( Math.random() * 9999999 )
    },

    placeholder: {
      type: String,
      default: 'Drop a file or click to browse'
    },

    required: {
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: Size.M,
      values: [Size.S, Size.M],
      validator: (value) => [Size.S, Size.M].includes(value)
    },

    value: {
      type: [file_PepperFile, Array]
    }
  },

  computed: {
    attrs(){
      let ret = {
        class: this.classes,
      };

      return ret
    },

    classes(){
      return {
         'forms-file': true,

         '-is-active': this.value,
         '-is-disabled': this.disabled || this.loading,
         '-is-loading': this.loading,
         '-is-required': this.required,
         '-is-read-only': this.readOnly,
         '-is-invalid': this.errors && this.errors.length,

         '-is-single': !this.multiple,
         '-is-multiple': this.multiple,

         '-s': this.size === Size.S,
         '-m': this.size === Size.M,
      }
    },

    hasLabel(){
      return this.hasSlot('default');
    },

    inputAttrs(){
      return {
        accept: this.accept,
        class: 'forms-file__field',
        id: this.id,
        disabled: this.disabled,
        multiple: this.multiple,
        name: this.name,
        ref: 'field',
        required: this.required,
        type: 'file',
        value: this.inputValue
      }
    },

    inputValue(){
      return null
    },
  },

  methods:{
    browse(){
      this.$refs.field.click();
    },

    clear(file){
      if (this.multiple){
        let i = this.value.indexOf(file);
        let r = [ ...this.value ];
        r.splice(i, 1);

        this.$emit('input', r);
      }
      else {
        this.$emit('input', null);
      }
    },

    hasSlot(name){
      return !!this.$slots[name];
    },

    iconForFile(file){
      let ret = 'file-document';

      if (file.type){
          switch(file.type.category){
            case MimeTypeCategory.ARCHIVE:
            ret = 'file-archive';
            break;
          case MimeTypeCategory.AUDIO:
            ret = 'file-audio';
            break;
          case MimeTypeCategory.CODE:
            ret = 'file-code';
            break;
          case MimeTypeCategory.DOCUMENT:
            ret = 'file-document';
            break;
          case MimeTypeCategory.IMAGE:
            ret = 'file-image';
            break;
          case MimeTypeCategory.VIDEO:
            ret = 'file-video';
            break;
        }
      }

      return ret;
    },

    labelForFile(file){
      return file ? file.filename : this.placeholder;
    },

    onBodyClick(){
      this.browse();
    },

    onInputChange(event){
      let files = [ ...event.target.files ];
      let income = files.map( file => {
        return new file_PepperFile({ 
          name: file.name,
          size: file.size,
          src: file,
          type: file.type
        })
      });

      let ret = this.multiple ? [ ...this.value, ...income ] : income[0];
      this.$emit('input', ret);
    }
  }, 

  mounted(){

  }
});

// CONCATENATED MODULE: ../forms-file/src/component.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_componentvue_type_script_lang_js_ = (componentvue_type_script_lang_js_); 
// CONCATENATED MODULE: ../forms-file/src/component.vue





/* normalize component */

var component_component = normalizeComponent(
  src_componentvue_type_script_lang_js_,
  componentvue_type_template_id_6bb79a01_render,
  componentvue_type_template_id_6bb79a01_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_component = (component_component.exports);
// EXTERNAL MODULE: ../forms-file/package.json
var forms_file_package = __webpack_require__("37ac");

// CONCATENATED MODULE: ../forms-file/src/index.js



src_component.meta = forms_file_package



// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../forms-textarea/src/textarea.vue?vue&type=template&id=648d2ea4&
var textareavue_type_template_id_648d2ea4_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[(_vm.hasLabel)?_c('div',{staticClass:"forms-textarea__header"},[_c('forms-label',{staticClass:"forms-textarea__label",attrs:{"rel":_vm.id},scopedSlots:_vm._u([{key:"before",fn:function(){return [_vm._t("before")]},proxy:true},{key:"after",fn:function(){return [_vm._t("after")]},proxy:true}],null,true)},[_vm._t("default")],2)],1):_vm._e(),_c('div',{staticClass:"forms-textarea__body"},[(_vm.iconPre)?_c(_vm.iconPreInteractive ? 'button' : 'div',_vm._g({tag:"component",staticClass:"forms-textarea__pre",class:{'-is-interactive': _vm.iconPreInteractive},attrs:{"disabled":_vm.iconPreDisabled}},_vm.iconPreListeners),[_c('ui-icon',{staticClass:"forms-textarea__icon",attrs:{"glyph":_vm.iconPre}})],1):_vm._e(),_c('div',{staticClass:"forms-textarea__content"},[_c('textarea',_vm._g(_vm._b({directives:[{name:"autofocus",rawName:"v-autofocus",value:(_vm.autofocus),expression:"autofocus"},{name:"model",rawName:"v-model",value:(_vm.ivalue),expression:"ivalue"}],domProps:{"value":(_vm.ivalue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ivalue=$event.target.value}}},'textarea',_vm.inputAttrs,false),_vm.listeners)),(_vm.min != null || _vm.max != null)?_c('span',{staticClass:"forms-textarea__counter"},[_c('span',{staticClass:"forms-textarea__count"},[_vm._v(_vm._s(_vm.length))]),(_vm.max)?_c('span',{staticClass:"forms-textarea__limit"},[_vm._v("/"+_vm._s(_vm.max))]):_vm._e()]):_vm._e(),(_vm.loading)?_c('div',{staticClass:"forms-textarea__loader"},[_vm._t("loader",[_c('ui-loader',{staticClass:"forms-textarea__loader",attrs:{"size":"s"}})])],2):_vm._e()]),(_vm.iconPost && !_vm.clearable)?_c(_vm.iconPostInteractive ? 'button' : 'div',_vm._g({tag:"component",staticClass:"forms-textarea__post",class:{'-is-interactive': _vm.iconPostInteractive},attrs:{"disabled":_vm.iconPostDisabled}},_vm.iconPostListerners),[_c('ui-icon',{staticClass:"forms-textarea__icon",attrs:{"glyph":_vm.iconPost}})],1):_vm._e(),(_vm.clearable && _vm.value && _vm.value.length > 0)?_c('button',{staticClass:"forms-textarea__post -is-interactive forms-textarea__clear",on:{"click":_vm.onClear}},[_c('ui-icon',{staticClass:"forms-textarea__icon",attrs:{"glyph":"cross"}})],1):_vm._e()],1),(_vm.errors && _vm.errors.length)?_c('div',{staticClass:"forms-textarea__footer"},_vm._l((_vm.errors),function(e){return _c('forms-label',{key:e,staticClass:"forms-textarea__label",attrs:{"rel":_vm.id,"intent":"danger"}},[_vm._v(_vm._s(e))])}),1):_vm._e()])}
var textareavue_type_template_id_648d2ea4_staticRenderFns = []


// CONCATENATED MODULE: ../forms-textarea/src/textarea.vue?vue&type=template&id=648d2ea4&

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../forms-textarea/src/textarea.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var textareavue_type_script_lang_js_ = ({
  name: "FormsTextarea",

  components: {
    FormsLabel: label,
    UiIcon: icon,
    UiLoader: loader
  },

  directives: {
    Autofocus: autofocus
  },

  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    appearance: {
      type: String,
      default: 'default',
      values: [Appearance.DEFAULT],
      validator: (value) => [Appearance.DEFAULT].includes(value)
    },

    autocomplete: {
      type: Boolean,
      default: true
    },

    autofocus: {
      type: Boolean,
      default: false
    },

    clearable: {
      type: Boolean,
      default: false
    },

    errors: {
      type: Array,
      property: String,
      default: () => []
    },

    iconPost: {
      type: String
    },

    iconPostDisabled: {
      type: Boolean,
      default: false
    },

    iconPostInteractive: {
      type: Boolean,
      default: false
    },

    iconPre: {
      type: String
    },

    iconPreDisabled: {
      type: Boolean,
      default: false
    },

    iconPreInteractive: {
      type: Boolean,
      default: false
    },

    id: {
      type: String,
      default: () => 'textarea-' + Math.round( Math.random() * 9999 )
    },

    disabled: {
      type: Boolean,
      default: false
    },

    loading: {
      type: Boolean,
      default: false
    },

    readOnly: {
      type: Boolean,
      default: false
    },

    required: {
      type: Boolean,
      default: false
    },

    max: {
      type: Number
    },

    min: {
      type: Number
    },

    name: {
      type: String,
      default: () => 'textarea-' + Math.round( Math.random() * 9999 )
    },

    placeholder: {
      type: String,
      doc: 'placeholder'
    },

    rows: {
      type: Number,
      default: 6
    },

    size: {
      type: String,
      default: Size.M,
      values: Size.ALL,
      validator: value => Size.ALL.includes(value)
    },

    spellcheck: {
      type: String,
      default: 'default',
      values: [true, 'default', false],
      validator: value => [true, 'default', false].includes(value)
    },

    value: {
      type: String,
    }
  },

  data(){
    return {
      ivalue: null
    }
  },

  computed: {
    classes(){
      return {
        'forms-textarea': true,

        '-view-none': this.appearance === 'none',

        '-icon-post': this.iconPost,
        '-icon-post-disabled': this.iconPostDisabled,
        '-icon-post-interactive': this.iconPostInteractive,
        '-icon-pre': this.iconPre,
        '-icon-pre-disabled': this.iconPreDisabled,
        '-icon-pre-interactive': this.iconPreInteractive,

        '-is-disabled': this.disabled,
        '-is-invalid': this.errors && this.errors.length,
        '-is-loading': this.loading,
        '-is-readonly': this.readOnly,
        '-is-required': this.required,

        '-xs': this.size === Size.XS,
        '-s': this.size === Size.S,
        '-m': this.size === Size.M,
        '-l': this.size === Size.L,

        '-no-label': this.hasLabel
      }
    },

    iconPreListeners(){
      return this.iconPreInteractive ? {'click': (event) => this.onIconClick(event, 'pre') } : {}
    },

    iconPostListerners(){
      return this.iconPostInteractive ? {'click': (event) => this.onIconClick(event, 'post') } : {}
    },

    inputAttrs(){
      let ret = Object.assign({}, this.$attrs);
      ret = Object.assign(ret, {
        autocomplete: this.autocomplete === true ? 'on' : null,
        autofocus: this.autofocus,
        class: "forms-textarea__field",
        id: this.id,
        disabled: this.disabled,
        maxlength: this.max,
        minlength: this.min,
        name: this.name,
        placeholder: this.placeholder,
        readonly: this.readOnly,
        ref: 'field',
        required: this.required,
        rows: this.rows,
        spellcheck: this.spellcheck
      });

      return ret;
    },

    hasAfter(){
      return !!this.hasSlot('after');
    },

    hasBefore(){
      return !!this.hasSlot('before');
    },

    hasLabel(){
      return !!this.hasSlot('default');
    },

    length(){
      return this.value ? this.value.length : 0;
    },

    listeners(){
      let _this = this;
      let ret = Object.assign({}, this.$listeners);
      ret = Object.assign(ret, {
        input(event){ _this.onInput(event) },
        keyup(event){ _this.onKeyUp(event) }
      });
      
      return ret;
    },
  },

  watch: {
    value(val){
      this.ivalue = val;
    }
  },

  methods: {
    focus(){
      this.$refs.field.focus();
    },

    hasSlot(name){
      return !!this.$slots[name];
    },
    
    onClear(event){
      this.ivalue = '';
      this.$refs.field.focus();
      this.$emit('clear', event);
      this.$emit('input', this.ivalue);
    },

    onIconClick(event, position){
      this.$emit('iconClick', event, position);
    },

    onInput(event){
      this.$emit('input', this.ivalue);
    },

    onKeyUp(event){
      this.$emit('keyup', event, event.target.value);
    }
  },

  mounted(){
    this.ivalue = this.value;
  }
});

// CONCATENATED MODULE: ../forms-textarea/src/textarea.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_textareavue_type_script_lang_js_ = (textareavue_type_script_lang_js_); 
// CONCATENATED MODULE: ../forms-textarea/src/textarea.vue





/* normalize component */

var textarea_component = normalizeComponent(
  src_textareavue_type_script_lang_js_,
  textareavue_type_template_id_648d2ea4_render,
  textareavue_type_template_id_648d2ea4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_textarea = (textarea_component.exports);
// EXTERNAL MODULE: ../forms-textarea/package.json
var forms_textarea_package = __webpack_require__("4619");

// CONCATENATED MODULE: ../forms-textarea/src/index.js



src_textarea.meta = forms_textarea_package



// CONCATENATED MODULE: ../pepper-pepper/src/components/forms.js













// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../navigations-tabs/src/tabs.vue?vue&type=template&id=7d6fbe94&
var tabsvue_type_template_id_7d6fbe94_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',_vm._b({},'nav',_vm.attrs,false),[_vm._t("default")],2)}
var tabsvue_type_template_id_7d6fbe94_staticRenderFns = []


// CONCATENATED MODULE: ../navigations-tabs/src/tabs.vue?vue&type=template&id=7d6fbe94&

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../navigations-tabs/src/tabs.vue?vue&type=script&lang=js&
//
//
//
//
//
//



/* harmony default export */ var tabsvue_type_script_lang_js_ = ({
  name: "NavigationsTabs",

  props: {
    appearance: {
      type: String,
      default: 'default',
      values: [Appearance.DEFAULT],
      validator: (value) => [Appearance.DEFAULT].includes(value)
    },
    
    disabled: {
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: Size.M,
      values: [Size.S, Size.M, Size.L],
      validator: value => [Size.S, Size.M, Size.L].includes(value)
    }
  },

  computed: {
    attrs(){
      let ret = {
        class: this.classes,
        disabled: this.disabled
      }

      return ret;
    },

    classes(){
      return {
        'navigations-tabs': true,

        '-is-disabled': this.disabled === true,

        '-s': this.size === Size.S,
        '-m': this.size === Size.M,
        '-l': this.size === Size.L
      }
    }
  }
});

// CONCATENATED MODULE: ../navigations-tabs/src/tabs.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_tabsvue_type_script_lang_js_ = (tabsvue_type_script_lang_js_); 
// CONCATENATED MODULE: ../navigations-tabs/src/tabs.vue





/* normalize component */

var tabs_component = normalizeComponent(
  src_tabsvue_type_script_lang_js_,
  tabsvue_type_template_id_7d6fbe94_render,
  tabsvue_type_template_id_7d6fbe94_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var tabs = (tabs_component.exports);
// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../navigations-tabs/src/item.vue?vue&type=template&id=3cb32480&
var itemvue_type_template_id_3cb32480_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('component',_vm._g(_vm._b({},'component',_vm.attrs,false),_vm.listeners),[_vm._t("default")],2)}
var itemvue_type_template_id_3cb32480_staticRenderFns = []


// CONCATENATED MODULE: ../navigations-tabs/src/item.vue?vue&type=template&id=3cb32480&

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../navigations-tabs/src/item.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//

/* harmony default export */ var itemvue_type_script_lang_js_ = ({
    name: 'NavigationsTabsItem',

    props: {
        disabled: {
            type: Boolean,
            default: false
        },

        errored: {
            type: Boolean,
            default: false
        },

        href: {},

        selected: {
            type: Boolean,
            default: false
        },

        target: {
            type: String,
            default: '_blank',
            values: ['_blank', '_self', '_parent', '_top'],
            validator: value => ['_blank', '_self', '_parent', '_top'].includes(value)
        }
    },

    computed: {
        attrs(){
            let ret = {
                class: this.classes,
                disabled: this.disabled,
                is: this.is
            }

            if (this.is === 'router-link'){
                ret.to = this.href;
            }

            if (this.is === 'a'){
                ret.href = this.href;
                ret.target = this.target;
            }

            if (this.target === '_blank'){
                ret.rel = 'noopener noreferrer';
            }

            return ret;
        },

        classes(){
            return {
                'navigations-tabs-item': true,

                '-is-active': this.selected === true,
                '-is-disabled': this.disabled === true,
                '-is-errored': this.errored === true,

                '-is-router': this.is === 'router-link',
                '-is-link': this.is === 'a'
            }
        },

        is(){
            let ret = 'button';

            if (this.href){
                // Object => router-link
                if(typeof this.href === 'object'){
                    ret = 'router-link'
                }

                // String => a
                if (typeof this.href === 'string'){
                    let protocol = ['http://', 'https://', 'mailto://', 'tel://'].filter(protocol => this.href.indexOf(protocol) != -1);
                    if (protocol.length > 0){
                        ret = 'a'
                    }
                }
            }

            return ret;
        },

        listeners(){
            return this.$listeners
        }
    }
});

// CONCATENATED MODULE: ../navigations-tabs/src/item.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_itemvue_type_script_lang_js_ = (itemvue_type_script_lang_js_); 
// CONCATENATED MODULE: ../navigations-tabs/src/item.vue





/* normalize component */

var item_component = normalizeComponent(
  src_itemvue_type_script_lang_js_,
  itemvue_type_template_id_3cb32480_render,
  itemvue_type_template_id_3cb32480_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var item = (item_component.exports);
// EXTERNAL MODULE: ../navigations-tabs/package.json
var navigations_tabs_package = __webpack_require__("30dc");

// CONCATENATED MODULE: ../navigations-tabs/src/index.js




tabs.meta = navigations_tabs_package;



// CONCATENATED MODULE: ../pepper-pepper/src/components/navigations.js


// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../popins-blanket/src/blanket.vue?vue&type=template&id=17daa381&
var blanketvue_type_template_id_17daa381_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popins-popin',{attrs:{"direction":"none","position":"top-left","target":_vm.target,"visible":_vm.visible}},[_c('div',_vm._g(_vm._b({},'div',_vm.attrs,false),_vm.listeners))])}
var blanketvue_type_template_id_17daa381_staticRenderFns = []


// CONCATENATED MODULE: ../popins-blanket/src/blanket.vue?vue&type=template&id=17daa381&

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../popins-blanket/src/blanket.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var blanketvue_type_script_lang_js_ = ({
  name: "PopinsBlanket",

  components: {
    PopinsPopin: popin
  },

  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    target: {
      default: () => document.body
    },

    visible:{
      type: Boolean,
      default: true
    }
  },

  computed: {
    attrs(){
      return {
        class: this.classes,
        disabled: this.disabled
      }
    },

    classes(){
      return {
        'popins-blanket': true,
        '-is-disabled': this.disabled
      }
    },

    listeners(){
      return this.disabled ? {} : this.$listeners;
    }
  },
});

// CONCATENATED MODULE: ../popins-blanket/src/blanket.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_blanketvue_type_script_lang_js_ = (blanketvue_type_script_lang_js_); 
// CONCATENATED MODULE: ../popins-blanket/src/blanket.vue





/* normalize component */

var blanket_component = normalizeComponent(
  src_blanketvue_type_script_lang_js_,
  blanketvue_type_template_id_17daa381_render,
  blanketvue_type_template_id_17daa381_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var blanket = (blanket_component.exports);
// EXTERNAL MODULE: ../popins-blanket/package.json
var popins_blanket_package = __webpack_require__("0993");

// CONCATENATED MODULE: ../popins-blanket/src/index.js



blanket.meta = popins_blanket_package



// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../popins-modal/src/modal.vue?vue&type=template&id=6b5290bb&
var modalvue_type_template_id_6b5290bb_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popins-modal -init"},[(_vm.blanket)?_c('popins-blanket',{attrs:{"transition":"none","visible":_vm.visible,"disabled":_vm.blanketDisabled},on:{"click":_vm.close}}):_vm._e(),_c('popins-popin',_vm._b({},'popins-popin',_vm.attrs,false),[_c('div',{class:_vm.classes},[(_vm.closable)?_c('actions-button',{staticClass:"popins-modal__close",attrs:{"icon-pre":"cross"},on:{"click":_vm.close}}):_vm._e(),_c('div',{staticClass:"popins-modal__inner"},[(_vm.hasSlot('header'))?_c('header',{staticClass:"popins-modal__header"},[_vm._t("header")],2):_vm._e(),(_vm.hasSlot('default'))?_c('section',{staticClass:"popins-modal__body"},[_vm._t("default")],2):_vm._e(),(_vm.hasSlot('footer'))?_c('footer',{staticClass:"popins-modal__footer"},[_vm._t("footer")],2):_vm._e()])],1)])],1)}
var modalvue_type_template_id_6b5290bb_staticRenderFns = []


// CONCATENATED MODULE: ../popins-modal/src/modal.vue?vue&type=template&id=6b5290bb&

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../popins-modal/src/modal.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var modalvue_type_script_lang_js_ = ({
  name: "PopinsModal",

  components: {
    ActionsButton: src_button,
    PopinsBlanket: blanket,
    PopinsPopin: popin
  },

  props: {
    appearance: {
      type: String,
      default: Appearance.DEFAULT,
      values: [Appearance.DEFAULT]
    },

    blanket: {
      type: Boolean,
      default: true
    },

    blanketDisabled: {
      type: Boolean,
      default: false
    },

    closable: {
      type: Boolean,
      default: true
    },
    
    scrollLocked: {
      type: Boolean,
      default: true
    },

    position: {
      type: String,
      default: Position.TOP_CENTER,
      values: Position.ALL,
      validator: (value) => Position.ALL.includes(value),
    },

    size: {
      type: String,
      default: Size.M,
      values: Size.ALL.concat([Size.FULLSCREEN]),
      validator: (value) => Size.ALL.concat([Size.FULLSCREEN]).includes(value),
    },

    visible: {
      type: Boolean,
      default: false
    },

    width: {
      type: String
    }
  },

  computed: {
    attrs(){
      return {
        class: this.classes,
        position: this.position,
        transition: Direction.UP,
        visible: this.visible,
        overflow: "visible",
        width: this.size === Size.FULLSCREEN ? '100vw' : this.width
      }
    },

    classes(){
      let klass = this.$attrs.klass || {};
      let ret = Object.assign(klass, {
        'popins-modal': true,

        '-top-left': this.position === Position.TOP_LEFT, 
        '-top-center': this.position === Position.TOP_CENTER, 
        '-top-right': this.position === Position.TOP_RIGHT, 
        '-middle-left': this.position === Position.MIDDLE_LEFT, 
        '-middle-center': this.position === Position.MIDDLE_CENTER, 
        '-middle-right': this.position === Position.MIDDLR_RIGHT, 
        '-bottom-left': this.position === Position.BOTTOM_LEFT, 
        '-bottom-center': this.position === Position.BOTTOM_CENTER, 
        '-bottom-right': this.position === Position.BOTTOM_RIGHT,

        '-xs': this.size === Size.XS,
        '-s': this.size === Size.S,
        '-l': this.size === Size.L,
        '-fullscreen': this.size === Size.FULLSCREEN,
      })

      return ret
    },

    listeners(){
      return this.$listeners
    }
  },

  watch: {
    visible(value){
      if (value){
        if (this.scrollLocked){
          document.body.classList.add('-no-scroll');
        }
        document.addEventListener('keydown', this.onKeyDown);
      }
      else{
        if (this.scrollLocked){
          document.body.classList.remove('-no-scroll');
        }
        document.removeEventListener('keydown', this.onKeyDown);
      }
    }
  },

  methods: {
    close(){
      this.$emit('close');
    },

    hasSlot(name){
      return this.$slots[name] !== undefined;
    },

    onKeyDown(event) {
      if (event.keyCode === KeyCode.ESCAPE) {
        this.close();
      }
    },
  },

  destroyed(){
    document.removeEventListener('keydown', this.onKeyDown);
  }
});

// CONCATENATED MODULE: ../popins-modal/src/modal.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_modalvue_type_script_lang_js_ = (modalvue_type_script_lang_js_); 
// CONCATENATED MODULE: ../popins-modal/src/modal.vue





/* normalize component */

var modal_component = normalizeComponent(
  src_modalvue_type_script_lang_js_,
  modalvue_type_template_id_6b5290bb_render,
  modalvue_type_template_id_6b5290bb_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var modal = (modal_component.exports);
// EXTERNAL MODULE: ../popins-modal/package.json
var popins_modal_package = __webpack_require__("124c");

// CONCATENATED MODULE: ../popins-modal/src/index.js



modal.meta = popins_modal_package



// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../popins-notification/src/template.vue?vue&type=template&id=42562265&
var templatevue_type_template_id_42562265_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"notification-wrapper"},[_c('notification',{class:[_vm.type && '-is-' + _vm.type],attrs:{"icon":_vm.icon,"title":_vm.title,"message":_vm.message,"content":_vm.content,"is-collapsed":_vm.isCollapsed,"is-closable":_vm.isClosable,"close-handler":_vm.close},nativeOn:{"mouseenter":function($event){return _vm.clearTimer($event)},"mouseleave":function($event){return _vm.startTimer($event)}}})],1)}
var templatevue_type_template_id_42562265_staticRenderFns = []


// CONCATENATED MODULE: ../popins-notification/src/template.vue?vue&type=template&id=42562265&

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../popins-notification/src/notification.vue?vue&type=template&id=531fdec9&
var notificationvue_type_template_id_531fdec9_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"notification-item"},[_c('header',{staticClass:"notification-item__header",on:{"click":_vm.triggerCollapse}},[(_vm.isCollapsed)?_c('div',{staticClass:"notification-item__collapse"}):_vm._e(),_c('div',{staticClass:"notification-item__headercontent"},[_c('div',{staticClass:"notification-item__group"},[(_vm.icon)?_c('div',{staticClass:"notification-item__icon",class:_vm.icon}):_vm._e(),(_vm.title)?_c('div',{staticClass:"notification-item__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e()]),_c('div',{staticClass:"notification-item__message"},[_vm._v(_vm._s(_vm.message))])]),(_vm.isClosable)?_c('div',{staticClass:"notification-item__close",attrs:{"aria-label":"Close","data-tooltip-pos":"up"},on:{"click":_vm.handleClose}},[_c('div',{staticClass:"notification-item__closeicon"})]):_vm._e()]),(_vm.$slots.default)?_c('div',{staticClass:"notification-item__body"},[_vm._t("default",[_vm._v(_vm._s(_vm.content))])],2):_vm._e()])}
var notificationvue_type_template_id_531fdec9_staticRenderFns = []


// CONCATENATED MODULE: ../popins-notification/src/notification.vue?vue&type=template&id=531fdec9&

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../popins-notification/src/notification.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var notificationvue_type_script_lang_js_ = ({
  name: 'notification',
  props: {
    icon: {
      type: String
    },

    title: {
      type: String
    },

    message: {
      type: String
    },

    content: {
      type: String
    },

    isCollapsed: {
      type: Boolean,
      default: true
    },

    isClosable: {
      type: Boolean,
      default: false
    },

    closeHandler: Function,
  },
  data () {
    return {
      visible: true,
      collapsed: this.isCollapsed
    }
  },
  methods: {
    triggerCollapse () {
      this.collapsed = !this.collapsed
    },
    close () {
      this.visible = false
    },
    handleClose () {
      if (typeof this.closeHandler === 'function') {
        this.closeHandler(this.close);
      }
      else {
        this.close();
      }
    }
  }
});

// CONCATENATED MODULE: ../popins-notification/src/notification.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_notificationvue_type_script_lang_js_ = (notificationvue_type_script_lang_js_); 
// CONCATENATED MODULE: ../popins-notification/src/notification.vue





/* normalize component */

var notification_component = normalizeComponent(
  src_notificationvue_type_script_lang_js_,
  notificationvue_type_template_id_531fdec9_render,
  notificationvue_type_template_id_531fdec9_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var notification = (notification_component.exports);
// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../popins-notification/src/template.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var templatevue_type_script_lang_js_ = ({
  name: 'PopinsNotification',
  components: {
    Notification: notification,
  },

  data () {
    return {
      show: false,
      type: 'info',
      icon: '',
      title: '',
      message: '',
      content: '',
      duration: 3000,
      isClosable: false,
      isCollapsed: false,
      onClose: null,
      timer: null,
      closed: false
    }
  },
  watch: {
    closed (val) {
      if (val) {
        this.show = false
        this.$el.addEventListener('animationend', this.destroyElement);
      }
    }
  },
  methods: {
    close () {
      this.closed = true;
      if (typeof this.onClose === 'function') {
        this.onClose(this);
      }
    },
    clearTimer () {
      clearTimeout(this.timer);
    },
    startTimer () {
      if (this.duration > 0 && this.type !== 'loading') {
        this.timer = setTimeout(() => {
          if (!this.closed) {
            this.close();
          }
        }, this.duration)
      }
    },
    destroyElement () {
      this.$el.removeEventListener('animationend', this.destroyElement);
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  mounted () {
    if (this.type !== 'loading') {
      this.startTimer()
      if (this.duration <= 0) {
        this.showClose = true
      }
    }
  },
  
});

// CONCATENATED MODULE: ../popins-notification/src/template.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_templatevue_type_script_lang_js_ = (templatevue_type_script_lang_js_); 
// CONCATENATED MODULE: ../popins-notification/src/template.vue





/* normalize component */

var template_component = normalizeComponent(
  src_templatevue_type_script_lang_js_,
  templatevue_type_template_id_42562265_render,
  templatevue_type_template_id_42562265_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var template = (template_component.exports);
// CONCATENATED MODULE: ../popins-notification/src/bus.js




const NotificationConstructor = external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend(template);

const instances = [];
let count = 1;
const containers = {};
const containerDom = document.body;
const containerClassName = 'notification-bus';

const Notification = (options) => {
  let onClose = options.onClose;
  const position = options.position || Position.BOTTOM_CENTER;
  const hasMask = options.hasMask || false;
  const key = position + (hasMask ? '-mask' : '')
  let containerEl = containers[key];

  if (!containerEl) {
    containerEl = containers[key] = document.createElement('div')
    containerEl.className = [
      containerClassName,
      '-is-' + position,
      hasMask ? '-has-mask' : ''
    ].filter(e => !!e).join(' ');
    containerDom.appendChild(containerEl);
  }

  const id = count++;
  options.onClose = function () {
    Notification.close(id, onClose);
  }

  const instance = new NotificationConstructor({
    el: document.createElement('div'),
    data: options
  });

  instance.id = id;
  instance.containerKey = key;

  // for position of bottom-*
  if (position.indexOf('bottom') === 0 && containerEl.firstChild) {
    containerEl.insertBefore(instance.$el, containerEl.firstChild);
  } else {
    containerEl.appendChild(instance.$el);
  }
  instance.show = true;
  instances.push(instance);

  return instance;
}

Notification.close = (id, onClose) => {
  for (let i = 0, len = instances.length; i < len; i++) {
    if (id === instances[i].id) {
      const { containerKey, hasMask } = instances[i];
      if (typeof onClose === 'function') {
        onClose(instances[i]);
      }
      instances[i] = null;
      instances.splice(i, 1);

      const index = instances.findIndex(e => e.containerKey === containerKey);

      // If the mask is turned on, remove the container after 300ms (do not remove the white screen for too long)
      if (hasMask && index === -1) {
        setTimeout(function () {
          containers[containerKey].remove();
          containers[containerKey] = null;
        }, 300);
      }
      break;
    }
  }

  setTimeout(function (){
    // Remove container after there is no message currently
    if (instances.length === 0) {
      for (let type in containers) {
        if (containers[type]) {
          containers[type].remove()
          containers[type] = null
        }
      }
    }
  }, 3000);
}

Notification.closeAll = () => {
  for (let i = instances.length - 1; i >= 0; i--) {
    instances[i].close();
  }
}

const types = Intent.ALL;

types.forEach(type => {
  Notification[type] = function (options) {
    options = typeof options === 'string' ? { message: options } : options
    return Notification({ options, type })
  }
})

/* harmony default export */ var src_bus = (Notification);

// CONCATENATED MODULE: ../popins-notification/src/index.js


src_bus.install = function(Vue, options){
  Vue.prototype.$notification = src_bus;
}



// CONCATENATED MODULE: ../pepper-pepper/src/components/popins.js






// CONCATENATED MODULE: ../pepper-pepper/src/components/transitions.js


// CONCATENATED MODULE: ../pepper-pepper/src/components/ui.js



// CONCATENATED MODULE: ../pepper-pepper/src/components/index.js








// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"421849a9-vue-loader-template"}!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../popins-confirm/src/confirm.vue?vue&type=template&id=45e649c6&
var confirmvue_type_template_id_45e649c6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popins-confirm -init"},[(_vm.blanket)?_c('popins-blanket',{attrs:{"transition":"none","visible":_vm.visible,"disabled":_vm.blanketDisabled},on:{"click":_vm.close}}):_vm._e(),_c('popins-popin',_vm._b({},'popins-popin',_vm.attrs,false),[_c('div',{staticClass:"popins-confirm__body"},[_vm._t("default",[(_vm.illustration)?_c('div',{staticClass:"popins-confirm__illustration",style:('background-image:url('+ _vm.illustration + ')')}):_vm._e(),(_vm.title)?_c('h2',{staticClass:"popins-confirm__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.description)?_c('div',{staticClass:"popins-confirm__description"},[_vm._v(_vm._s(_vm.description))]):_vm._e()],{"description":_vm.description,"illustraton":_vm.illustration,"title":_vm.title}),(_vm.primaryAction || _vm.secondaryAction || _vm.tertiaryAction)?_c('div',{staticClass:"popins-confirm__actions"},[(_vm.primaryAction || _vm.secondaryAction)?_c('div',{staticClass:"popins-confirm__action"},[(_vm.secondaryAction)?_c('actions-button',_vm._g({ref:"secondary"},_vm.listeners),[_vm._v(_vm._s(_vm.secondaryAction))]):_vm._e(),(_vm.primaryAction)?_c('actions-button',_vm._g({ref:"primary",attrs:{"appearance":"primary"}},_vm.listeners),[_vm._v(_vm._s(_vm.primaryAction))]):_vm._e()],1):_vm._e(),(_vm.tertiaryAction)?_c('div',{staticClass:"popins-confirm__action"},[_c('actions-button',_vm._g({ref:"tertiary",attrs:{"appearance":"link"}},_vm.listeners),[_vm._v(_vm._s(_vm.tertiaryAction))])],1):_vm._e()]):_vm._e()],2)])],1)}
var confirmvue_type_template_id_45e649c6_staticRenderFns = []


// CONCATENATED MODULE: ../popins-confirm/src/confirm.vue?vue&type=template&id=45e649c6&

// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/cache-loader/dist/cjs.js??ref--0-0!/mnt/d/projects/spices/pepper/node_modules/vue-loader/lib??vue-loader-options!../popins-confirm/src/confirm.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var confirmvue_type_script_lang_js_ = ({
  name: "PopinsConfirm",

  components: {
    ActionsButton: src_button,
    PopinsBlanket: blanket,
    PopinsPopin: popin
  },

  props: {
    blanket: {
      type: Boolean,
      default: true
    },

    blanketDisabled: {
      type: Boolean,
      default: true
    },

    closed: {
      type: Function
    },

    description: {
      type: String
    },

    id: {
      type: Number,
      default: 0
    },

    illustration: {
      type: String
    },

    onPrimary: {
      type: Function,
      default: null
    },

    onSecondary: {
      type: Function,
      default: null
    },

    onTertiary: {
      type: Function,
      default: null
    },

    primaryAction: {
      type: String
    },

    secondaryAction: {
      type: String
    },

    tertiaryAction: {
      type: String
    },

    title: {
      type: String
    },

    visible: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    attrs() {
      let ret = {
        class: this.classes,
        position: 'middle-center',
        target: document.body,
        direction: 'up',
        visible: this.visible
      };

      return ret;
    },

    classes() {
      return {
        "popins-confirm": true
      };
    },

    listeners(){
      let _this = this;
      let ret = Object.assign({}, this.$listeners);
      ret = Object.assign(ret, {
        click(event){ _this.onClick(event) }
      });
      
      return ret;
    }
  },

  methods: {
    close(){
      this.visible = false;
      this.closed && this.closed( this.id );
    },

    onClick(event) {
      event.preventDefault();

      let target = event.currentTarget;
      let action = [ this.$refs.primary, this.$refs.secondary, this.$refs.tertiary ].find((e) => e && e.$el == target);
      
      if (action){
        let type = action.$vnode.data.ref;
        let handler = `on${type.charAt(0).toUpperCase() + type.slice(1)}`;
        this[handler] != null && this[handler]()
      }

      this.close();
    }
  }
});

// CONCATENATED MODULE: ../popins-confirm/src/confirm.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_confirmvue_type_script_lang_js_ = (confirmvue_type_script_lang_js_); 
// CONCATENATED MODULE: ../popins-confirm/src/confirm.vue





/* normalize component */

var confirm_component = normalizeComponent(
  src_confirmvue_type_script_lang_js_,
  confirmvue_type_template_id_45e649c6_render,
  confirmvue_type_template_id_45e649c6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_confirm = (confirm_component.exports);
// CONCATENATED MODULE: ../popins-confirm/src/bus.js



const PopinsConfirmClass = external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend(src_confirm);
const bus_instances = [];
let bus_count = 0;

const Confirm = (options) => {
  let o = {
    closed: (id) => { Confirm.close(id) },
    primaryAction: 'Confirm',
    secondaryAction: 'Discard',
    title: 'Are you sure?',
    visible: true
  };
  options = Object.assign(o, options);

  const id = bus_count++;
  const instance = new PopinsConfirmClass({
    propsData: options
  });
  instance.id = id;
  bus_instances.push(instance);

  instance.$mount();
}

Confirm.close = (id) => {
  let n = bus_instances.length;
  for (let i = 0; i < n ; i++ ){
    let el = bus_instances[i];
    if (el.id === id){
      bus_instances.splice(i, 1);
      el.$destroy();
    }
  }
}

/* harmony default export */ var popins_confirm_src_bus = (Confirm);

// CONCATENATED MODULE: ../popins-confirm/src/index.js


popins_confirm_src_bus.install = (Vue, opts) => {
  Vue.prototype.$confirm = popins_confirm_src_bus
}


// CONCATENATED MODULE: ../pepper-pepper/src/index.js


////////////////////////////////////////////////////////////////////////////
//  Version
////////////////////////////////////////////////////////////////////////////


////////////////////////////////////////////////////////////////////////////
//  Constants
////////////////////////////////////////////////////////////////////////////




////////////////////////////////////////////////////////////////////////////
//  Directives
////////////////////////////////////////////////////////////////////////////


////////////////////////////////////////////////////////////////////////////
//  Components
////////////////////////////////////////////////////////////////////////////




let components = [];
Object.keys(components_namespaceObject).forEach(name => { components.push(components_namespaceObject[name]); });


////////////////////////////////////////////////////////////////////////////
//  Auto Install
////////////////////////////////////////////////////////////////////////////
const install = function (Vue, opts = {}) {

    // Components
    components.forEach(component => {
        if (component.name) {
            Vue.component(component.name, component);
        }
    });

    // PopinsConfirm
    popins_confirm_src_bus.install(Vue, opts);

    // Constants
    if (!Vue.prototype.$spices) {
        Vue.prototype.$spices = {}
    }

    Vue.prototype.$spices.pepper = src_namespaceObject;
}

/* harmony default export */ var pepper_pepper_src = (install);

// CONCATENATED MODULE: ./src/index.js


/* harmony default export */ var src_0 = (pepper_pepper_src);
// CONCATENATED MODULE: /mnt/d/projects/spices/pepper/node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (src_0);



/***/ }),

/***/ "2046":
/***/ (function(module) {

module.exports = JSON.parse("{\"author\":\"Alexandre <alexandre@infinity-mobile.io>\",\"browserslist\":[\"> 1%\",\"last 2 versions\",\"not dead\"],\"category\":\"Popins\",\"description\":\"This two parts component is the base layer for all related popins components. The first creates a bus to receive and display the popins. The second acts as a helper in order to display or hide the actual popin.\",\"devDependencies\":{\"@vue/cli-service\":\"^4.1.1\",\"vue\":\"^2.6.10\"},\"directories\":{\"src\":\"src\"},\"displayName\":\"Popin\",\"events\":{},\"files\":[\"src\"],\"homepage\":\"http://pepper.infinity-commerce.io/components/popins/popin\",\"license\":\"UNLICENSED\",\"main\":\"src/index.js\",\"name\":\"@pepper/popins-popin\",\"publishConfig\":{\"access\":\"public\",\"registry\":\"https://npm.infinity-commerce.io/\"},\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@bitbucket.org:infinity-mobile/pepper.git\"},\"samples\":{\"default\":{\"key\":\"default\",\"name\":\"Default\",\"slots\":{\"default\":\"Label\"}}},\"scripts\":{\"bundle\":\"\",\"bundle:wc\":\"vue-cli-service build --target wc --name popins-popin ./src/popin.vue\",\"bundle:lib\":\"vue-cli-service build --target lib --name pepper-popins-popin ./src/index.js\"},\"slots\":{},\"status\":\"draft\",\"version\":\"1.3.2\",\"gitHead\":\"14531a2a18d9b6dc6dc42232a03f11c3f7d5e9d2\",\"dependencies\":{\"@pepper/utils\":\"^1.1.2\"}}");

/***/ }),

/***/ "30dc":
/***/ (function(module) {

module.exports = JSON.parse("{\"author\":\"Alexandre <alexandre@infinity-mobile.io>\",\"browserslist\":[\"> 1%\",\"last 2 versions\",\"not dead\"],\"category\":\"Tabs\",\"dependencies\":{\"@pepper/utils\":\"^1.1.2\"},\"description\":\"Use tabs to display multiple panels within a single window.\",\"directories\":{\"src\":\"src\"},\"displayName\":\"Tabs\",\"files\":[\"src\"],\"homepage\":\"http://pepper.infinity-commerce.io/components/navigations/tabs\",\"license\":\"UNLICENSED\",\"main\":\"src/index.js\",\"name\":\"@pepper/navigations-tabs\",\"publishConfig\":{\"access\":\"public\",\"registry\":\"https://npm.infinity-commerce.io/\"},\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@bitbucket.org:infinity-mobile/pepper.git\"},\"samples\":{\"default\":{\"name\":\"Default\",\"props\":{},\"slots\":{\"default\":\"Label\"}}},\"scripts\":{\"bundle\":\"\",\"bundle:wc\":\"vue-cli-service build --target wc --name navigations-tabs ./src/tabs.vue\",\"bundle:lib\":\"vue-cli-service build --target lib --name pepper-navigations-tabs ./src/index.js\"},\"slots\":{\"default\":{}},\"version\":\"1.2.3\"}");

/***/ }),

/***/ "32bb":
/***/ (function(module) {

module.exports = JSON.parse("{\"author\":\"Alexandre <alexandre@infinity-mobile.io>\",\"browserslist\":[\"> 1%\",\"last 2 versions\",\"not dead\"],\"category\":\"Forms\",\"description\":\"Represents a caption for an item in a user interface.\",\"directories\":{\"src\":\"src\"},\"displayName\":\"Label\",\"files\":[\"src\"],\"homepage\":\"http://pepper.infinity-commerce.io/components/forms/label\",\"license\":\"UNLICENSED\",\"main\":\"src/index.js\",\"name\":\"@pepper/forms-label\",\"publishConfig\":{\"access\":\"public\",\"registry\":\"https://npm.infinity-commerce.io/\"},\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@bitbucket.org:infinity-mobile/pepper.git\"},\"samples\":{\"default\":{\"name\":\"Default\",\"slots\":{\"default\":\"Label\"}}},\"scripts\":{\"bundle\":\"\",\"bundle:wc\":\"vue-cli-service build --target wc --name forms-label ./src/label.vue\",\"bundle:lib\":\"vue-cli-service build --target lib --name pepper-forms-label ./src/index.js\"},\"slots\":{\"after\":{},\"before\":{},\"default\":{}},\"status\":\"draft\",\"version\":\"1.3.3\",\"gitHead\":\"14531a2a18d9b6dc6dc42232a03f11c3f7d5e9d2\",\"dependencies\":{\"@pepper/utils\":\"^1.1.2\"}}");

/***/ }),

/***/ "37ac":
/***/ (function(module) {

module.exports = JSON.parse("{\"author\":\"Alexandre <alexandre@infinity-mobile.io>\",\"browserslist\":[\"> 1%\",\"last 2 versions\",\"not dead\"],\"category\":\"Forms\",\"dependencies\":{\"@pepper/directives-autofocus\":\"^1.1.2\",\"@pepper/forms-input\":\"^1.7.7\"},\"description\":\"It allows the user to upload one or more file(s).\",\"directories\":{\"src\":\"src\"},\"displayName\":\"File\",\"events\":{\"input\":{\"type\":\"input\"}},\"files\":[\"src\"],\"homepage\":\"http://pepper.infinity-commerce.io/components/forms/file\",\"license\":\"UNLICENSED\",\"main\":\"src/index.js\",\"name\":\"@pepper/forms-file\",\"publishConfig\":{\"access\":\"public\",\"registry\":\"https://npm.infinity-commerce.io/\"},\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@bitbucket.org:infinity-mobile/pepper.git\"},\"samples\":{\"default\":{\"name\":\"Default\",\"slots\":{\"default\":\"Label\"}}},\"scripts\":{\"bundle\":\"\",\"bundle:wc\":\"vue-cli-service build --target wc --name forms-file ./src/file.vue\",\"bundle:lib\":\"vue-cli-service build --target lib --name pepper-forms-file ./src/index.js\"},\"slots\":{\"after\":{},\"before\":{},\"default\":{}},\"version\":\"0.2.8\"}");

/***/ }),

/***/ "3b6d":
/***/ (function(module) {

module.exports = JSON.parse("{\"author\":\"Alexandre <alexandre@infinity-mobile.io>\",\"browserslist\":[\"> 1%\",\"last 2 versions\",\"not dead\"],\"category\":\"Transitions\",\"description\":\"Transition an element with a fade animation\",\"directories\":{\"src\":\"src\"},\"displayName\":\"Fade\",\"events\":{\"afterEnter\":{\"type\":\"afterEnter\"},\"afterLeave\":{\"type\":\"afterLeave\"},\"beforeEnter\":{\"type\":\"beforeEnter\"},\"beforeLeave\":{\"type\":\"beforeLeave\"},\"enter\":{\"type\":\"enter\"},\"enterCancelled\":{\"type\":\"enterCancelled\"},\"leave\":{\"type\":\"leave\"},\"leaveCancelled\":{\"type\":\"leaveCancelled\"}},\"files\":[\"src\"],\"homepage\":\"http://pepper.infinity-commerce.io/components/transitions/fade\",\"license\":\"UNLICENSED\",\"main\":\"src/index.js\",\"name\":\"@pepper/transitions-fade\",\"publishConfig\":{\"access\":\"public\",\"registry\":\"https://npm.infinity-commerce.io/\"},\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@bitbucket.org:infinity-mobile/pepper.git\"},\"samples\":{\"default\":{\"name\":\"Default\",\"slots\":{\"default\":\"Label\"}}},\"scripts\":{\"bundle\":\"\",\"bundle:wc\":\"vue-cli-service build --target wc --name transitions-fade ./src/fade.vue\",\"bundle:lib\":\"vue-cli-service build --target lib --name pepper-transitions-fade ./src/index.js\"},\"slots\":{\"default\":{\"name\":\"default\"}},\"version\":\"1.2.3\",\"gitHead\":\"14531a2a18d9b6dc6dc42232a03f11c3f7d5e9d2\",\"dependencies\":{\"@pepper/utils\":\"^1.1.2\"}}");

/***/ }),

/***/ "405b":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    if (document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "41f3":
/***/ (function(module) {

module.exports = JSON.parse("{\"author\":\"Alexandre <alexandre@infinity-mobile.io>\",\"browserslist\":[\"> 1%\",\"last 2 versions\",\"not dead\"],\"category\":\"Forms\",\"dependencies\":{\"@pepper/directives-clickoutside\":\"^1.1.6\",\"@pepper/forms-control\":\"^1.1.4\",\"@pepper/popins-popin\":\"^1.3.2\",\"@pepper/utils\":\"^1.1.2\"},\"description\":\"Provide recommendations based on the current input. All the attributes and slots inherited from the input are available to use.\",\"directories\":{\"src\":\"src\"},\"displayName\":\"AutoComplete\",\"events\":{\"cancel\":{\"type\":\"cancel\"},\"clear\":{\"type\":\"clear\"},\"input\":{\"type\":\"input\"},\"selected\":{\"type\":\"selected\"}},\"files\":[\"src\"],\"homepage\":\"http://pepper.infinity-commerce.io/components/forms/autocomplete\",\"license\":\"UNPUBLISHED\",\"main\":\"src/index.js\",\"name\":\"@pepper/forms-autocomplete\",\"publishConfig\":{\"access\":\"public\",\"registry\":\"https://npm.infinity-commerce.io/\"},\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@bitbucket.org:infinity-mobile/pepper.git\"},\"samples\":{\"array\":{\"name\":\"Array\",\"props\":{\"options\":[{\"first\":\"Briana\",\"last\":\"Morin\"},{\"first\":\"Everett\",\"last\":\"Short\"},{\"first\":\"Hardy\",\"last\":\"Hobbs\"},{\"first\":\"Julia\",\"last\":\"Cooke\"},{\"first\":\"Maryanne\",\"last\":\"Puckett\"},{\"first\":\"Norton\",\"last\":\"Gross\"},{\"first\":\"Warren\",\"last\":\"Guerrero\"}],\"property\":\"first\"},\"slots\":{\"default\":\"Data feeded from an array\"}}},\"scripts\":{\"bundle\":\"\",\"bundle:wc\":\"vue-cli-service build --target wc --name forms-autocomplete ./src/autocomplete.vue\",\"bundle:lib\":\"vue-cli-service build --target lib --name pepper-forms-autocomplete ./src/index.js\"},\"slots\":{\"after\":{},\"before\":{},\"default\":{},\"no-results\":{},\"result\":{},\"results\":{}},\"version\":\"1.7.11\",\"gitHead\":\"837ba81c27d2379bdf07d4ba95dcf0dd35db1333\"}");

/***/ }),

/***/ "42ac":
/***/ (function(module) {

module.exports = JSON.parse("{\"author\":\"Alexandre <alexandre@infinity-mobile.io>\",\"browserslist\":[\"> 1%\",\"last 2 versions\",\"not dead\"],\"category\":\"Ui\",\"description\":\"Display an icon.\",\"devDependencies\":{\"@vue/cli-service\":\"^4.1.1\",\"vue\":\"^2.6.10\"},\"directories\":{\"src\":\"src\"},\"displayName\":\"Icon\",\"events\":{},\"files\":[\"src\"],\"homepage\":\"http://pepper.infinity-commerce.io/components/ui/icon\",\"license\":\"UNLICENSED\",\"main\":\"src/index.js\",\"name\":\"@pepper/ui-icon\",\"publishConfig\":{\"access\":\"public\",\"registry\":\"https://npm.infinity-commerce.io/\"},\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@bitbucket.org:infinity-mobile/pepper.git\"},\"samples\":{\"default\":{\"name\":\"Default\",\"props\":{},\"slots\":{}}},\"scripts\":{\"bundle\":\"\",\"bundle:wc\":\"vue-cli-service build --target wc --name ui-icon ./src/icon.vue\",\"bundle:lib\":\"vue-cli-service build --target lib --name pepper-ui-icon ./src/index.js\"},\"slots\":{},\"status\":\"draft\",\"version\":\"1.0.9\",\"gitHead\":\"14531a2a18d9b6dc6dc42232a03f11c3f7d5e9d2\"}");

/***/ }),

/***/ "4619":
/***/ (function(module) {

module.exports = JSON.parse("{\"author\":\"Alexandre <alexandre@infinity-mobile.io>\",\"browserslist\":[\"> 1%\",\"last 2 versions\",\"not dead\"],\"category\":\"Forms\",\"dependencies\":{\"@pepper/directives-autofocus\":\"^1.1.2\",\"@pepper/forms-label\":\"^1.3.3\",\"@pepper/ui-icon\":\"^1.0.9\",\"@pepper/ui-loader\":\"^1.0.9\",\"@pepper/utils\":\"^1.1.2\"},\"description\":\"It provides a standard way to create a text-based form input.\",\"directories\":{\"src\":\"src\"},\"displayName\":\"Textarea\",\"events\":{\"blur\":{\"type\":\"blur\"},\"clear\":{\"type\":\"clear\"},\"focus\":{\"type\":\"focus\"},\"iconClick\":{\"type\":\"iconClick\"},\"input\":{\"type\":\"input\"},\"keyup\":{\"type\":\"keyup\"}},\"files\":[\"src\"],\"homepage\":\"http://pepper.infinity-commerce.io/components/forms/textarea\",\"license\":\"UNLICENSED\",\"main\":\"src/index.js\",\"name\":\"@pepper/forms-textarea\",\"publishConfig\":{\"access\":\"public\",\"registry\":\"https://npm.infinity-commerce.io/\"},\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@bitbucket.org:infinity-mobile/pepper.git\"},\"samples\":{\"default\":{\"name\":\"Default\",\"slots\":{\"default\":\"Label\"}},\"constraint\":{\"name\":\"Constraint\",\"slots\":{\"default\":\"Label\"},\"props\":{\"min\":0,\"max\":140}},\"icons\":{\"name\":\"Icons\",\"slots\":{\"default\":\"Label\"},\"props\":{\"iconPre\":\"arrow-left\",\"iconPost\":\"arrow-right\"}}},\"scripts\":{\"bundle\":\"\",\"bundle:wc\":\"vue-cli-service build --target wc --name forms-textarea ./src/textarea.vue\",\"bundle:lib\":\"vue-cli-service build --target lib --name pepper-forms-textarea ./src/index.js\"},\"slots\":{\"after\":{},\"before\":{},\"default\":{}},\"status\":\"draft\",\"version\":\"1.2.4\",\"gitHead\":\"14531a2a18d9b6dc6dc42232a03f11c3f7d5e9d2\"}");

/***/ }),

/***/ "477f":
/***/ (function(module) {

module.exports = JSON.parse("{\"author\":\"Alexandre <alexandre@infinity-mobile.io>\",\"browserslist\":[\"> 1%\",\"last 2 versions\",\"not dead\"],\"category\":\"Data\",\"description\":\"Displays as a tag with an optional link and/or button to remove the given tag.\",\"directories\":{\"src\":\"src\"},\"displayName\":\"Tag\",\"files\":[\"src\"],\"homepage\":\"http://pepper.infinity-commerce.io/components/data/tag\",\"license\":\"UNLICENSED\",\"main\":\"src/index.js\",\"name\":\"@pepper/data-tag\",\"publishConfig\":{\"access\":\"public\",\"registry\":\"https://npm.infinity-commerce.io/\"},\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@bitbucket.org:infinity-mobile/pepper.git\"},\"samples\":{\"default\":{\"name\":\"Default\",\"props\":{\"closabled\":true},\"slots\":{\"default\":\"Label\"}}},\"scripts\":{\"bundle\":\"\",\"bundle:wc\":\"vue-cli-service build --target wc --name data-tag ./src/tag.vue\",\"bundle:lib\":\"vue-cli-service build --target lib --name pepper-data-tag ./src/index.js\"},\"slots\":{\"default\":{}},\"version\":\"1.3.2\",\"gitHead\":\"14531a2a18d9b6dc6dc42232a03f11c3f7d5e9d2\"}");

/***/ }),

/***/ "5266":
/***/ (function(module) {

module.exports = JSON.parse("{\"author\":\"Alexandre <alexandre@infinity-mobile.io>\",\"browserslist\":[\"> 1%\",\"last 2 versions\",\"not dead\"],\"category\":\"Popins\",\"description\":\"Creates a dropdown menu, with optional groups, icons, and disabled items.\",\"dependencies\":{\"@pepper/popins-popin\":\"^1.3.2\",\"@pepper/transitions-fade\":\"^1.2.3\",\"@pepper/utils\":\"^1.1.2\"},\"devDependencies\":{\"@vue/cli-service\":\"^4.1.1\",\"vue\":\"^2.6.10\"},\"directories\":{\"src\":\"src\"},\"displayName\":\"Dropdown\",\"events\":{},\"files\":[\"src\"],\"homepage\":\"http://pepper.infinity-commerce.io/components/popins/dropdown\",\"license\":\"UNLICENSED\",\"main\":\"src/index.js\",\"name\":\"@pepper/popins-dropdown\",\"publishConfig\":{\"access\":\"public\",\"registry\":\"https://npm.infinity-commerce.io/\"},\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@bitbucket.org:infinity-mobile/pepper.git\"},\"samples\":{\"default\":{\"key\":\"default\",\"name\":\"Default\",\"slots\":{\"default\":\"Label\"}}},\"scripts\":{\"bundle\":\"\",\"bundle:wc\":\"vue-cli-service build --target wc --name popins-dropdown ./src/dropdown.vue\",\"bundle:lib\":\"vue-cli-service build --target lib --name pepper-popins-dropdown ./src/index.js\"},\"slots\":{},\"status\":\"draft\",\"version\":\"1.3.5\",\"gitHead\":\"66ea90c2b141a970b48185e79b0f66c49d0f2c85\"}");

/***/ }),

/***/ "5d60":
/***/ (function(module) {

module.exports = JSON.parse("{\"author\":\"Alexandre <alexandre@infinity-mobile.io>\",\"browserslist\":[\"> 1%\",\"last 2 versions\",\"not dead\"],\"category\":\"Data\",\"dependencies\":{\"@pepper/utils\":\"^1.1.2\"},\"description\":\"Indicates values. Visual indicators for numeric values such as tallies and scores. They're commonly used before and after the label of the thing they're quantifying.\",\"directories\":{\"src\":\"src\"},\"displayName\":\"Badge\",\"files\":[\"src\"],\"homepage\":\"http://pepper.infinity-commerce.io/components/data/badge\",\"license\":\"UNLICENSED\",\"main\":\"src/index.js\",\"name\":\"@pepper/data-badge\",\"publishConfig\":{\"access\":\"public\",\"registry\":\"https://npm.infinity-commerce.io/\"},\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@bitbucket.org:infinity-mobile/pepper.git\"},\"samples\":{\"default\":{\"name\":\"Default\",\"props\":{\"value\":100,\"max\":10},\"slots\":{\"default\":\"Label\"}}},\"scripts\":{\"bundle\":\"\",\"bundle:wc\":\"vue-cli-service build --target wc --name data-badge ./src/badge.vue\",\"bundle:lib\":\"vue-cli-service build --target lib --name pepper-data-badge ./src/index.js\"},\"slots\":{\"default\":{}},\"version\":\"1.2.3\"}");

/***/ }),

/***/ "68aa":
/***/ (function(module) {

module.exports = JSON.parse("{\"author\":\"Alexandre <alexandre@infinity-mobile.io>\",\"browserslist\":[\"> 1%\",\"last 2 versions\",\"not dead\"],\"category\":\"Forms\",\"dependencies\":{\"@pepper/directives-autofocus\":\"^1.1.2\",\"@pepper/forms-label\":\"^1.3.3\",\"@pepper/utils\":\"^1.1.2\"},\"description\":\"A checkbox element primarily for use in forms.\",\"directories\":{\"src\":\"src\"},\"displayName\":\"Checkbox\",\"events\":{\"blur\":{\"type\":\"blur\"},\"change\":{\"type\":\"change\"},\"focus\":{\"type\":\"focus\"}},\"files\":[\"src\"],\"homepage\":\"http://pepper.infinity-commerce.io/components/forms/checkbox\",\"license\":\"UNLICENSED\",\"main\":\"src/index.js\",\"name\":\"@pepper/forms-checkbox\",\"publishConfig\":{\"access\":\"public\",\"registry\":\"https://npm.infinity-commerce.io/\"},\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@bitbucket.org:infinity-mobile/pepper.git\"},\"samples\":{\"default\":{\"key\":\"default\",\"name\":\"Default\",\"props\":{\"size\":\"m\"},\"slots\":{\"default\":\"Label\"}}},\"scripts\":{\"bundle\":\"\",\"bundle:wc\":\"vue-cli-service build --target wc --name forms-checkbox ./src/checkbox.vue\",\"bundle:lib\":\"vue-cli-service build --target lib --name pepper-forms-checkbox ./src/index.js\"},\"slots\":{\"after\":{},\"before\":{},\"default\":{}},\"status\":\"draft\",\"version\":\"1.6.5\",\"gitHead\":\"14531a2a18d9b6dc6dc42232a03f11c3f7d5e9d2\"}");

/***/ }),

/***/ "7431":
/***/ (function(module) {

module.exports = JSON.parse("{\"author\":\"Alexandre <alexandre@infinity-mobile.io>\",\"browserslist\":[\"> 1%\",\"last 2 versions\",\"not dead\"],\"category\":\"Data\",\"description\":\"Pagination is helpful when you do not want to bloat your page by showing all the data at once. In this case we expect user to navigate through different pages of the component.\",\"dependencies\":{\"@pepper/actions-button\":\"^1.4.5\",\"@pepper/forms-select\":\"^1.5.9\",\"@pepper/utils\":\"^1.1.2\"},\"directories\":{\"src\":\"src\"},\"displayName\":\"Pagination\",\"files\":[\"src\"],\"homepage\":\"http://pepper.infinity-commerce.io/components/data/pagination\",\"license\":\"UNLICENSED\",\"main\":\"src/index.js\",\"name\":\"@pepper/data-pagination\",\"publishConfig\":{\"access\":\"public\",\"registry\":\"https://npm.infinity-commerce.io/\"},\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@bitbucket.org:infinity-mobile/pepper.git\"},\"samples\":{\"default\":{\"name\":\"Default\",\"props\":{\"currentIndex\":1,\"currentPage\":1,\"total\":500,\"pageSize\":20}}},\"scripts\":{\"bundle\":\"\",\"bundle:wc\":\"vue-cli-service build --target wc --name data-pagination ./src/pagination.vue\",\"bundle:lib\":\"vue-cli-service build --target lib --name pepper-data-pagination ./src/index.js\"},\"slots\":{\"default\":{}},\"version\":\"1.3.12\",\"gitHead\":\"837ba81c27d2379bdf07d4ba95dcf0dd35db1333\"}");

/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8bbf__;

/***/ }),

/***/ "8da5":
/***/ (function(module) {

module.exports = JSON.parse("{\"author\":\"Alexandre <alexandre@infinity-mobile.io>\",\"browserslist\":[\"> 1%\",\"last 2 versions\",\"not dead\"],\"category\":\"Directives\",\"description\":\"Vue directive to react on clicks outside an element without stopping the event propagation\",\"directories\":{\"src\":\"src\"},\"displayName\":\"ClickOutside\",\"files\":[\"src\"],\"homepage\":\"http://pepper.infinity-commerce.io/directives/clickoutside\",\"license\":\"UNLICENSED\",\"main\":\"src/index.js\",\"name\":\"@pepper/directives-clickoutside\",\"publishConfig\":{\"access\":\"public\",\"registry\":\"https://npm.infinity-commerce.io/\"},\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@bitbucket.org:infinity-mobile/pepper.git\"},\"scripts\":{\"bundle\":\"\",\"bundle:lib\":\"vue-cli-service build --target lib --name pepper-directives-clickoutside ./src/index.js\"},\"version\":\"1.1.6\",\"gitHead\":\"837ba81c27d2379bdf07d4ba95dcf0dd35db1333\"}");

/***/ }),

/***/ "8f54":
/***/ (function(module) {

module.exports = JSON.parse("{\"author\":\"Alexandre <alexandre@infinity-mobile.io>\",\"browserslist\":[\"> 1%\",\"last 2 versions\",\"not dead\"],\"category\":\"Charts\",\"description\":\"Each entry is stacked on top of each other to display the relationship between each other.\",\"directories\":{\"src\":\"src\"},\"displayName\":\"Stack\",\"files\":[\"src\"],\"homepage\":\"http://pepper.infinity-commerce.io/components/charts/stack\",\"license\":\"UNLICENSED\",\"main\":\"src/index.js\",\"name\":\"@pepper/charts-stack\",\"publishConfig\":{\"access\":\"public\",\"registry\":\"https://npm.infinity-commerce.io/\"},\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@bitbucket.org:infinity-mobile/pepper.git\"},\"samples\":{\"default\":{\"name\":\"Default\",\"props\":{\"total\":30,\"value\":[{\"label\":\"abc\",\"value\":10},{\"label\":\"def\",\"value\":20}]},\"slots\":{\"default\":\"Label\"}}},\"scripts\":{\"bundle\":\"\",\"bundle:wc\":\"vue-cli-service build --target wc --name charts-stack ./src/tag.vue\",\"bundle:lib\":\"vue-cli-service build --target lib --name pepper-charts-stack ./src/index.js\"},\"slots\":{\"default\":{}},\"version\":\"1.1.5\"}");

/***/ }),

/***/ "974a":
/***/ (function(module) {

module.exports = JSON.parse("{\"author\":\"Alexandre <alexandre@infinity-mobile.io>\",\"browserslist\":[\"> 1%\",\"last 2 versions\",\"not dead\"],\"category\":\"Actions\",\"dependencies\":{\"@pepper/ui-icon\":\"^1.0.9\",\"@pepper/ui-loader\":\"^1.0.9\",\"@pepper/utils\":\"^1.1.2\"},\"description\":\"Buttons are used as triggers for actions. They are used in forms, toolbars, dialog footers and as stand-alone action triggers.\",\"directories\":{\"src\":\"src\"},\"displayName\":\"Button\",\"events\":{\"blur\":{\"type\":\"blur\"},\"click\":{\"type\":\"click\"},\"focus\":{\"type\":\"focus\"}},\"files\":[\"src\"],\"homepage\":\"http://pepper.infinity-commerce.io/components/actions/button\",\"license\":\"UNLICENSED\",\"main\":\"src/index.js\",\"name\":\"@pepper/actions-button\",\"publishConfig\":{\"access\":\"public\",\"registry\":\"https://npm.infinity-commerce.io/\"},\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@bitbucket.org:infinity-mobile/pepper.git\"},\"samples\":{\"label\":{\"name\":\"Label\",\"props\":{\"href\":\"http://infinity-mobile.io\"},\"slots\":{\"default\":\"Label <strong>only</strong>\"}},\"labelIcon\":{\"name\":\"Label & Icon After\",\"props\":{\"iconPre\":\"arrow-left\"},\"slots\":{\"default\":\"Label\"}}},\"scripts\":{\"bundle\":\"\",\"bundle:wc\":\"vue-cli-service build --target wc --name actions-button ./src/button.vue\",\"bundle:lib\":\"vue-cli-service build --target lib --name pepper-actions-button ./src/index.js\"},\"slots\":{\"default\":{},\"loader\":{}},\"version\":\"1.4.5\",\"gitHead\":\"14531a2a18d9b6dc6dc42232a03f11c3f7d5e9d2\"}");

/***/ }),

/***/ "a074":
/***/ (function(module) {

module.exports = JSON.parse("{\"author\":\"Alexandre <alexandre@infinity-mobile.io>\",\"browserslist\":[\"> 1%\",\"last 2 versions\",\"not dead\"],\"category\":\"Directives\",\"description\":\"Gives automatically the focus the the applied element on page load\",\"directories\":{\"src\":\"src\"},\"displayName\":\"Autofocus\",\"files\":[\"src\"],\"homepage\":\"http://pepper.infinity-commerce.io/directives/autofocus\",\"license\":\"UNLICENSED\",\"main\":\"src/index.js\",\"name\":\"@pepper/directives-autofocus\",\"publishConfig\":{\"access\":\"public\",\"registry\":\"https://npm.infinity-commerce.io/\"},\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@bitbucket.org:infinity-mobile/pepper.git\"},\"scripts\":{\"bundle\":\"\",\"bundle:lib\":\"vue-cli-service build --target lib --name pepper-directives-autofocus ./src/index.js\"},\"version\":\"1.1.2\",\"gitHead\":\"14531a2a18d9b6dc6dc42232a03f11c3f7d5e9d2\"}");

/***/ }),

/***/ "a18e":
/***/ (function(module) {

module.exports = JSON.parse("{\"author\":\"Alexandre <alexandre@infinity-mobile.io>\",\"browserslist\":[\"> 1%\",\"last 2 versions\",\"not dead\"],\"category\":\"Forms\",\"description\":\"Edition and visualization of iterative data structure\",\"dependencies\":{\"@pepper/actions-button\":\"^1.4.5\",\"@pepper/forms-autocomplete\":\"^1.7.11\",\"@pepper/forms-checkbox\":\"^1.6.5\",\"@pepper/forms-input\":\"^1.7.7\",\"@pepper/forms-select\":\"^1.5.9\",\"@pepper/utils\":\"^1.1.2\"},\"directories\":{\"src\":\"src\"},\"displayName\":\"Iterable\",\"files\":[\"src\"],\"homepage\":\"http://pepper.infinity-commerce.io/components/forms/iterable\",\"license\":\"UNLICENSED\",\"main\":\"src/index.js\",\"name\":\"@pepper/forms-iterable\",\"publishConfig\":{\"access\":\"public\",\"registry\":\"https://npm.infinity-commerce.io/\"},\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@bitbucket.org:infinity-mobile/pepper.git\"},\"samples\":{\"default\":{\"name\":\"Default\",\"slots\":{\"default\":\"Label\"},\"props\":{\"options\":[{\"type\":\"String\",\"property\":\"item1\",\"label\":\"Item1\"},{\"type\":\"String\",\"property\":\"item2\",\"label\":\"Item2\"}]}}},\"scripts\":{\"bundle\":\"\",\"bundle:wc\":\"vue-cli-service build --target wc --name forms-iterable ./src/iterable.vue\",\"bundle:lib\":\"vue-cli-service build --target lib --name pepper-forms-iterable ./src/index.js\"},\"slots\":{\"after\":{},\"before\":{},\"default\":{}},\"version\":\"1.2.16\",\"gitHead\":\"837ba81c27d2379bdf07d4ba95dcf0dd35db1333\"}");

/***/ }),

/***/ "b2a5":
/***/ (function(module) {

module.exports = JSON.parse("{\"author\":\"Alexandre <alexandre@infinity-mobile.io>\",\"browserslist\":[\"> 1%\",\"last 2 versions\",\"not dead\"],\"category\":\"Forms\",\"dependencies\":{\"@pepper/directives-autofocus\":\"^1.1.2\",\"@pepper/directives-clickoutside\":\"^1.1.6\",\"@pepper/forms-control\":\"^1.1.4\",\"@pepper/forms-label\":\"^1.3.3\",\"@pepper/ui-icon\":\"^1.0.9\",\"@pepper/ui-loader\":\"^1.0.9\"},\"description\":\"Allows selection of an item or items from a dropdown list. Substitute for the native select element.\",\"directories\":{\"src\":\"src\"},\"displayName\":\"Select\",\"events\":{\"blur\":{\"type\":\"blur\"},\"change\":{\"type\":\"change\"},\"focus\":{\"type\":\"focus\"}},\"files\":[\"src\"],\"homepage\":\"http://pepper.infinity-commerce.io/components/forms/select\",\"license\":\"UNLICENSED\",\"main\":\"src/index.js\",\"name\":\"@pepper/forms-select\",\"publishConfig\":{\"access\":\"public\",\"registry\":\"https://npm.infinity-commerce.io/\"},\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@bitbucket.org:infinity-mobile/pepper.git\"},\"samples\":{\"default\":{\"name\":\"Default\",\"props\":{\"options\":[{\"label\":\"Item 1\",\"value\":1},{\"label\":\"Item 2\",\"value\":2},{\"label\":\"Item 3\",\"value\":3}],\"placeholder\":\"Select a value\"},\"slots\":{\"default\":{\"value\":\"Label\"}}}},\"scripts\":{\"bundle\":\"\",\"bundle:wc\":\"vue-cli-service build --target wc --name forms-select ./src/select.vue\",\"bundle:lib\":\"vue-cli-service build --target lib --name pepper-forms-select ./src/index.js\"},\"slots\":{\"after\":{},\"before\":{},\"default\":{}},\"status\":\"draft\",\"version\":\"1.5.9\",\"gitHead\":\"837ba81c27d2379bdf07d4ba95dcf0dd35db1333\"}");

/***/ }),

/***/ "c3a3":
/***/ (function(module) {

module.exports = JSON.parse("{\"author\":\"Alexandre <alexandre@infinity-mobile.io>\",\"browserslist\":[\"> 1%\",\"last 2 versions\",\"not dead\"],\"category\":\"Forms\",\"dependencies\":{\"@pepper/directives-autofocus\":\"^1.1.2\",\"@pepper/forms-label\":\"^1.3.3\",\"@pepper/ui-icon\":\"^1.0.9\",\"@pepper/ui-loader\":\"^1.0.9\",\"@pepper/utils\":\"^1.1.2\"},\"description\":\"Base layout for all the forms controls\",\"directories\":{\"src\":\"src\"},\"displayName\":\"Control\",\"events\":{\"blur\":{\"type\":\"blur\"},\"clear\":{\"type\":\"clear\"},\"focus\":{\"type\":\"focus\"},\"iconClick\":{\"type\":\"iconClick\"},\"input\":{\"type\":\"input\"},\"keyup\":{\"type\":\"keyup\"}},\"files\":[\"src\"],\"homepage\":\"http://pepper.infinity-commerce.io/components/forms/control\",\"license\":\"UNLICENSED\",\"main\":\"src/index.js\",\"name\":\"@pepper/forms-control\",\"publishConfig\":{\"access\":\"public\",\"registry\":\"https://npm.infinity-commerce.io/\"},\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@bitbucket.org:infinity-mobile/pepper.git\"},\"samples\":{\"default\":{\"name\":\"Default\",\"props\":{\"iconPre\":\"arrow-left\"},\"slots\":{\"default\":\"Label\"}}},\"scripts\":{\"bundle\":\"\",\"bundle:wc\":\"vue-cli-service build --target wc --name forms-control ./src/control.vue\",\"bundle:lib\":\"vue-cli-service build --target lib --name pepper-forms-control ./src/index.js\"},\"slots\":{\"after\":{},\"before\":{},\"default\":{}},\"version\":\"1.1.4\"}");

/***/ }),

/***/ "c3a32":
/***/ (function(module) {

module.exports = JSON.parse("{\"author\":\"Alexandre <alexandre@infinity-mobile.io>\",\"browserslist\":[\"> 1%\",\"last 2 versions\",\"not dead\"],\"category\":\"Forms\",\"description\":\"Provide a listing representation on a simple collection of data. Useful to display a list of data that don't have too many columns.\",\"directories\":{\"src\":\"src\"},\"displayName\":\"List\",\"files\":[\"src\"],\"homepage\":\"http://pepper.infinity-commerce.io/components/data/tag\",\"license\":\"UNLICENSED\",\"main\":\"src/index.js\",\"name\":\"@pepper/forms-list\",\"publishConfig\":{\"access\":\"public\",\"registry\":\"https://npm.infinity-commerce.io/\"},\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@bitbucket.org:infinity-mobile/pepper.git\"},\"samples\":{\"default\":{\"name\":\"Default\",\"props\":{\"value\":[{\"label\":\"Item 1\"},{\"label\":\"Item 2\"},{\"label\":\"Item 3\"},{\"label\":\"Item 4\"},{\"label\":\"Item 5\"}]},\"slots\":{}}},\"scripts\":{\"bundle\":\"\",\"bundle:wc\":\"vue-cli-service build --target wc --name forms-list ./src/list.vue\",\"bundle:lib\":\"vue-cli-service build --target lib --name pepper-forms-list ./src/index.js\"},\"slots\":{\"default\":{}},\"version\":\"1.0.3\",\"dependencies\":{\"sortablejs\":\"^1.10.2\"}}");

/***/ }),

/***/ "cfcf":
/***/ (function(module) {

module.exports = JSON.parse("{\"author\":\"Alexandre <alexandre@infinity-mobile.io>\",\"browserslist\":[\"> 1%\",\"last 2 versions\",\"not dead\"],\"category\":\"Data\",\"dependencies\":{\"@pepper/actions-button\":\"^1.4.5\",\"@pepper/forms-select\":\"^1.5.9\",\"@pepper/utils\":\"^1.1.2\"},\"description\":\"It allows the user to filter data on a dataset based on criteria.\",\"directories\":{\"src\":\"src\"},\"displayName\":\"Filter\",\"events\":{\"click\":{\"type\":\"click\"}},\"files\":[\"src\"],\"homepage\":\"http://pepper.infinity-commerce.io/components/data/filter\",\"license\":\"UNLICENSED\",\"main\":\"src/index.js\",\"name\":\"@pepper/data-filter\",\"publishConfig\":{\"access\":\"public\",\"registry\":\"https://npm.infinity-commerce.io/\"},\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@bitbucket.org:infinity-mobile/pepper.git\"},\"samples\":{},\"scripts\":{\"bundle\":\"\",\"bundle:wc\":\"vue-cli-service build --target wc --name data-filter ./src/filter.vue\",\"bundle:lib\":\"vue-cli-service build --target lib --name pepper-data-filter ./src/index.js\"},\"slots\":{\"default\":{}},\"version\":\"1.2.11\",\"gitHead\":\"837ba81c27d2379bdf07d4ba95dcf0dd35db1333\"}");

/***/ }),

/***/ "df54":
/***/ (function(module) {

module.exports = JSON.parse("{\"author\":\"Alexandre <alexandre@infinity-mobile.io>\",\"browserslist\":[\"> 1%\",\"last 2 versions\",\"not dead\"],\"category\":\"Forms\",\"dependencies\":{\"@pepper/directives-autofocus\":\"^1.1.2\",\"@pepper/forms-label\":\"^1.3.3\",\"@pepper/utils\":\"^1.1.2\"},\"description\":\"Allow a user to choose only one of a predefined set of mutually exclusive options.\",\"directories\":{\"src\":\"src\"},\"displayName\":\"Radio\",\"events\":{\"blur\":{\"type\":\"blur\"},\"change\":{\"type\":\"change\"},\"focus\":{\"type\":\"focus\"}},\"files\":[\"src\"],\"homepage\":\"http://pepper.infinity-commerce.io/components/forms/radio\",\"license\":\"UNLICENSED\",\"main\":\"src/index.js\",\"name\":\"@pepper/forms-radio\",\"publishConfig\":{\"access\":\"public\",\"registry\":\"https://npm.infinity-commerce.io/\"},\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@bitbucket.org:infinity-mobile/pepper.git\"},\"samples\":{\"default\":{\"name\":\"Default\",\"slots\":{\"default\":\"Label\"},\"props\":{\"size\":\"m\"}}},\"scripts\":{\"bundle\":\"\",\"bundle:wc\":\"vue-cli-service build --target wc --name forms-radio ./src/radio.vue\",\"bundle:lib\":\"vue-cli-service build --target lib --name pepper-forms-radio ./src/index.js\"},\"slots\":{\"after\":{},\"before\":{},\"default\":{}},\"status\":\"draft\",\"version\":\"1.4.4\",\"gitHead\":\"14531a2a18d9b6dc6dc42232a03f11c3f7d5e9d2\"}");

/***/ }),

/***/ "e687":
/***/ (function(module) {

module.exports = JSON.parse("{\"a\":\"1.11.23\"}");

/***/ }),

/***/ "f4eb":
/***/ (function(module) {

module.exports = JSON.parse("{\"author\":\"Alexandre <alexandre@infinity-mobile.io>\",\"browserslist\":[\"> 1%\",\"last 2 versions\",\"not dead\"],\"category\":\"Data\",\"dependencies\":{\"@pepper/actions-button\":\"^1.4.5\"},\"description\":\"A component used for presenting various empty states (no items, empty search, welcome screen, …)\",\"directories\":{\"src\":\"src\"},\"displayName\":\"Empty\",\"events\":{\"click\":{\"type\":\"click\"}},\"files\":[\"src\"],\"homepage\":\"http://pepper.infinity-commerce.io/components/data/empty\",\"license\":\"UNLICENSED\",\"main\":\"src/index.js\",\"name\":\"@pepper/data-empty\",\"publishConfig\":{\"access\":\"public\",\"registry\":\"https://npm.infinity-commerce.io/\"},\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@bitbucket.org:infinity-mobile/pepper.git\"},\"samples\":{\"default\":{\"name\":\"Default\",\"props\":{\"primaryAction\":\"Primary Action\",\"secondaryAction\":\"Secondary Action\",\"tertiaryAction\":\"Ternary Action\"},\"slots\":{\"default\":\"No content here\"}}},\"scripts\":{\"bundle\":\"\",\"bundle:wc\":\"vue-cli-service build --target wc --name data-empty ./src/empty.vue\",\"bundle:lib\":\"vue-cli-service build --target lib --name pepper-data-empty ./src/index.js\"},\"slots\":{\"default\":{}},\"version\":\"1.2.5\",\"gitHead\":\"14531a2a18d9b6dc6dc42232a03f11c3f7d5e9d2\"}");

/***/ }),

/***/ "f8c4":
/***/ (function(module) {

module.exports = JSON.parse("{\"author\":\"Alexandre <alexandre@infinity-mobile.io>\",\"browserslist\":[\"> 1%\",\"last 2 versions\",\"not dead\"],\"category\":\"Ui\",\"description\":\"Used for showing a system process of unknown length going on that ends with the system displaying results to the user.\",\"devDependencies\":{\"@vue/cli-service\":\"^4.1.1\",\"vue\":\"^2.6.10\"},\"directories\":{\"src\":\"src\"},\"displayName\":\"Loader\",\"events\":{},\"files\":[\"src\"],\"homepage\":\"http://pepper.infinity-commerce.io/components/ui/loader\",\"license\":\"UNPUBLISHED\",\"main\":\"src/index.js\",\"name\":\"@pepper/ui-loader\",\"publishConfig\":{\"access\":\"public\",\"registry\":\"https://npm.infinity-commerce.io/\"},\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@bitbucket.org:infinity-mobile/pepper.git\"},\"samples\":{\"default\":{\"name\":\"Default\",\"props\":{},\"slots\":{}}},\"scripts\":{\"bundle\":\"\",\"bundle:wc\":\"vue-cli-service build --target wc --name ui-loader ./src/loader.vue\",\"bundle:lib\":\"vue-cli-service build --target lib --name pepper-ui-loader ./src/index.js\"},\"slots\":{},\"version\":\"1.0.9\",\"gitHead\":\"14531a2a18d9b6dc6dc42232a03f11c3f7d5e9d2\"}");

/***/ }),

/***/ "fdcd":
/***/ (function(module) {

module.exports = JSON.parse("{\"author\":\"Alexandre <alexandre@infinity-mobile.io>\",\"browserslist\":[\"> 1%\",\"last 2 versions\",\"not dead\"],\"category\":\"Forms\",\"dependencies\":{\"@pepper/directives-autofocus\":\"^1.1.2\",\"@pepper/forms-control\":\"^1.1.4\",\"@pepper/forms-label\":\"^1.3.3\",\"@pepper/ui-icon\":\"^1.0.9\",\"@pepper/ui-loader\":\"^1.0.9\",\"@pepper/utils\":\"^1.1.2\"},\"description\":\"Is a wrapped <input> component. Used to create interactive controls for web-based forms in order to accept data from the user.\",\"directories\":{\"src\":\"src\"},\"displayName\":\"Input\",\"events\":{\"blur\":{\"type\":\"blur\"},\"clear\":{\"type\":\"clear\"},\"focus\":{\"type\":\"focus\"},\"iconClick\":{\"type\":\"iconClick\"},\"input\":{\"type\":\"input\"},\"keyup\":{\"type\":\"keyup\"}},\"files\":[\"src\"],\"homepage\":\"http://pepper.infinity-commerce.io/components/forms/input\",\"license\":\"UNLICENSED\",\"main\":\"src/index.js\",\"name\":\"@pepper/forms-input\",\"publishConfig\":{\"access\":\"public\",\"registry\":\"https://npm.infinity-commerce.io/\"},\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@bitbucket.org:infinity-mobile/pepper.git\"},\"samples\":{\"default\":{\"name\":\"Default\",\"props\":{\"iconPre\":\"arrow-left\"},\"slots\":{\"default\":\"Label\"}}},\"scripts\":{\"bundle\":\"\",\"bundle:wc\":\"vue-cli-service build --target wc --name forms-input ./src/input.vue\",\"bundle:lib\":\"vue-cli-service build --target lib --name pepper-forms-input ./src/index.js\"},\"slots\":{\"after\":{},\"before\":{},\"default\":{}},\"status\":\"draft\",\"version\":\"1.7.7\",\"gitHead\":\"14531a2a18d9b6dc6dc42232a03f11c3f7d5e9d2\"}");

/***/ }),

/***/ "ff3f":
/***/ (function(module) {

module.exports = JSON.parse("{\"author\":\"Alexandre <alexandre@infinity-mobile.io>\",\"browserslist\":[\"> 1%\",\"last 2 versions\",\"not dead\"],\"category\":\"Forms\",\"dependencies\":{\"@pepper/directives-autofocus\":\"^1.1.2\",\"@pepper/forms-checkbox\":\"^1.6.5\",\"@pepper/forms-label\":\"^1.3.3\",\"@pepper/forms-radio\":\"^1.4.4\",\"@pepper/utils\":\"^1.1.2\"},\"description\":\"Provide a set of choice to the user. Either to the form a multiple answers or only one. Only use it with limited options (max 5)\",\"directories\":{\"src\":\"src\"},\"displayName\":\"Choice\",\"events\":{},\"files\":[\"src\"],\"homepage\":\"http://pepper.infinity-commerce.io/components/forms/choice\",\"license\":\"UNLICENSED\",\"main\":\"src/index.js\",\"name\":\"@pepper/forms-choice\",\"publishConfig\":{\"access\":\"public\",\"registry\":\"https://npm.infinity-commerce.io/\"},\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@bitbucket.org:infinity-mobile/pepper.git\"},\"samples\":{\"default\":{\"name\":\"Default\",\"props\":{\"options\":[{\"label\":\"a\",\"value\":\"a\"},{\"label\":\"b\",\"value\":\"b\"}]},\"slots\":{\"default\":\"Label\"}}},\"scripts\":{\"bundle\":\"\",\"bundle:wc\":\"vue-cli-service build --target wc --name forms-choice ./src/choice.vue\",\"bundle:lib\":\"vue-cli-service build --target lib --name pepper-forms-choice ./src/index.js\"},\"slots\":{\"after\":{},\"before\":{},\"default\":{}},\"version\":\"1.2.5\",\"gitHead\":\"14531a2a18d9b6dc6dc42232a03f11c3f7d5e9d2\"}");

/***/ })

/******/ });
});
//# sourceMappingURL=spices-pepper.umd.js.map